// source: trade-copier.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.tradecopier.AddConfigReply', null, global);
goog.exportSymbol('proto.tradecopier.AddConfigReq', null, global);
goog.exportSymbol('proto.tradecopier.AddCopierTemplateReply', null, global);
goog.exportSymbol('proto.tradecopier.AddCopierTemplateReq', null, global);
goog.exportSymbol('proto.tradecopier.AddSlaveReply', null, global);
goog.exportSymbol('proto.tradecopier.AddSlavesReq', null, global);
goog.exportSymbol('proto.tradecopier.AddSymbolMappingReply', null, global);
goog.exportSymbol('proto.tradecopier.AddSymbolMappingReq', null, global);
goog.exportSymbol('proto.tradecopier.AdminAddSymbolMappingReply', null, global);
goog.exportSymbol('proto.tradecopier.AdminAddSymbolMappingReq', null, global);
goog.exportSymbol('proto.tradecopier.AdminDeleteSymbolMappingReply', null, global);
goog.exportSymbol('proto.tradecopier.AdminDeleteSymbolMappingReq', null, global);
goog.exportSymbol('proto.tradecopier.AdminEditSymbolMappingReply', null, global);
goog.exportSymbol('proto.tradecopier.AdminEditSymbolMappingReq', null, global);
goog.exportSymbol('proto.tradecopier.AdminGetUserConfigsReply', null, global);
goog.exportSymbol('proto.tradecopier.AdminGetUserConfigsReq', null, global);
goog.exportSymbol('proto.tradecopier.AdminListSymbolMappingsReply', null, global);
goog.exportSymbol('proto.tradecopier.AdminListSymbolMappingsReq', null, global);
goog.exportSymbol('proto.tradecopier.AdminUpdateConfigReply', null, global);
goog.exportSymbol('proto.tradecopier.AdminUpdateConfigReq', null, global);
goog.exportSymbol('proto.tradecopier.AdminUpdateSlaveReply', null, global);
goog.exportSymbol('proto.tradecopier.AdminUpdateSlaveReq', null, global);
goog.exportSymbol('proto.tradecopier.AssociatedMasterSymbolReply', null, global);
goog.exportSymbol('proto.tradecopier.AssociatedMasterSymbolReq', null, global);
goog.exportSymbol('proto.tradecopier.Config', null, global);
goog.exportSymbol('proto.tradecopier.CopierTemplate', null, global);
goog.exportSymbol('proto.tradecopier.CopyExistingTradeReply', null, global);
goog.exportSymbol('proto.tradecopier.CopyExistingTradeReq', null, global);
goog.exportSymbol('proto.tradecopier.DayOfWeek', null, global);
goog.exportSymbol('proto.tradecopier.DeleteConfigReply', null, global);
goog.exportSymbol('proto.tradecopier.DeleteConfigReq', null, global);
goog.exportSymbol('proto.tradecopier.DeleteCopierTemplateReply', null, global);
goog.exportSymbol('proto.tradecopier.DeleteCopierTemplateReq', null, global);
goog.exportSymbol('proto.tradecopier.DeleteSalvesReq', null, global);
goog.exportSymbol('proto.tradecopier.DeleteSlavesReply', null, global);
goog.exportSymbol('proto.tradecopier.DeleteSymbolMappingReply', null, global);
goog.exportSymbol('proto.tradecopier.DeleteSymbolMappingReq', null, global);
goog.exportSymbol('proto.tradecopier.DeleteSymbolSettingsReply', null, global);
goog.exportSymbol('proto.tradecopier.DeleteSymbolSettingsReq', null, global);
goog.exportSymbol('proto.tradecopier.EditSymbolMappingReply', null, global);
goog.exportSymbol('proto.tradecopier.EditSymbolMappingReq', null, global);
goog.exportSymbol('proto.tradecopier.FilterType', null, global);
goog.exportSymbol('proto.tradecopier.GetUserConfigsReply', null, global);
goog.exportSymbol('proto.tradecopier.GetUserConfigsReq', null, global);
goog.exportSymbol('proto.tradecopier.IntCheckMasterConfigReply', null, global);
goog.exportSymbol('proto.tradecopier.IntCheckMasterConfigReq', null, global);
goog.exportSymbol('proto.tradecopier.IntDeleteMasterSlavesReply', null, global);
goog.exportSymbol('proto.tradecopier.IntDeleteMasterSlavesReq', null, global);
goog.exportSymbol('proto.tradecopier.IntGetLogsReply', null, global);
goog.exportSymbol('proto.tradecopier.IntGetLogsReq', null, global);
goog.exportSymbol('proto.tradecopier.IntGetMasterAndSlaveCountReply', null, global);
goog.exportSymbol('proto.tradecopier.IntGetMasterAndSlaveCountReq', null, global);
goog.exportSymbol('proto.tradecopier.IntGetUserMasterAccountsReply', null, global);
goog.exportSymbol('proto.tradecopier.IntGetUserMasterAccountsReq', null, global);
goog.exportSymbol('proto.tradecopier.IntGetUsersConfigsCountReply', null, global);
goog.exportSymbol('proto.tradecopier.IntGetUsersConfigsCountReq', null, global);
goog.exportSymbol('proto.tradecopier.IntListSymbolMappingReply', null, global);
goog.exportSymbol('proto.tradecopier.IntListSymbolMappingReq', null, global);
goog.exportSymbol('proto.tradecopier.IntMapSymbolInBulkReply', null, global);
goog.exportSymbol('proto.tradecopier.IntMapSymbolInBulkReq', null, global);
goog.exportSymbol('proto.tradecopier.IntSlaveAccountIDsReply', null, global);
goog.exportSymbol('proto.tradecopier.IntSlaveAccountIDsReq', null, global);
goog.exportSymbol('proto.tradecopier.ListCopierTemplateReply', null, global);
goog.exportSymbol('proto.tradecopier.ListCopierTemplateReq', null, global);
goog.exportSymbol('proto.tradecopier.ListSymbolMappingsReply', null, global);
goog.exportSymbol('proto.tradecopier.ListSymbolMappingsReq', null, global);
goog.exportSymbol('proto.tradecopier.ListSymbolSettingsReply', null, global);
goog.exportSymbol('proto.tradecopier.ListSymbolSettingsReq', null, global);
goog.exportSymbol('proto.tradecopier.Log', null, global);
goog.exportSymbol('proto.tradecopier.Mapping', null, global);
goog.exportSymbol('proto.tradecopier.MappingReq', null, global);
goog.exportSymbol('proto.tradecopier.Master', null, global);
goog.exportSymbol('proto.tradecopier.MasterMeta', null, global);
goog.exportSymbol('proto.tradecopier.MasterOrderInfo', null, global);
goog.exportSymbol('proto.tradecopier.MasterTicket', null, global);
goog.exportSymbol('proto.tradecopier.PauseAccountReply', null, global);
goog.exportSymbol('proto.tradecopier.PauseAccountReq', null, global);
goog.exportSymbol('proto.tradecopier.PauseAccountSymbolReply', null, global);
goog.exportSymbol('proto.tradecopier.PauseAccountSymbolReq', null, global);
goog.exportSymbol('proto.tradecopier.RISK_TYPE', null, global);
goog.exportSymbol('proto.tradecopier.SimulateTradeReply', null, global);
goog.exportSymbol('proto.tradecopier.SimulateTradeReq', null, global);
goog.exportSymbol('proto.tradecopier.Slave', null, global);
goog.exportSymbol('proto.tradecopier.SlaveOrder', null, global);
goog.exportSymbol('proto.tradecopier.SymbolSettings', null, global);
goog.exportSymbol('proto.tradecopier.TpSlConfig', null, global);
goog.exportSymbol('proto.tradecopier.TradingHour', null, global);
goog.exportSymbol('proto.tradecopier.UpdateConfigReply', null, global);
goog.exportSymbol('proto.tradecopier.UpdateConfigReq', null, global);
goog.exportSymbol('proto.tradecopier.UpdateCopierTemplateReply', null, global);
goog.exportSymbol('proto.tradecopier.UpdateCopierTemplateReq', null, global);
goog.exportSymbol('proto.tradecopier.UpdateSlaveManyReply', null, global);
goog.exportSymbol('proto.tradecopier.UpdateSlaveManyReq', null, global);
goog.exportSymbol('proto.tradecopier.UpdateSlaveReply', null, global);
goog.exportSymbol('proto.tradecopier.UpdateSlaveReq', null, global);
goog.exportSymbol('proto.tradecopier.UpdateSymbolSettingsReply', null, global);
goog.exportSymbol('proto.tradecopier.UpdateSymbolSettingsReq', null, global);
goog.exportSymbol('proto.tradecopier.UpdatedSlaveConfig', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.IntCheckMasterConfigReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.IntCheckMasterConfigReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.IntCheckMasterConfigReq.displayName = 'proto.tradecopier.IntCheckMasterConfigReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.IntCheckMasterConfigReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.IntCheckMasterConfigReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.IntCheckMasterConfigReply.displayName = 'proto.tradecopier.IntCheckMasterConfigReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.PauseAccountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.PauseAccountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.PauseAccountReq.displayName = 'proto.tradecopier.PauseAccountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.PauseAccountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.PauseAccountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.PauseAccountReply.displayName = 'proto.tradecopier.PauseAccountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AdminUpdateConfigReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.AdminUpdateConfigReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AdminUpdateConfigReq.displayName = 'proto.tradecopier.AdminUpdateConfigReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AdminUpdateConfigReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.AdminUpdateConfigReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AdminUpdateConfigReply.displayName = 'proto.tradecopier.AdminUpdateConfigReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AdminUpdateSlaveReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.AdminUpdateSlaveReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AdminUpdateSlaveReq.displayName = 'proto.tradecopier.AdminUpdateSlaveReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AdminUpdateSlaveReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.AdminUpdateSlaveReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AdminUpdateSlaveReply.displayName = 'proto.tradecopier.AdminUpdateSlaveReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AdminGetUserConfigsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.AdminGetUserConfigsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AdminGetUserConfigsReq.displayName = 'proto.tradecopier.AdminGetUserConfigsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AdminGetUserConfigsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.AdminGetUserConfigsReply.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.AdminGetUserConfigsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AdminGetUserConfigsReply.displayName = 'proto.tradecopier.AdminGetUserConfigsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AdminListSymbolMappingsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.AdminListSymbolMappingsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AdminListSymbolMappingsReq.displayName = 'proto.tradecopier.AdminListSymbolMappingsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AdminListSymbolMappingsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.AdminListSymbolMappingsReply.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.AdminListSymbolMappingsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AdminListSymbolMappingsReply.displayName = 'proto.tradecopier.AdminListSymbolMappingsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AdminAddSymbolMappingReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.AdminAddSymbolMappingReq.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.AdminAddSymbolMappingReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AdminAddSymbolMappingReq.displayName = 'proto.tradecopier.AdminAddSymbolMappingReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AdminAddSymbolMappingReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.AdminAddSymbolMappingReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AdminAddSymbolMappingReply.displayName = 'proto.tradecopier.AdminAddSymbolMappingReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AdminDeleteSymbolMappingReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.AdminDeleteSymbolMappingReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AdminDeleteSymbolMappingReq.displayName = 'proto.tradecopier.AdminDeleteSymbolMappingReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AdminDeleteSymbolMappingReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.AdminDeleteSymbolMappingReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AdminDeleteSymbolMappingReply.displayName = 'proto.tradecopier.AdminDeleteSymbolMappingReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.IntGetMasterAndSlaveCountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.IntGetMasterAndSlaveCountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.IntGetMasterAndSlaveCountReq.displayName = 'proto.tradecopier.IntGetMasterAndSlaveCountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.IntGetMasterAndSlaveCountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.IntGetMasterAndSlaveCountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.IntGetMasterAndSlaveCountReply.displayName = 'proto.tradecopier.IntGetMasterAndSlaveCountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.IntGetUsersConfigsCountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.IntGetUsersConfigsCountReq.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.IntGetUsersConfigsCountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.IntGetUsersConfigsCountReq.displayName = 'proto.tradecopier.IntGetUsersConfigsCountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.IntGetUsersConfigsCountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.IntGetUsersConfigsCountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.IntGetUsersConfigsCountReply.displayName = 'proto.tradecopier.IntGetUsersConfigsCountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AddConfigReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.AddConfigReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AddConfigReq.displayName = 'proto.tradecopier.AddConfigReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AddConfigReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.AddConfigReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AddConfigReply.displayName = 'proto.tradecopier.AddConfigReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.UpdateConfigReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.UpdateConfigReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.UpdateConfigReq.displayName = 'proto.tradecopier.UpdateConfigReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.UpdateConfigReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.UpdateConfigReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.UpdateConfigReply.displayName = 'proto.tradecopier.UpdateConfigReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.DeleteConfigReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.DeleteConfigReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.DeleteConfigReq.displayName = 'proto.tradecopier.DeleteConfigReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.DeleteConfigReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.DeleteConfigReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.DeleteConfigReply.displayName = 'proto.tradecopier.DeleteConfigReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AddSlavesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.AddSlavesReq.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.AddSlavesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AddSlavesReq.displayName = 'proto.tradecopier.AddSlavesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AddSlaveReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.AddSlaveReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AddSlaveReply.displayName = 'proto.tradecopier.AddSlaveReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.DeleteSalvesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.DeleteSalvesReq.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.DeleteSalvesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.DeleteSalvesReq.displayName = 'proto.tradecopier.DeleteSalvesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.DeleteSlavesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.DeleteSlavesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.DeleteSlavesReply.displayName = 'proto.tradecopier.DeleteSlavesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.GetUserConfigsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.GetUserConfigsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.GetUserConfigsReq.displayName = 'proto.tradecopier.GetUserConfigsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.GetUserConfigsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.GetUserConfigsReply.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.GetUserConfigsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.GetUserConfigsReply.displayName = 'proto.tradecopier.GetUserConfigsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.Config = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.Config.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.Config, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.Config.displayName = 'proto.tradecopier.Config';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.Master = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.Master, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.Master.displayName = 'proto.tradecopier.Master';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.Slave = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.Slave.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.Slave, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.Slave.displayName = 'proto.tradecopier.Slave';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.MasterOrderInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.MasterOrderInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.MasterOrderInfo.displayName = 'proto.tradecopier.MasterOrderInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.SimulateTradeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.SimulateTradeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.SimulateTradeReq.displayName = 'proto.tradecopier.SimulateTradeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.SlaveOrder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.SlaveOrder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.SlaveOrder.displayName = 'proto.tradecopier.SlaveOrder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.TpSlConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.TpSlConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.TpSlConfig.displayName = 'proto.tradecopier.TpSlConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.SimulateTradeReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.SimulateTradeReply.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.SimulateTradeReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.SimulateTradeReply.displayName = 'proto.tradecopier.SimulateTradeReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.UpdateSlaveReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.UpdateSlaveReq.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.UpdateSlaveReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.UpdateSlaveReq.displayName = 'proto.tradecopier.UpdateSlaveReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.UpdateSlaveReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.UpdateSlaveReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.UpdateSlaveReply.displayName = 'proto.tradecopier.UpdateSlaveReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.ListSymbolMappingsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.ListSymbolMappingsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.ListSymbolMappingsReq.displayName = 'proto.tradecopier.ListSymbolMappingsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.ListSymbolMappingsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.ListSymbolMappingsReply.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.ListSymbolMappingsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.ListSymbolMappingsReply.displayName = 'proto.tradecopier.ListSymbolMappingsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.Mapping = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.Mapping, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.Mapping.displayName = 'proto.tradecopier.Mapping';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AddSymbolMappingReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.AddSymbolMappingReq.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.AddSymbolMappingReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AddSymbolMappingReq.displayName = 'proto.tradecopier.AddSymbolMappingReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.MappingReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.MappingReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.MappingReq.displayName = 'proto.tradecopier.MappingReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AddSymbolMappingReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.AddSymbolMappingReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AddSymbolMappingReply.displayName = 'proto.tradecopier.AddSymbolMappingReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.DeleteSymbolMappingReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.DeleteSymbolMappingReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.DeleteSymbolMappingReq.displayName = 'proto.tradecopier.DeleteSymbolMappingReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.DeleteSymbolMappingReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.DeleteSymbolMappingReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.DeleteSymbolMappingReply.displayName = 'proto.tradecopier.DeleteSymbolMappingReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.IntDeleteMasterSlavesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.IntDeleteMasterSlavesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.IntDeleteMasterSlavesReq.displayName = 'proto.tradecopier.IntDeleteMasterSlavesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.IntDeleteMasterSlavesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.IntDeleteMasterSlavesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.IntDeleteMasterSlavesReply.displayName = 'proto.tradecopier.IntDeleteMasterSlavesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.IntGetUserMasterAccountsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.IntGetUserMasterAccountsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.IntGetUserMasterAccountsReq.displayName = 'proto.tradecopier.IntGetUserMasterAccountsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.IntGetUserMasterAccountsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.IntGetUserMasterAccountsReply.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.IntGetUserMasterAccountsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.IntGetUserMasterAccountsReply.displayName = 'proto.tradecopier.IntGetUserMasterAccountsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.IntGetLogsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.IntGetLogsReq.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.IntGetLogsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.IntGetLogsReq.displayName = 'proto.tradecopier.IntGetLogsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.MasterTicket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.MasterTicket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.MasterTicket.displayName = 'proto.tradecopier.MasterTicket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.IntGetLogsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.IntGetLogsReply.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.IntGetLogsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.IntGetLogsReply.displayName = 'proto.tradecopier.IntGetLogsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.Log = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.Log, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.Log.displayName = 'proto.tradecopier.Log';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.EditSymbolMappingReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.EditSymbolMappingReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.EditSymbolMappingReq.displayName = 'proto.tradecopier.EditSymbolMappingReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.EditSymbolMappingReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.EditSymbolMappingReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.EditSymbolMappingReply.displayName = 'proto.tradecopier.EditSymbolMappingReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AdminEditSymbolMappingReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.AdminEditSymbolMappingReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AdminEditSymbolMappingReq.displayName = 'proto.tradecopier.AdminEditSymbolMappingReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AdminEditSymbolMappingReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.AdminEditSymbolMappingReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AdminEditSymbolMappingReply.displayName = 'proto.tradecopier.AdminEditSymbolMappingReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.IntListSymbolMappingReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.IntListSymbolMappingReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.IntListSymbolMappingReq.displayName = 'proto.tradecopier.IntListSymbolMappingReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.IntListSymbolMappingReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.IntListSymbolMappingReply.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.IntListSymbolMappingReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.IntListSymbolMappingReply.displayName = 'proto.tradecopier.IntListSymbolMappingReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.IntMapSymbolInBulkReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.IntMapSymbolInBulkReq.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.IntMapSymbolInBulkReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.IntMapSymbolInBulkReq.displayName = 'proto.tradecopier.IntMapSymbolInBulkReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.IntMapSymbolInBulkReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.IntMapSymbolInBulkReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.IntMapSymbolInBulkReply.displayName = 'proto.tradecopier.IntMapSymbolInBulkReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.MasterMeta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.MasterMeta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.MasterMeta.displayName = 'proto.tradecopier.MasterMeta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.UpdateSlaveManyReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.UpdateSlaveManyReq.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.UpdateSlaveManyReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.UpdateSlaveManyReq.displayName = 'proto.tradecopier.UpdateSlaveManyReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.TradingHour = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.TradingHour, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.TradingHour.displayName = 'proto.tradecopier.TradingHour';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.UpdatedSlaveConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.UpdatedSlaveConfig.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.UpdatedSlaveConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.UpdatedSlaveConfig.displayName = 'proto.tradecopier.UpdatedSlaveConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.UpdateSlaveManyReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.UpdateSlaveManyReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.UpdateSlaveManyReply.displayName = 'proto.tradecopier.UpdateSlaveManyReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.IntSlaveAccountIDsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.IntSlaveAccountIDsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.IntSlaveAccountIDsReq.displayName = 'proto.tradecopier.IntSlaveAccountIDsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.IntSlaveAccountIDsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.IntSlaveAccountIDsReply.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.IntSlaveAccountIDsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.IntSlaveAccountIDsReply.displayName = 'proto.tradecopier.IntSlaveAccountIDsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.CopyExistingTradeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.CopyExistingTradeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.CopyExistingTradeReq.displayName = 'proto.tradecopier.CopyExistingTradeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.CopyExistingTradeReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.CopyExistingTradeReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.CopyExistingTradeReply.displayName = 'proto.tradecopier.CopyExistingTradeReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.UpdateSymbolSettingsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.UpdateSymbolSettingsReq.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.UpdateSymbolSettingsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.UpdateSymbolSettingsReq.displayName = 'proto.tradecopier.UpdateSymbolSettingsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.UpdateSymbolSettingsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.UpdateSymbolSettingsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.UpdateSymbolSettingsReply.displayName = 'proto.tradecopier.UpdateSymbolSettingsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.ListSymbolSettingsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.ListSymbolSettingsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.ListSymbolSettingsReq.displayName = 'proto.tradecopier.ListSymbolSettingsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.ListSymbolSettingsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.ListSymbolSettingsReply.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.ListSymbolSettingsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.ListSymbolSettingsReply.displayName = 'proto.tradecopier.ListSymbolSettingsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.SymbolSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.SymbolSettings.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.SymbolSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.SymbolSettings.displayName = 'proto.tradecopier.SymbolSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.DeleteSymbolSettingsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.DeleteSymbolSettingsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.DeleteSymbolSettingsReq.displayName = 'proto.tradecopier.DeleteSymbolSettingsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.DeleteSymbolSettingsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.DeleteSymbolSettingsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.DeleteSymbolSettingsReply.displayName = 'proto.tradecopier.DeleteSymbolSettingsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.PauseAccountSymbolReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.PauseAccountSymbolReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.PauseAccountSymbolReq.displayName = 'proto.tradecopier.PauseAccountSymbolReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.PauseAccountSymbolReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.PauseAccountSymbolReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.PauseAccountSymbolReply.displayName = 'proto.tradecopier.PauseAccountSymbolReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AssociatedMasterSymbolReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.AssociatedMasterSymbolReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AssociatedMasterSymbolReq.displayName = 'proto.tradecopier.AssociatedMasterSymbolReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AssociatedMasterSymbolReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.AssociatedMasterSymbolReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AssociatedMasterSymbolReply.displayName = 'proto.tradecopier.AssociatedMasterSymbolReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AddCopierTemplateReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.AddCopierTemplateReq.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.AddCopierTemplateReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AddCopierTemplateReq.displayName = 'proto.tradecopier.AddCopierTemplateReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.AddCopierTemplateReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.AddCopierTemplateReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.AddCopierTemplateReply.displayName = 'proto.tradecopier.AddCopierTemplateReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.ListCopierTemplateReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.ListCopierTemplateReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.ListCopierTemplateReq.displayName = 'proto.tradecopier.ListCopierTemplateReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.ListCopierTemplateReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.ListCopierTemplateReply.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.ListCopierTemplateReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.ListCopierTemplateReply.displayName = 'proto.tradecopier.ListCopierTemplateReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.CopierTemplate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.CopierTemplate.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.CopierTemplate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.CopierTemplate.displayName = 'proto.tradecopier.CopierTemplate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.UpdateCopierTemplateReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tradecopier.UpdateCopierTemplateReq.repeatedFields_, null);
};
goog.inherits(proto.tradecopier.UpdateCopierTemplateReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.UpdateCopierTemplateReq.displayName = 'proto.tradecopier.UpdateCopierTemplateReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.UpdateCopierTemplateReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.UpdateCopierTemplateReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.UpdateCopierTemplateReply.displayName = 'proto.tradecopier.UpdateCopierTemplateReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.DeleteCopierTemplateReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.DeleteCopierTemplateReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.DeleteCopierTemplateReq.displayName = 'proto.tradecopier.DeleteCopierTemplateReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tradecopier.DeleteCopierTemplateReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tradecopier.DeleteCopierTemplateReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tradecopier.DeleteCopierTemplateReply.displayName = 'proto.tradecopier.DeleteCopierTemplateReply';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.IntCheckMasterConfigReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.IntCheckMasterConfigReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.IntCheckMasterConfigReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntCheckMasterConfigReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.IntCheckMasterConfigReq}
 */
proto.tradecopier.IntCheckMasterConfigReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.IntCheckMasterConfigReq;
  return proto.tradecopier.IntCheckMasterConfigReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.IntCheckMasterConfigReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.IntCheckMasterConfigReq}
 */
proto.tradecopier.IntCheckMasterConfigReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.IntCheckMasterConfigReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.IntCheckMasterConfigReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.IntCheckMasterConfigReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntCheckMasterConfigReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.IntCheckMasterConfigReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.IntCheckMasterConfigReq} returns this
 */
proto.tradecopier.IntCheckMasterConfigReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.tradecopier.IntCheckMasterConfigReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.IntCheckMasterConfigReq} returns this
 */
proto.tradecopier.IntCheckMasterConfigReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.IntCheckMasterConfigReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.IntCheckMasterConfigReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.IntCheckMasterConfigReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntCheckMasterConfigReply.toObject = function(includeInstance, msg) {
  var f, obj = {
found: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.IntCheckMasterConfigReply}
 */
proto.tradecopier.IntCheckMasterConfigReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.IntCheckMasterConfigReply;
  return proto.tradecopier.IntCheckMasterConfigReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.IntCheckMasterConfigReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.IntCheckMasterConfigReply}
 */
proto.tradecopier.IntCheckMasterConfigReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFound(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.IntCheckMasterConfigReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.IntCheckMasterConfigReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.IntCheckMasterConfigReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntCheckMasterConfigReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool found = 1;
 * @return {boolean}
 */
proto.tradecopier.IntCheckMasterConfigReply.prototype.getFound = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tradecopier.IntCheckMasterConfigReply} returns this
 */
proto.tradecopier.IntCheckMasterConfigReply.prototype.setFound = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.PauseAccountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.PauseAccountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.PauseAccountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.PauseAccountReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
configId: jspb.Message.getFieldWithDefault(msg, 2, ""),
slaveId: (f = msg.getSlaveId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
pauseUntil: (f = msg.getPauseUntil()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.PauseAccountReq}
 */
proto.tradecopier.PauseAccountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.PauseAccountReq;
  return proto.tradecopier.PauseAccountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.PauseAccountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.PauseAccountReq}
 */
proto.tradecopier.PauseAccountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfigId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSlaveId(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPauseUntil(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.PauseAccountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.PauseAccountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.PauseAccountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.PauseAccountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConfigId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlaveId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPauseUntil();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.PauseAccountReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.PauseAccountReq} returns this
 */
proto.tradecopier.PauseAccountReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string config_id = 2;
 * @return {string}
 */
proto.tradecopier.PauseAccountReq.prototype.getConfigId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.PauseAccountReq} returns this
 */
proto.tradecopier.PauseAccountReq.prototype.setConfigId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue slave_id = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.PauseAccountReq.prototype.getSlaveId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.PauseAccountReq} returns this
*/
proto.tradecopier.PauseAccountReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.PauseAccountReq} returns this
 */
proto.tradecopier.PauseAccountReq.prototype.clearSlaveId = function() {
  return this.setSlaveId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.PauseAccountReq.prototype.hasSlaveId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp pause_until = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.tradecopier.PauseAccountReq.prototype.getPauseUntil = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.tradecopier.PauseAccountReq} returns this
*/
proto.tradecopier.PauseAccountReq.prototype.setPauseUntil = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.PauseAccountReq} returns this
 */
proto.tradecopier.PauseAccountReq.prototype.clearPauseUntil = function() {
  return this.setPauseUntil(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.PauseAccountReq.prototype.hasPauseUntil = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.PauseAccountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.PauseAccountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.PauseAccountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.PauseAccountReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.PauseAccountReply}
 */
proto.tradecopier.PauseAccountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.PauseAccountReply;
  return proto.tradecopier.PauseAccountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.PauseAccountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.PauseAccountReply}
 */
proto.tradecopier.PauseAccountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.PauseAccountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.PauseAccountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.PauseAccountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.PauseAccountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AdminUpdateConfigReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AdminUpdateConfigReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AdminUpdateConfigReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminUpdateConfigReq.toObject = function(includeInstance, msg) {
  var f, obj = {
configId: jspb.Message.getFieldWithDefault(msg, 1, ""),
userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
enable: (f = msg.getEnable()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
manageExisting: (f = msg.getManageExisting()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AdminUpdateConfigReq}
 */
proto.tradecopier.AdminUpdateConfigReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AdminUpdateConfigReq;
  return proto.tradecopier.AdminUpdateConfigReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AdminUpdateConfigReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AdminUpdateConfigReq}
 */
proto.tradecopier.AdminUpdateConfigReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfigId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEnable(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setManageExisting(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AdminUpdateConfigReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AdminUpdateConfigReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AdminUpdateConfigReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminUpdateConfigReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEnable();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getManageExisting();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string config_id = 1;
 * @return {string}
 */
proto.tradecopier.AdminUpdateConfigReq.prototype.getConfigId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AdminUpdateConfigReq} returns this
 */
proto.tradecopier.AdminUpdateConfigReq.prototype.setConfigId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.tradecopier.AdminUpdateConfigReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AdminUpdateConfigReq} returns this
 */
proto.tradecopier.AdminUpdateConfigReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.BoolValue enable = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.AdminUpdateConfigReq.prototype.getEnable = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.AdminUpdateConfigReq} returns this
*/
proto.tradecopier.AdminUpdateConfigReq.prototype.setEnable = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AdminUpdateConfigReq} returns this
 */
proto.tradecopier.AdminUpdateConfigReq.prototype.clearEnable = function() {
  return this.setEnable(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AdminUpdateConfigReq.prototype.hasEnable = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.BoolValue manage_existing = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.AdminUpdateConfigReq.prototype.getManageExisting = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.AdminUpdateConfigReq} returns this
*/
proto.tradecopier.AdminUpdateConfigReq.prototype.setManageExisting = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AdminUpdateConfigReq} returns this
 */
proto.tradecopier.AdminUpdateConfigReq.prototype.clearManageExisting = function() {
  return this.setManageExisting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AdminUpdateConfigReq.prototype.hasManageExisting = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AdminUpdateConfigReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AdminUpdateConfigReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AdminUpdateConfigReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminUpdateConfigReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AdminUpdateConfigReply}
 */
proto.tradecopier.AdminUpdateConfigReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AdminUpdateConfigReply;
  return proto.tradecopier.AdminUpdateConfigReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AdminUpdateConfigReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AdminUpdateConfigReply}
 */
proto.tradecopier.AdminUpdateConfigReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AdminUpdateConfigReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AdminUpdateConfigReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AdminUpdateConfigReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminUpdateConfigReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AdminUpdateSlaveReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AdminUpdateSlaveReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AdminUpdateSlaveReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminUpdateSlaveReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
configId: jspb.Message.getFieldWithDefault(msg, 2, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 3, ""),
enable: (f = msg.getEnable()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
manageExisting: (f = msg.getManageExisting()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AdminUpdateSlaveReq}
 */
proto.tradecopier.AdminUpdateSlaveReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AdminUpdateSlaveReq;
  return proto.tradecopier.AdminUpdateSlaveReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AdminUpdateSlaveReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AdminUpdateSlaveReq}
 */
proto.tradecopier.AdminUpdateSlaveReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfigId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEnable(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setManageExisting(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AdminUpdateSlaveReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AdminUpdateSlaveReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AdminUpdateSlaveReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminUpdateSlaveReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConfigId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEnable();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getManageExisting();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.AdminUpdateSlaveReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AdminUpdateSlaveReq} returns this
 */
proto.tradecopier.AdminUpdateSlaveReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string config_id = 2;
 * @return {string}
 */
proto.tradecopier.AdminUpdateSlaveReq.prototype.getConfigId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AdminUpdateSlaveReq} returns this
 */
proto.tradecopier.AdminUpdateSlaveReq.prototype.setConfigId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slave_id = 3;
 * @return {string}
 */
proto.tradecopier.AdminUpdateSlaveReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AdminUpdateSlaveReq} returns this
 */
proto.tradecopier.AdminUpdateSlaveReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.BoolValue enable = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.AdminUpdateSlaveReq.prototype.getEnable = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.AdminUpdateSlaveReq} returns this
*/
proto.tradecopier.AdminUpdateSlaveReq.prototype.setEnable = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AdminUpdateSlaveReq} returns this
 */
proto.tradecopier.AdminUpdateSlaveReq.prototype.clearEnable = function() {
  return this.setEnable(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AdminUpdateSlaveReq.prototype.hasEnable = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.BoolValue manage_existing = 5;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.AdminUpdateSlaveReq.prototype.getManageExisting = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 5));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.AdminUpdateSlaveReq} returns this
*/
proto.tradecopier.AdminUpdateSlaveReq.prototype.setManageExisting = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AdminUpdateSlaveReq} returns this
 */
proto.tradecopier.AdminUpdateSlaveReq.prototype.clearManageExisting = function() {
  return this.setManageExisting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AdminUpdateSlaveReq.prototype.hasManageExisting = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AdminUpdateSlaveReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AdminUpdateSlaveReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AdminUpdateSlaveReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminUpdateSlaveReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AdminUpdateSlaveReply}
 */
proto.tradecopier.AdminUpdateSlaveReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AdminUpdateSlaveReply;
  return proto.tradecopier.AdminUpdateSlaveReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AdminUpdateSlaveReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AdminUpdateSlaveReply}
 */
proto.tradecopier.AdminUpdateSlaveReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AdminUpdateSlaveReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AdminUpdateSlaveReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AdminUpdateSlaveReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminUpdateSlaveReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AdminGetUserConfigsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AdminGetUserConfigsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AdminGetUserConfigsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminGetUserConfigsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AdminGetUserConfigsReq}
 */
proto.tradecopier.AdminGetUserConfigsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AdminGetUserConfigsReq;
  return proto.tradecopier.AdminGetUserConfigsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AdminGetUserConfigsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AdminGetUserConfigsReq}
 */
proto.tradecopier.AdminGetUserConfigsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AdminGetUserConfigsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AdminGetUserConfigsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AdminGetUserConfigsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminGetUserConfigsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.AdminGetUserConfigsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AdminGetUserConfigsReq} returns this
 */
proto.tradecopier.AdminGetUserConfigsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.AdminGetUserConfigsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AdminGetUserConfigsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AdminGetUserConfigsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AdminGetUserConfigsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminGetUserConfigsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
configsList: jspb.Message.toObjectList(msg.getConfigsList(),
    proto.tradecopier.Config.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AdminGetUserConfigsReply}
 */
proto.tradecopier.AdminGetUserConfigsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AdminGetUserConfigsReply;
  return proto.tradecopier.AdminGetUserConfigsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AdminGetUserConfigsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AdminGetUserConfigsReply}
 */
proto.tradecopier.AdminGetUserConfigsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tradecopier.Config;
      reader.readMessage(value,proto.tradecopier.Config.deserializeBinaryFromReader);
      msg.addConfigs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AdminGetUserConfigsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AdminGetUserConfigsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AdminGetUserConfigsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminGetUserConfigsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tradecopier.Config.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Config configs = 1;
 * @return {!Array<!proto.tradecopier.Config>}
 */
proto.tradecopier.AdminGetUserConfigsReply.prototype.getConfigsList = function() {
  return /** @type{!Array<!proto.tradecopier.Config>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tradecopier.Config, 1));
};


/**
 * @param {!Array<!proto.tradecopier.Config>} value
 * @return {!proto.tradecopier.AdminGetUserConfigsReply} returns this
*/
proto.tradecopier.AdminGetUserConfigsReply.prototype.setConfigsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tradecopier.Config=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.Config}
 */
proto.tradecopier.AdminGetUserConfigsReply.prototype.addConfigs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tradecopier.Config, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.AdminGetUserConfigsReply} returns this
 */
proto.tradecopier.AdminGetUserConfigsReply.prototype.clearConfigsList = function() {
  return this.setConfigsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AdminListSymbolMappingsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AdminListSymbolMappingsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AdminListSymbolMappingsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminListSymbolMappingsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AdminListSymbolMappingsReq}
 */
proto.tradecopier.AdminListSymbolMappingsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AdminListSymbolMappingsReq;
  return proto.tradecopier.AdminListSymbolMappingsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AdminListSymbolMappingsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AdminListSymbolMappingsReq}
 */
proto.tradecopier.AdminListSymbolMappingsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AdminListSymbolMappingsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AdminListSymbolMappingsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AdminListSymbolMappingsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminListSymbolMappingsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.AdminListSymbolMappingsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AdminListSymbolMappingsReq} returns this
 */
proto.tradecopier.AdminListSymbolMappingsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slave_id = 2;
 * @return {string}
 */
proto.tradecopier.AdminListSymbolMappingsReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AdminListSymbolMappingsReq} returns this
 */
proto.tradecopier.AdminListSymbolMappingsReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.AdminListSymbolMappingsReply.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AdminListSymbolMappingsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AdminListSymbolMappingsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AdminListSymbolMappingsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminListSymbolMappingsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
slaveId: jspb.Message.getFieldWithDefault(msg, 1, ""),
mappingsList: jspb.Message.toObjectList(msg.getMappingsList(),
    proto.tradecopier.Mapping.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AdminListSymbolMappingsReply}
 */
proto.tradecopier.AdminListSymbolMappingsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AdminListSymbolMappingsReply;
  return proto.tradecopier.AdminListSymbolMappingsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AdminListSymbolMappingsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AdminListSymbolMappingsReply}
 */
proto.tradecopier.AdminListSymbolMappingsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 2:
      var value = new proto.tradecopier.Mapping;
      reader.readMessage(value,proto.tradecopier.Mapping.deserializeBinaryFromReader);
      msg.addMappings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AdminListSymbolMappingsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AdminListSymbolMappingsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AdminListSymbolMappingsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminListSymbolMappingsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMappingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.tradecopier.Mapping.serializeBinaryToWriter
    );
  }
};


/**
 * optional string slave_id = 1;
 * @return {string}
 */
proto.tradecopier.AdminListSymbolMappingsReply.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AdminListSymbolMappingsReply} returns this
 */
proto.tradecopier.AdminListSymbolMappingsReply.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Mapping mappings = 2;
 * @return {!Array<!proto.tradecopier.Mapping>}
 */
proto.tradecopier.AdminListSymbolMappingsReply.prototype.getMappingsList = function() {
  return /** @type{!Array<!proto.tradecopier.Mapping>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tradecopier.Mapping, 2));
};


/**
 * @param {!Array<!proto.tradecopier.Mapping>} value
 * @return {!proto.tradecopier.AdminListSymbolMappingsReply} returns this
*/
proto.tradecopier.AdminListSymbolMappingsReply.prototype.setMappingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.tradecopier.Mapping=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.Mapping}
 */
proto.tradecopier.AdminListSymbolMappingsReply.prototype.addMappings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.tradecopier.Mapping, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.AdminListSymbolMappingsReply} returns this
 */
proto.tradecopier.AdminListSymbolMappingsReply.prototype.clearMappingsList = function() {
  return this.setMappingsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.AdminAddSymbolMappingReq.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AdminAddSymbolMappingReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AdminAddSymbolMappingReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AdminAddSymbolMappingReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminAddSymbolMappingReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 2, ""),
mappingsList: jspb.Message.toObjectList(msg.getMappingsList(),
    proto.tradecopier.MappingReq.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AdminAddSymbolMappingReq}
 */
proto.tradecopier.AdminAddSymbolMappingReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AdminAddSymbolMappingReq;
  return proto.tradecopier.AdminAddSymbolMappingReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AdminAddSymbolMappingReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AdminAddSymbolMappingReq}
 */
proto.tradecopier.AdminAddSymbolMappingReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 3:
      var value = new proto.tradecopier.MappingReq;
      reader.readMessage(value,proto.tradecopier.MappingReq.deserializeBinaryFromReader);
      msg.addMappings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AdminAddSymbolMappingReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AdminAddSymbolMappingReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AdminAddSymbolMappingReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminAddSymbolMappingReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMappingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.tradecopier.MappingReq.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.AdminAddSymbolMappingReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AdminAddSymbolMappingReq} returns this
 */
proto.tradecopier.AdminAddSymbolMappingReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slave_id = 2;
 * @return {string}
 */
proto.tradecopier.AdminAddSymbolMappingReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AdminAddSymbolMappingReq} returns this
 */
proto.tradecopier.AdminAddSymbolMappingReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated MappingReq mappings = 3;
 * @return {!Array<!proto.tradecopier.MappingReq>}
 */
proto.tradecopier.AdminAddSymbolMappingReq.prototype.getMappingsList = function() {
  return /** @type{!Array<!proto.tradecopier.MappingReq>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tradecopier.MappingReq, 3));
};


/**
 * @param {!Array<!proto.tradecopier.MappingReq>} value
 * @return {!proto.tradecopier.AdminAddSymbolMappingReq} returns this
*/
proto.tradecopier.AdminAddSymbolMappingReq.prototype.setMappingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.tradecopier.MappingReq=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.MappingReq}
 */
proto.tradecopier.AdminAddSymbolMappingReq.prototype.addMappings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.tradecopier.MappingReq, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.AdminAddSymbolMappingReq} returns this
 */
proto.tradecopier.AdminAddSymbolMappingReq.prototype.clearMappingsList = function() {
  return this.setMappingsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AdminAddSymbolMappingReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AdminAddSymbolMappingReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AdminAddSymbolMappingReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminAddSymbolMappingReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AdminAddSymbolMappingReply}
 */
proto.tradecopier.AdminAddSymbolMappingReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AdminAddSymbolMappingReply;
  return proto.tradecopier.AdminAddSymbolMappingReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AdminAddSymbolMappingReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AdminAddSymbolMappingReply}
 */
proto.tradecopier.AdminAddSymbolMappingReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AdminAddSymbolMappingReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AdminAddSymbolMappingReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AdminAddSymbolMappingReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminAddSymbolMappingReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AdminDeleteSymbolMappingReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AdminDeleteSymbolMappingReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AdminDeleteSymbolMappingReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminDeleteSymbolMappingReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 2, ""),
symbolId: jspb.Message.getFieldWithDefault(msg, 3, 0),
deleteAll: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AdminDeleteSymbolMappingReq}
 */
proto.tradecopier.AdminDeleteSymbolMappingReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AdminDeleteSymbolMappingReq;
  return proto.tradecopier.AdminDeleteSymbolMappingReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AdminDeleteSymbolMappingReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AdminDeleteSymbolMappingReq}
 */
proto.tradecopier.AdminDeleteSymbolMappingReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSymbolId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeleteAll(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AdminDeleteSymbolMappingReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AdminDeleteSymbolMappingReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AdminDeleteSymbolMappingReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminDeleteSymbolMappingReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbolId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getDeleteAll();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.AdminDeleteSymbolMappingReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AdminDeleteSymbolMappingReq} returns this
 */
proto.tradecopier.AdminDeleteSymbolMappingReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slave_id = 2;
 * @return {string}
 */
proto.tradecopier.AdminDeleteSymbolMappingReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AdminDeleteSymbolMappingReq} returns this
 */
proto.tradecopier.AdminDeleteSymbolMappingReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 symbol_id = 3;
 * @return {number}
 */
proto.tradecopier.AdminDeleteSymbolMappingReq.prototype.getSymbolId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.AdminDeleteSymbolMappingReq} returns this
 */
proto.tradecopier.AdminDeleteSymbolMappingReq.prototype.setSymbolId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool delete_all = 4;
 * @return {boolean}
 */
proto.tradecopier.AdminDeleteSymbolMappingReq.prototype.getDeleteAll = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tradecopier.AdminDeleteSymbolMappingReq} returns this
 */
proto.tradecopier.AdminDeleteSymbolMappingReq.prototype.setDeleteAll = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AdminDeleteSymbolMappingReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AdminDeleteSymbolMappingReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AdminDeleteSymbolMappingReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminDeleteSymbolMappingReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AdminDeleteSymbolMappingReply}
 */
proto.tradecopier.AdminDeleteSymbolMappingReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AdminDeleteSymbolMappingReply;
  return proto.tradecopier.AdminDeleteSymbolMappingReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AdminDeleteSymbolMappingReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AdminDeleteSymbolMappingReply}
 */
proto.tradecopier.AdminDeleteSymbolMappingReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AdminDeleteSymbolMappingReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AdminDeleteSymbolMappingReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AdminDeleteSymbolMappingReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminDeleteSymbolMappingReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.IntGetMasterAndSlaveCountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.IntGetMasterAndSlaveCountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.IntGetMasterAndSlaveCountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntGetMasterAndSlaveCountReq.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.IntGetMasterAndSlaveCountReq}
 */
proto.tradecopier.IntGetMasterAndSlaveCountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.IntGetMasterAndSlaveCountReq;
  return proto.tradecopier.IntGetMasterAndSlaveCountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.IntGetMasterAndSlaveCountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.IntGetMasterAndSlaveCountReq}
 */
proto.tradecopier.IntGetMasterAndSlaveCountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.IntGetMasterAndSlaveCountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.IntGetMasterAndSlaveCountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.IntGetMasterAndSlaveCountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntGetMasterAndSlaveCountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.IntGetMasterAndSlaveCountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.IntGetMasterAndSlaveCountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.IntGetMasterAndSlaveCountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntGetMasterAndSlaveCountReply.toObject = function(includeInstance, msg) {
  var f, obj = {
totalMasters: jspb.Message.getFieldWithDefault(msg, 1, 0),
totalEnabledMasters: jspb.Message.getFieldWithDefault(msg, 2, 0),
totalSlaves: jspb.Message.getFieldWithDefault(msg, 3, 0),
totalEnabledSlaves: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.IntGetMasterAndSlaveCountReply}
 */
proto.tradecopier.IntGetMasterAndSlaveCountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.IntGetMasterAndSlaveCountReply;
  return proto.tradecopier.IntGetMasterAndSlaveCountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.IntGetMasterAndSlaveCountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.IntGetMasterAndSlaveCountReply}
 */
proto.tradecopier.IntGetMasterAndSlaveCountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalMasters(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalEnabledMasters(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalSlaves(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalEnabledSlaves(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.IntGetMasterAndSlaveCountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.IntGetMasterAndSlaveCountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.IntGetMasterAndSlaveCountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntGetMasterAndSlaveCountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalMasters();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTotalEnabledMasters();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTotalSlaves();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTotalEnabledSlaves();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional int64 total_masters = 1;
 * @return {number}
 */
proto.tradecopier.IntGetMasterAndSlaveCountReply.prototype.getTotalMasters = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.IntGetMasterAndSlaveCountReply} returns this
 */
proto.tradecopier.IntGetMasterAndSlaveCountReply.prototype.setTotalMasters = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 total_enabled_masters = 2;
 * @return {number}
 */
proto.tradecopier.IntGetMasterAndSlaveCountReply.prototype.getTotalEnabledMasters = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.IntGetMasterAndSlaveCountReply} returns this
 */
proto.tradecopier.IntGetMasterAndSlaveCountReply.prototype.setTotalEnabledMasters = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 total_slaves = 3;
 * @return {number}
 */
proto.tradecopier.IntGetMasterAndSlaveCountReply.prototype.getTotalSlaves = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.IntGetMasterAndSlaveCountReply} returns this
 */
proto.tradecopier.IntGetMasterAndSlaveCountReply.prototype.setTotalSlaves = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 total_enabled_slaves = 4;
 * @return {number}
 */
proto.tradecopier.IntGetMasterAndSlaveCountReply.prototype.getTotalEnabledSlaves = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.IntGetMasterAndSlaveCountReply} returns this
 */
proto.tradecopier.IntGetMasterAndSlaveCountReply.prototype.setTotalEnabledSlaves = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.IntGetUsersConfigsCountReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.IntGetUsersConfigsCountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.IntGetUsersConfigsCountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.IntGetUsersConfigsCountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntGetUsersConfigsCountReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.IntGetUsersConfigsCountReq}
 */
proto.tradecopier.IntGetUsersConfigsCountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.IntGetUsersConfigsCountReq;
  return proto.tradecopier.IntGetUsersConfigsCountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.IntGetUsersConfigsCountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.IntGetUsersConfigsCountReq}
 */
proto.tradecopier.IntGetUsersConfigsCountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.IntGetUsersConfigsCountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.IntGetUsersConfigsCountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.IntGetUsersConfigsCountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntGetUsersConfigsCountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string user_ids = 1;
 * @return {!Array<string>}
 */
proto.tradecopier.IntGetUsersConfigsCountReq.prototype.getUserIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.tradecopier.IntGetUsersConfigsCountReq} returns this
 */
proto.tradecopier.IntGetUsersConfigsCountReq.prototype.setUserIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.IntGetUsersConfigsCountReq} returns this
 */
proto.tradecopier.IntGetUsersConfigsCountReq.prototype.addUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.IntGetUsersConfigsCountReq} returns this
 */
proto.tradecopier.IntGetUsersConfigsCountReq.prototype.clearUserIdsList = function() {
  return this.setUserIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.IntGetUsersConfigsCountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.IntGetUsersConfigsCountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.IntGetUsersConfigsCountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntGetUsersConfigsCountReply.toObject = function(includeInstance, msg) {
  var f, obj = {
usersConfigCountMapMap: (f = msg.getUsersConfigCountMapMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.IntGetUsersConfigsCountReply}
 */
proto.tradecopier.IntGetUsersConfigsCountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.IntGetUsersConfigsCountReply;
  return proto.tradecopier.IntGetUsersConfigsCountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.IntGetUsersConfigsCountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.IntGetUsersConfigsCountReply}
 */
proto.tradecopier.IntGetUsersConfigsCountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getUsersConfigCountMapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readInt64, null, "", 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.IntGetUsersConfigsCountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.IntGetUsersConfigsCountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.IntGetUsersConfigsCountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntGetUsersConfigsCountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersConfigCountMapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeInt64);
  }
};


/**
 * map<string, int64> users_config_count_map = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.tradecopier.IntGetUsersConfigsCountReply.prototype.getUsersConfigCountMapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.tradecopier.IntGetUsersConfigsCountReply} returns this
 */
proto.tradecopier.IntGetUsersConfigsCountReply.prototype.clearUsersConfigCountMapMap = function() {
  this.getUsersConfigCountMapMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AddConfigReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AddConfigReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AddConfigReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AddConfigReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
masterAccount: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AddConfigReq}
 */
proto.tradecopier.AddConfigReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AddConfigReq;
  return proto.tradecopier.AddConfigReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AddConfigReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AddConfigReq}
 */
proto.tradecopier.AddConfigReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AddConfigReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AddConfigReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AddConfigReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AddConfigReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMasterAccount();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.AddConfigReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AddConfigReq} returns this
 */
proto.tradecopier.AddConfigReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string master_account = 2;
 * @return {string}
 */
proto.tradecopier.AddConfigReq.prototype.getMasterAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AddConfigReq} returns this
 */
proto.tradecopier.AddConfigReq.prototype.setMasterAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AddConfigReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AddConfigReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AddConfigReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AddConfigReply.toObject = function(includeInstance, msg) {
  var f, obj = {
configId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AddConfigReply}
 */
proto.tradecopier.AddConfigReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AddConfigReply;
  return proto.tradecopier.AddConfigReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AddConfigReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AddConfigReply}
 */
proto.tradecopier.AddConfigReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfigId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AddConfigReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AddConfigReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AddConfigReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AddConfigReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string config_id = 1;
 * @return {string}
 */
proto.tradecopier.AddConfigReply.prototype.getConfigId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AddConfigReply} returns this
 */
proto.tradecopier.AddConfigReply.prototype.setConfigId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.UpdateConfigReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.UpdateConfigReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.UpdateConfigReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdateConfigReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
configId: jspb.Message.getFieldWithDefault(msg, 2, ""),
enable: (f = msg.getEnable()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
masterAccountId: jspb.Message.getFieldWithDefault(msg, 4, ""),
manageExisting: (f = msg.getManageExisting()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.UpdateConfigReq}
 */
proto.tradecopier.UpdateConfigReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.UpdateConfigReq;
  return proto.tradecopier.UpdateConfigReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.UpdateConfigReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.UpdateConfigReq}
 */
proto.tradecopier.UpdateConfigReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfigId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEnable(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountId(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setManageExisting(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.UpdateConfigReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.UpdateConfigReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.UpdateConfigReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdateConfigReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConfigId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEnable();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getMasterAccountId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getManageExisting();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.UpdateConfigReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.UpdateConfigReq} returns this
 */
proto.tradecopier.UpdateConfigReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string config_id = 2;
 * @return {string}
 */
proto.tradecopier.UpdateConfigReq.prototype.getConfigId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.UpdateConfigReq} returns this
 */
proto.tradecopier.UpdateConfigReq.prototype.setConfigId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.BoolValue enable = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateConfigReq.prototype.getEnable = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateConfigReq} returns this
*/
proto.tradecopier.UpdateConfigReq.prototype.setEnable = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateConfigReq} returns this
 */
proto.tradecopier.UpdateConfigReq.prototype.clearEnable = function() {
  return this.setEnable(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateConfigReq.prototype.hasEnable = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string master_account_id = 4;
 * @return {string}
 */
proto.tradecopier.UpdateConfigReq.prototype.getMasterAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.UpdateConfigReq} returns this
 */
proto.tradecopier.UpdateConfigReq.prototype.setMasterAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.BoolValue manage_existing = 5;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateConfigReq.prototype.getManageExisting = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 5));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateConfigReq} returns this
*/
proto.tradecopier.UpdateConfigReq.prototype.setManageExisting = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateConfigReq} returns this
 */
proto.tradecopier.UpdateConfigReq.prototype.clearManageExisting = function() {
  return this.setManageExisting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateConfigReq.prototype.hasManageExisting = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.UpdateConfigReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.UpdateConfigReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.UpdateConfigReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdateConfigReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.UpdateConfigReply}
 */
proto.tradecopier.UpdateConfigReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.UpdateConfigReply;
  return proto.tradecopier.UpdateConfigReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.UpdateConfigReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.UpdateConfigReply}
 */
proto.tradecopier.UpdateConfigReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.UpdateConfigReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.UpdateConfigReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.UpdateConfigReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdateConfigReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.DeleteConfigReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.DeleteConfigReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.DeleteConfigReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.DeleteConfigReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
configId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.DeleteConfigReq}
 */
proto.tradecopier.DeleteConfigReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.DeleteConfigReq;
  return proto.tradecopier.DeleteConfigReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.DeleteConfigReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.DeleteConfigReq}
 */
proto.tradecopier.DeleteConfigReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfigId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.DeleteConfigReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.DeleteConfigReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.DeleteConfigReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.DeleteConfigReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConfigId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.DeleteConfigReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.DeleteConfigReq} returns this
 */
proto.tradecopier.DeleteConfigReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string config_id = 2;
 * @return {string}
 */
proto.tradecopier.DeleteConfigReq.prototype.getConfigId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.DeleteConfigReq} returns this
 */
proto.tradecopier.DeleteConfigReq.prototype.setConfigId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.DeleteConfigReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.DeleteConfigReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.DeleteConfigReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.DeleteConfigReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.DeleteConfigReply}
 */
proto.tradecopier.DeleteConfigReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.DeleteConfigReply;
  return proto.tradecopier.DeleteConfigReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.DeleteConfigReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.DeleteConfigReply}
 */
proto.tradecopier.DeleteConfigReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.DeleteConfigReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.DeleteConfigReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.DeleteConfigReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.DeleteConfigReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.AddSlavesReq.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AddSlavesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AddSlavesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AddSlavesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AddSlavesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
configId: jspb.Message.getFieldWithDefault(msg, 2, ""),
slaveAccountsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AddSlavesReq}
 */
proto.tradecopier.AddSlavesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AddSlavesReq;
  return proto.tradecopier.AddSlavesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AddSlavesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AddSlavesReq}
 */
proto.tradecopier.AddSlavesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfigId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addSlaveAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AddSlavesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AddSlavesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AddSlavesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AddSlavesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConfigId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlaveAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.AddSlavesReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AddSlavesReq} returns this
 */
proto.tradecopier.AddSlavesReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string config_id = 2;
 * @return {string}
 */
proto.tradecopier.AddSlavesReq.prototype.getConfigId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AddSlavesReq} returns this
 */
proto.tradecopier.AddSlavesReq.prototype.setConfigId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string slave_accounts = 3;
 * @return {!Array<string>}
 */
proto.tradecopier.AddSlavesReq.prototype.getSlaveAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.tradecopier.AddSlavesReq} returns this
 */
proto.tradecopier.AddSlavesReq.prototype.setSlaveAccountsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.AddSlavesReq} returns this
 */
proto.tradecopier.AddSlavesReq.prototype.addSlaveAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.AddSlavesReq} returns this
 */
proto.tradecopier.AddSlavesReq.prototype.clearSlaveAccountsList = function() {
  return this.setSlaveAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AddSlaveReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AddSlaveReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AddSlaveReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AddSlaveReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AddSlaveReply}
 */
proto.tradecopier.AddSlaveReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AddSlaveReply;
  return proto.tradecopier.AddSlaveReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AddSlaveReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AddSlaveReply}
 */
proto.tradecopier.AddSlaveReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AddSlaveReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AddSlaveReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AddSlaveReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AddSlaveReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.DeleteSalvesReq.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.DeleteSalvesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.DeleteSalvesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.DeleteSalvesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.DeleteSalvesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
configId: jspb.Message.getFieldWithDefault(msg, 2, ""),
slaveAccountsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.DeleteSalvesReq}
 */
proto.tradecopier.DeleteSalvesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.DeleteSalvesReq;
  return proto.tradecopier.DeleteSalvesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.DeleteSalvesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.DeleteSalvesReq}
 */
proto.tradecopier.DeleteSalvesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfigId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addSlaveAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.DeleteSalvesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.DeleteSalvesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.DeleteSalvesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.DeleteSalvesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConfigId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlaveAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.DeleteSalvesReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.DeleteSalvesReq} returns this
 */
proto.tradecopier.DeleteSalvesReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string config_id = 2;
 * @return {string}
 */
proto.tradecopier.DeleteSalvesReq.prototype.getConfigId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.DeleteSalvesReq} returns this
 */
proto.tradecopier.DeleteSalvesReq.prototype.setConfigId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string slave_accounts = 3;
 * @return {!Array<string>}
 */
proto.tradecopier.DeleteSalvesReq.prototype.getSlaveAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.tradecopier.DeleteSalvesReq} returns this
 */
proto.tradecopier.DeleteSalvesReq.prototype.setSlaveAccountsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.DeleteSalvesReq} returns this
 */
proto.tradecopier.DeleteSalvesReq.prototype.addSlaveAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.DeleteSalvesReq} returns this
 */
proto.tradecopier.DeleteSalvesReq.prototype.clearSlaveAccountsList = function() {
  return this.setSlaveAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.DeleteSlavesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.DeleteSlavesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.DeleteSlavesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.DeleteSlavesReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.DeleteSlavesReply}
 */
proto.tradecopier.DeleteSlavesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.DeleteSlavesReply;
  return proto.tradecopier.DeleteSlavesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.DeleteSlavesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.DeleteSlavesReply}
 */
proto.tradecopier.DeleteSlavesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.DeleteSlavesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.DeleteSlavesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.DeleteSlavesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.DeleteSlavesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.GetUserConfigsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.GetUserConfigsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.GetUserConfigsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.GetUserConfigsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.GetUserConfigsReq}
 */
proto.tradecopier.GetUserConfigsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.GetUserConfigsReq;
  return proto.tradecopier.GetUserConfigsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.GetUserConfigsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.GetUserConfigsReq}
 */
proto.tradecopier.GetUserConfigsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.GetUserConfigsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.GetUserConfigsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.GetUserConfigsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.GetUserConfigsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.GetUserConfigsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.GetUserConfigsReq} returns this
 */
proto.tradecopier.GetUserConfigsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.GetUserConfigsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.GetUserConfigsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.GetUserConfigsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.GetUserConfigsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.GetUserConfigsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
configsList: jspb.Message.toObjectList(msg.getConfigsList(),
    proto.tradecopier.Config.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.GetUserConfigsReply}
 */
proto.tradecopier.GetUserConfigsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.GetUserConfigsReply;
  return proto.tradecopier.GetUserConfigsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.GetUserConfigsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.GetUserConfigsReply}
 */
proto.tradecopier.GetUserConfigsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tradecopier.Config;
      reader.readMessage(value,proto.tradecopier.Config.deserializeBinaryFromReader);
      msg.addConfigs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.GetUserConfigsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.GetUserConfigsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.GetUserConfigsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.GetUserConfigsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tradecopier.Config.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Config configs = 1;
 * @return {!Array<!proto.tradecopier.Config>}
 */
proto.tradecopier.GetUserConfigsReply.prototype.getConfigsList = function() {
  return /** @type{!Array<!proto.tradecopier.Config>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tradecopier.Config, 1));
};


/**
 * @param {!Array<!proto.tradecopier.Config>} value
 * @return {!proto.tradecopier.GetUserConfigsReply} returns this
*/
proto.tradecopier.GetUserConfigsReply.prototype.setConfigsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tradecopier.Config=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.Config}
 */
proto.tradecopier.GetUserConfigsReply.prototype.addConfigs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tradecopier.Config, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.GetUserConfigsReply} returns this
 */
proto.tradecopier.GetUserConfigsReply.prototype.clearConfigsList = function() {
  return this.setConfigsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.Config.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.Config.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.Config.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.Config} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.Config.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
master: (f = msg.getMaster()) && proto.tradecopier.Master.toObject(includeInstance, f),
slavesList: jspb.Message.toObjectList(msg.getSlavesList(),
    proto.tradecopier.Slave.toObject, includeInstance),
manageExisting: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.Config}
 */
proto.tradecopier.Config.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.Config;
  return proto.tradecopier.Config.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.Config} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.Config}
 */
proto.tradecopier.Config.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 3:
      var value = new proto.tradecopier.Master;
      reader.readMessage(value,proto.tradecopier.Master.deserializeBinaryFromReader);
      msg.setMaster(value);
      break;
    case 4:
      var value = new proto.tradecopier.Slave;
      reader.readMessage(value,proto.tradecopier.Slave.deserializeBinaryFromReader);
      msg.addSlaves(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setManageExisting(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.Config.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.Config.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.Config} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.Config.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMaster();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.tradecopier.Master.serializeBinaryToWriter
    );
  }
  f = message.getSlavesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.tradecopier.Slave.serializeBinaryToWriter
    );
  }
  f = message.getManageExisting();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tradecopier.Config.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.Config} returns this
 */
proto.tradecopier.Config.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool enabled = 2;
 * @return {boolean}
 */
proto.tradecopier.Config.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tradecopier.Config} returns this
 */
proto.tradecopier.Config.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional Master master = 3;
 * @return {?proto.tradecopier.Master}
 */
proto.tradecopier.Config.prototype.getMaster = function() {
  return /** @type{?proto.tradecopier.Master} */ (
    jspb.Message.getWrapperField(this, proto.tradecopier.Master, 3));
};


/**
 * @param {?proto.tradecopier.Master|undefined} value
 * @return {!proto.tradecopier.Config} returns this
*/
proto.tradecopier.Config.prototype.setMaster = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Config} returns this
 */
proto.tradecopier.Config.prototype.clearMaster = function() {
  return this.setMaster(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Config.prototype.hasMaster = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated Slave slaves = 4;
 * @return {!Array<!proto.tradecopier.Slave>}
 */
proto.tradecopier.Config.prototype.getSlavesList = function() {
  return /** @type{!Array<!proto.tradecopier.Slave>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tradecopier.Slave, 4));
};


/**
 * @param {!Array<!proto.tradecopier.Slave>} value
 * @return {!proto.tradecopier.Config} returns this
*/
proto.tradecopier.Config.prototype.setSlavesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.tradecopier.Slave=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.Slave}
 */
proto.tradecopier.Config.prototype.addSlaves = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.tradecopier.Slave, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.Config} returns this
 */
proto.tradecopier.Config.prototype.clearSlavesList = function() {
  return this.setSlavesList([]);
};


/**
 * optional bool manage_existing = 5;
 * @return {boolean}
 */
proto.tradecopier.Config.prototype.getManageExisting = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tradecopier.Config} returns this
 */
proto.tradecopier.Config.prototype.setManageExisting = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.Master.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.Master.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.Master} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.Master.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
nickname: jspb.Message.getFieldWithDefault(msg, 3, ""),
accountNumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
name: (f = msg.getName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
platform: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.Master}
 */
proto.tradecopier.Master.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.Master;
  return proto.tradecopier.Master.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.Master} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.Master}
 */
proto.tradecopier.Master.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.Master.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.Master.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.Master} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.Master.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tradecopier.Master.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.Master} returns this
 */
proto.tradecopier.Master.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.tradecopier.Master.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.Master} returns this
 */
proto.tradecopier.Master.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string nickname = 3;
 * @return {string}
 */
proto.tradecopier.Master.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.Master} returns this
 */
proto.tradecopier.Master.prototype.setNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string account_number = 4;
 * @return {string}
 */
proto.tradecopier.Master.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.Master} returns this
 */
proto.tradecopier.Master.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.StringValue name = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.Master.prototype.getName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.Master} returns this
*/
proto.tradecopier.Master.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Master} returns this
 */
proto.tradecopier.Master.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Master.prototype.hasName = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.tradecopier.Master.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.tradecopier.Master} returns this
*/
proto.tradecopier.Master.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Master} returns this
 */
proto.tradecopier.Master.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Master.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string platform = 7;
 * @return {string}
 */
proto.tradecopier.Master.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.Master} returns this
 */
proto.tradecopier.Master.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.Slave.repeatedFields_ = [32,35,47];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.Slave.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.Slave.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.Slave} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.Slave.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
enabled: (f = msg.getEnabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
riskType: (f = msg.getRiskType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
fixedLotValue: (f = msg.getFixedLotValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
lotMultiplierValue: (f = msg.getLotMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
balanceMultiplierValue: (f = msg.getBalanceMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
copyStopLoss: (f = msg.getCopyStopLoss()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyTakeProfit: (f = msg.getCopyTakeProfit()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyPendingOrders: (f = msg.getCopyPendingOrders()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
nickname: jspb.Message.getFieldWithDefault(msg, 11, ""),
accountNumber: jspb.Message.getFieldWithDefault(msg, 12, ""),
forceMinimumLotSize: (f = msg.getForceMinimumLotSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyComment: (f = msg.getCopyComment()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
customComment: (f = msg.getCustomComment()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
forceMaximumLotSize: (f = msg.getForceMaximumLotSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
platform: jspb.Message.getFieldWithDefault(msg, 17, ""),
placedType: (f = msg.getPlacedType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
reverseTrade: (f = msg.getReverseTrade()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
symbolMismatch: (f = msg.getSymbolMismatch()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
showSymbolMismatch: (f = msg.getShowSymbolMismatch()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
strictClose: (f = msg.getStrictClose()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
considerContractSize: (f = msg.getConsiderContractSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
name: (f = msg.getName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
copyMagicNumber: (f = msg.getCopyMagicNumber()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
magicNumber: (f = msg.getMagicNumber()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
manageExisting: (f = msg.getManageExisting()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
lotRefinerValue: (f = msg.getLotRefinerValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
fixedBalanceMultiplierValue: (f = msg.getFixedBalanceMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
fixedMasterBalance: (f = msg.getFixedMasterBalance()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
pauseUntil: (f = msg.getPauseUntil()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
magicFiltersList: jspb.Message.toObjectList(msg.getMagicFiltersList(),
    google_protobuf_wrappers_pb.Int64Value.toObject, includeInstance),
minDelayTime: (f = msg.getMinDelayTime()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
copyExpiryTime: (f = msg.getCopyExpiryTime()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
commentFiltersList: jspb.Message.toObjectList(msg.getCommentFiltersList(),
    google_protobuf_wrappers_pb.StringValue.toObject, includeInstance),
minLotFilter: (f = msg.getMinLotFilter()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
maxLotFilter: (f = msg.getMaxLotFilter()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
maxDelayTime: (f = msg.getMaxDelayTime()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
stopLossPip: (f = msg.getStopLossPip()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
takeProfitPip: (f = msg.getTakeProfitPip()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
slRefiner: (f = msg.getSlRefiner()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
tpRefiner: (f = msg.getTpRefiner()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
balancePercentageValue: (f = msg.getBalancePercentageValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
copyExistingTrades: (f = msg.getCopyExistingTrades()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
allowedTradeSide: (f = msg.getAllowedTradeSide()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
tradingHoursList: jspb.Message.toObjectList(msg.getTradingHoursList(),
    proto.tradecopier.TradingHour.toObject, includeInstance),
magicFilterType: (f = msg.getMagicFilterType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
commentFilterType: (f = msg.getCommentFilterType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.Slave}
 */
proto.tradecopier.Slave.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.Slave;
  return proto.tradecopier.Slave.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.Slave} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.Slave}
 */
proto.tradecopier.Slave.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEnabled(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRiskType(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedLotValue(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLotMultiplierValue(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setBalanceMultiplierValue(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyStopLoss(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyTakeProfit(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyPendingOrders(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setForceMinimumLotSize(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyComment(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomComment(value);
      break;
    case 16:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setForceMaximumLotSize(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 18:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPlacedType(value);
      break;
    case 19:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setReverseTrade(value);
      break;
    case 20:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setSymbolMismatch(value);
      break;
    case 21:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setShowSymbolMismatch(value);
      break;
    case 22:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setStrictClose(value);
      break;
    case 23:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setConsiderContractSize(value);
      break;
    case 24:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 25:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyMagicNumber(value);
      break;
    case 26:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMagicNumber(value);
      break;
    case 27:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setManageExisting(value);
      break;
    case 28:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLotRefinerValue(value);
      break;
    case 29:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedBalanceMultiplierValue(value);
      break;
    case 30:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedMasterBalance(value);
      break;
    case 31:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPauseUntil(value);
      break;
    case 32:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.addMagicFilters(value);
      break;
    case 33:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMinDelayTime(value);
      break;
    case 34:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyExpiryTime(value);
      break;
    case 35:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.addCommentFilters(value);
      break;
    case 36:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMinLotFilter(value);
      break;
    case 37:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMaxLotFilter(value);
      break;
    case 38:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMaxDelayTime(value);
      break;
    case 39:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setStopLossPip(value);
      break;
    case 40:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTakeProfitPip(value);
      break;
    case 41:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setSlRefiner(value);
      break;
    case 42:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTpRefiner(value);
      break;
    case 43:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setBalancePercentageValue(value);
      break;
    case 44:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 45:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyExistingTrades(value);
      break;
    case 46:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAllowedTradeSide(value);
      break;
    case 47:
      var value = new proto.tradecopier.TradingHour;
      reader.readMessage(value,proto.tradecopier.TradingHour.deserializeBinaryFromReader);
      msg.addTradingHours(value);
      break;
    case 48:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setMagicFilterType(value);
      break;
    case 49:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCommentFilterType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.Slave.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.Slave.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.Slave} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.Slave.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEnabled();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getRiskType();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getFixedLotValue();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getLotMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getBalanceMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyStopLoss();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyTakeProfit();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyPendingOrders();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getForceMinimumLotSize();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyComment();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomComment();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getForceMaximumLotSize();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getPlacedType();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getReverseTrade();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getSymbolMismatch();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getShowSymbolMismatch();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getStrictClose();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getConsiderContractSize();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyMagicNumber();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getMagicNumber();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getManageExisting();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getLotRefinerValue();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getFixedBalanceMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getFixedMasterBalance();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getPauseUntil();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMagicFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      32,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getMinDelayTime();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getCopyExpiryTime();
  if (f != null) {
    writer.writeMessage(
      34,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCommentFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      35,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getMinLotFilter();
  if (f != null) {
    writer.writeMessage(
      36,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxLotFilter();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxDelayTime();
  if (f != null) {
    writer.writeMessage(
      38,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getStopLossPip();
  if (f != null) {
    writer.writeMessage(
      39,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTakeProfitPip();
  if (f != null) {
    writer.writeMessage(
      40,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getSlRefiner();
  if (f != null) {
    writer.writeMessage(
      41,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTpRefiner();
  if (f != null) {
    writer.writeMessage(
      42,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getBalancePercentageValue();
  if (f != null) {
    writer.writeMessage(
      43,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      44,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCopyExistingTrades();
  if (f != null) {
    writer.writeMessage(
      45,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getAllowedTradeSide();
  if (f != null) {
    writer.writeMessage(
      46,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTradingHoursList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      47,
      f,
      proto.tradecopier.TradingHour.serializeBinaryToWriter
    );
  }
  f = message.getMagicFilterType();
  if (f != null) {
    writer.writeMessage(
      48,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCommentFilterType();
  if (f != null) {
    writer.writeMessage(
      49,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tradecopier.Slave.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.tradecopier.Slave.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.BoolValue enabled = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.Slave.prototype.getEnabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearEnabled = function() {
  return this.setEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasEnabled = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue risk_type = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.Slave.prototype.getRiskType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setRiskType = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearRiskType = function() {
  return this.setRiskType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasRiskType = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.DoubleValue fixed_lot_value = 5;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.Slave.prototype.getFixedLotValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 5));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setFixedLotValue = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearFixedLotValue = function() {
  return this.setFixedLotValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasFixedLotValue = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.DoubleValue lot_multiplier_value = 6;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.Slave.prototype.getLotMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 6));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setLotMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearLotMultiplierValue = function() {
  return this.setLotMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasLotMultiplierValue = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.DoubleValue balance_multiplier_value = 7;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.Slave.prototype.getBalanceMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 7));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setBalanceMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearBalanceMultiplierValue = function() {
  return this.setBalanceMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasBalanceMultiplierValue = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.BoolValue copy_stop_loss = 8;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.Slave.prototype.getCopyStopLoss = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 8));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setCopyStopLoss = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearCopyStopLoss = function() {
  return this.setCopyStopLoss(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasCopyStopLoss = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.BoolValue copy_take_profit = 9;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.Slave.prototype.getCopyTakeProfit = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 9));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setCopyTakeProfit = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearCopyTakeProfit = function() {
  return this.setCopyTakeProfit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasCopyTakeProfit = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.BoolValue copy_pending_orders = 10;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.Slave.prototype.getCopyPendingOrders = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 10));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setCopyPendingOrders = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearCopyPendingOrders = function() {
  return this.setCopyPendingOrders(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasCopyPendingOrders = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string nickname = 11;
 * @return {string}
 */
proto.tradecopier.Slave.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.setNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string account_number = 12;
 * @return {string}
 */
proto.tradecopier.Slave.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional google.protobuf.BoolValue force_minimum_lot_size = 13;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.Slave.prototype.getForceMinimumLotSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 13));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setForceMinimumLotSize = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearForceMinimumLotSize = function() {
  return this.setForceMinimumLotSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasForceMinimumLotSize = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.BoolValue copy_comment = 14;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.Slave.prototype.getCopyComment = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 14));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setCopyComment = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearCopyComment = function() {
  return this.setCopyComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasCopyComment = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.StringValue custom_comment = 15;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.Slave.prototype.getCustomComment = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 15));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setCustomComment = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearCustomComment = function() {
  return this.setCustomComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasCustomComment = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.BoolValue force_maximum_lot_size = 16;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.Slave.prototype.getForceMaximumLotSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 16));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setForceMaximumLotSize = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearForceMaximumLotSize = function() {
  return this.setForceMaximumLotSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasForceMaximumLotSize = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional string platform = 17;
 * @return {string}
 */
proto.tradecopier.Slave.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional google.protobuf.StringValue placed_type = 18;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.Slave.prototype.getPlacedType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 18));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setPlacedType = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearPlacedType = function() {
  return this.setPlacedType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasPlacedType = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional google.protobuf.BoolValue reverse_trade = 19;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.Slave.prototype.getReverseTrade = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 19));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setReverseTrade = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearReverseTrade = function() {
  return this.setReverseTrade(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasReverseTrade = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional google.protobuf.BoolValue symbol_mismatch = 20;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.Slave.prototype.getSymbolMismatch = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 20));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setSymbolMismatch = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearSymbolMismatch = function() {
  return this.setSymbolMismatch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasSymbolMismatch = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional google.protobuf.BoolValue show_symbol_mismatch = 21;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.Slave.prototype.getShowSymbolMismatch = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 21));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setShowSymbolMismatch = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearShowSymbolMismatch = function() {
  return this.setShowSymbolMismatch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasShowSymbolMismatch = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional google.protobuf.BoolValue strict_close = 22;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.Slave.prototype.getStrictClose = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 22));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setStrictClose = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearStrictClose = function() {
  return this.setStrictClose(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasStrictClose = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.BoolValue consider_contract_size = 23;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.Slave.prototype.getConsiderContractSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 23));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setConsiderContractSize = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearConsiderContractSize = function() {
  return this.setConsiderContractSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasConsiderContractSize = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional google.protobuf.StringValue name = 24;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.Slave.prototype.getName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 24));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasName = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional google.protobuf.BoolValue copy_magic_number = 25;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.Slave.prototype.getCopyMagicNumber = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 25));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setCopyMagicNumber = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearCopyMagicNumber = function() {
  return this.setCopyMagicNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasCopyMagicNumber = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional google.protobuf.Int64Value magic_number = 26;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.Slave.prototype.getMagicNumber = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 26));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setMagicNumber = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearMagicNumber = function() {
  return this.setMagicNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasMagicNumber = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional google.protobuf.BoolValue manage_existing = 27;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.Slave.prototype.getManageExisting = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 27));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setManageExisting = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearManageExisting = function() {
  return this.setManageExisting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasManageExisting = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional google.protobuf.DoubleValue lot_refiner_value = 28;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.Slave.prototype.getLotRefinerValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 28));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setLotRefinerValue = function(value) {
  return jspb.Message.setWrapperField(this, 28, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearLotRefinerValue = function() {
  return this.setLotRefinerValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasLotRefinerValue = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional google.protobuf.DoubleValue fixed_balance_multiplier_value = 29;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.Slave.prototype.getFixedBalanceMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 29));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setFixedBalanceMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearFixedBalanceMultiplierValue = function() {
  return this.setFixedBalanceMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasFixedBalanceMultiplierValue = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional google.protobuf.DoubleValue fixed_master_balance = 30;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.Slave.prototype.getFixedMasterBalance = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 30));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setFixedMasterBalance = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearFixedMasterBalance = function() {
  return this.setFixedMasterBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasFixedMasterBalance = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional google.protobuf.Timestamp pause_until = 31;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.tradecopier.Slave.prototype.getPauseUntil = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 31));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setPauseUntil = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearPauseUntil = function() {
  return this.setPauseUntil(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasPauseUntil = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * repeated google.protobuf.Int64Value magic_filters = 32;
 * @return {!Array<!proto.google.protobuf.Int64Value>}
 */
proto.tradecopier.Slave.prototype.getMagicFiltersList = function() {
  return /** @type{!Array<!proto.google.protobuf.Int64Value>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 32));
};


/**
 * @param {!Array<!proto.google.protobuf.Int64Value>} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setMagicFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 32, value);
};


/**
 * @param {!proto.google.protobuf.Int64Value=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Int64Value}
 */
proto.tradecopier.Slave.prototype.addMagicFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 32, opt_value, proto.google.protobuf.Int64Value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearMagicFiltersList = function() {
  return this.setMagicFiltersList([]);
};


/**
 * optional google.protobuf.Int64Value min_delay_time = 33;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.Slave.prototype.getMinDelayTime = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 33));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setMinDelayTime = function(value) {
  return jspb.Message.setWrapperField(this, 33, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearMinDelayTime = function() {
  return this.setMinDelayTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasMinDelayTime = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional google.protobuf.BoolValue copy_expiry_time = 34;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.Slave.prototype.getCopyExpiryTime = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 34));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setCopyExpiryTime = function(value) {
  return jspb.Message.setWrapperField(this, 34, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearCopyExpiryTime = function() {
  return this.setCopyExpiryTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasCopyExpiryTime = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * repeated google.protobuf.StringValue comment_filters = 35;
 * @return {!Array<!proto.google.protobuf.StringValue>}
 */
proto.tradecopier.Slave.prototype.getCommentFiltersList = function() {
  return /** @type{!Array<!proto.google.protobuf.StringValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_wrappers_pb.StringValue, 35));
};


/**
 * @param {!Array<!proto.google.protobuf.StringValue>} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setCommentFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 35, value);
};


/**
 * @param {!proto.google.protobuf.StringValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.StringValue}
 */
proto.tradecopier.Slave.prototype.addCommentFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 35, opt_value, proto.google.protobuf.StringValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearCommentFiltersList = function() {
  return this.setCommentFiltersList([]);
};


/**
 * optional google.protobuf.DoubleValue min_lot_filter = 36;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.Slave.prototype.getMinLotFilter = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 36));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setMinLotFilter = function(value) {
  return jspb.Message.setWrapperField(this, 36, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearMinLotFilter = function() {
  return this.setMinLotFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasMinLotFilter = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional google.protobuf.DoubleValue max_lot_filter = 37;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.Slave.prototype.getMaxLotFilter = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 37));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setMaxLotFilter = function(value) {
  return jspb.Message.setWrapperField(this, 37, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearMaxLotFilter = function() {
  return this.setMaxLotFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasMaxLotFilter = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional google.protobuf.Int64Value max_delay_time = 38;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.Slave.prototype.getMaxDelayTime = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 38));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setMaxDelayTime = function(value) {
  return jspb.Message.setWrapperField(this, 38, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearMaxDelayTime = function() {
  return this.setMaxDelayTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasMaxDelayTime = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional google.protobuf.DoubleValue stop_loss_pip = 39;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.Slave.prototype.getStopLossPip = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 39));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setStopLossPip = function(value) {
  return jspb.Message.setWrapperField(this, 39, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearStopLossPip = function() {
  return this.setStopLossPip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasStopLossPip = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * optional google.protobuf.DoubleValue take_profit_pip = 40;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.Slave.prototype.getTakeProfitPip = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 40));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setTakeProfitPip = function(value) {
  return jspb.Message.setWrapperField(this, 40, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearTakeProfitPip = function() {
  return this.setTakeProfitPip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasTakeProfitPip = function() {
  return jspb.Message.getField(this, 40) != null;
};


/**
 * optional google.protobuf.DoubleValue sl_refiner = 41;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.Slave.prototype.getSlRefiner = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 41));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setSlRefiner = function(value) {
  return jspb.Message.setWrapperField(this, 41, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearSlRefiner = function() {
  return this.setSlRefiner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasSlRefiner = function() {
  return jspb.Message.getField(this, 41) != null;
};


/**
 * optional google.protobuf.DoubleValue tp_refiner = 42;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.Slave.prototype.getTpRefiner = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 42));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setTpRefiner = function(value) {
  return jspb.Message.setWrapperField(this, 42, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearTpRefiner = function() {
  return this.setTpRefiner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasTpRefiner = function() {
  return jspb.Message.getField(this, 42) != null;
};


/**
 * optional google.protobuf.DoubleValue balance_percentage_value = 43;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.Slave.prototype.getBalancePercentageValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 43));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setBalancePercentageValue = function(value) {
  return jspb.Message.setWrapperField(this, 43, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearBalancePercentageValue = function() {
  return this.setBalancePercentageValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasBalancePercentageValue = function() {
  return jspb.Message.getField(this, 43) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 44;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.tradecopier.Slave.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 44));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 44, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 44) != null;
};


/**
 * optional google.protobuf.BoolValue copy_existing_trades = 45;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.Slave.prototype.getCopyExistingTrades = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 45));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setCopyExistingTrades = function(value) {
  return jspb.Message.setWrapperField(this, 45, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearCopyExistingTrades = function() {
  return this.setCopyExistingTrades(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasCopyExistingTrades = function() {
  return jspb.Message.getField(this, 45) != null;
};


/**
 * optional google.protobuf.StringValue allowed_trade_side = 46;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.Slave.prototype.getAllowedTradeSide = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 46));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setAllowedTradeSide = function(value) {
  return jspb.Message.setWrapperField(this, 46, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearAllowedTradeSide = function() {
  return this.setAllowedTradeSide(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasAllowedTradeSide = function() {
  return jspb.Message.getField(this, 46) != null;
};


/**
 * repeated TradingHour trading_hours = 47;
 * @return {!Array<!proto.tradecopier.TradingHour>}
 */
proto.tradecopier.Slave.prototype.getTradingHoursList = function() {
  return /** @type{!Array<!proto.tradecopier.TradingHour>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tradecopier.TradingHour, 47));
};


/**
 * @param {!Array<!proto.tradecopier.TradingHour>} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setTradingHoursList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 47, value);
};


/**
 * @param {!proto.tradecopier.TradingHour=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.TradingHour}
 */
proto.tradecopier.Slave.prototype.addTradingHours = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 47, opt_value, proto.tradecopier.TradingHour, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearTradingHoursList = function() {
  return this.setTradingHoursList([]);
};


/**
 * optional google.protobuf.StringValue magic_filter_type = 48;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.Slave.prototype.getMagicFilterType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 48));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setMagicFilterType = function(value) {
  return jspb.Message.setWrapperField(this, 48, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearMagicFilterType = function() {
  return this.setMagicFilterType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasMagicFilterType = function() {
  return jspb.Message.getField(this, 48) != null;
};


/**
 * optional google.protobuf.StringValue comment_filter_type = 49;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.Slave.prototype.getCommentFilterType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 49));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.Slave} returns this
*/
proto.tradecopier.Slave.prototype.setCommentFilterType = function(value) {
  return jspb.Message.setWrapperField(this, 49, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Slave} returns this
 */
proto.tradecopier.Slave.prototype.clearCommentFilterType = function() {
  return this.setCommentFilterType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Slave.prototype.hasCommentFilterType = function() {
  return jspb.Message.getField(this, 49) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.MasterOrderInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.MasterOrderInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.MasterOrderInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.MasterOrderInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
orderType: jspb.Message.getFieldWithDefault(msg, 1, ""),
symbol: jspb.Message.getFieldWithDefault(msg, 2, ""),
lots: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
openPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
takeProfit: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
stopLoss: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
magicNumber: jspb.Message.getFieldWithDefault(msg, 7, 0),
placedType: jspb.Message.getFieldWithDefault(msg, 8, ""),
expiration: jspb.Message.getFieldWithDefault(msg, 9, ""),
comment: jspb.Message.getFieldWithDefault(msg, 10, ""),
isPendingFill: jspb.Message.getBooleanFieldWithDefault(msg, 11, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.MasterOrderInfo}
 */
proto.tradecopier.MasterOrderInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.MasterOrderInfo;
  return proto.tradecopier.MasterOrderInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.MasterOrderInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.MasterOrderInfo}
 */
proto.tradecopier.MasterOrderInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLots(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOpenPrice(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTakeProfit(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStopLoss(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMagicNumber(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlacedType(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpiration(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPendingFill(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.MasterOrderInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.MasterOrderInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.MasterOrderInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.MasterOrderInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLots();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getOpenPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getTakeProfit();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getStopLoss();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getMagicNumber();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getPlacedType();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getExpiration();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getIsPendingFill();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
};


/**
 * optional string order_type = 1;
 * @return {string}
 */
proto.tradecopier.MasterOrderInfo.prototype.getOrderType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.MasterOrderInfo} returns this
 */
proto.tradecopier.MasterOrderInfo.prototype.setOrderType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string symbol = 2;
 * @return {string}
 */
proto.tradecopier.MasterOrderInfo.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.MasterOrderInfo} returns this
 */
proto.tradecopier.MasterOrderInfo.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double lots = 3;
 * @return {number}
 */
proto.tradecopier.MasterOrderInfo.prototype.getLots = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.MasterOrderInfo} returns this
 */
proto.tradecopier.MasterOrderInfo.prototype.setLots = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double open_price = 4;
 * @return {number}
 */
proto.tradecopier.MasterOrderInfo.prototype.getOpenPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.MasterOrderInfo} returns this
 */
proto.tradecopier.MasterOrderInfo.prototype.setOpenPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double take_profit = 5;
 * @return {number}
 */
proto.tradecopier.MasterOrderInfo.prototype.getTakeProfit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.MasterOrderInfo} returns this
 */
proto.tradecopier.MasterOrderInfo.prototype.setTakeProfit = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double stop_loss = 6;
 * @return {number}
 */
proto.tradecopier.MasterOrderInfo.prototype.getStopLoss = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.MasterOrderInfo} returns this
 */
proto.tradecopier.MasterOrderInfo.prototype.setStopLoss = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional int64 magic_number = 7;
 * @return {number}
 */
proto.tradecopier.MasterOrderInfo.prototype.getMagicNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.MasterOrderInfo} returns this
 */
proto.tradecopier.MasterOrderInfo.prototype.setMagicNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string placed_type = 8;
 * @return {string}
 */
proto.tradecopier.MasterOrderInfo.prototype.getPlacedType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.MasterOrderInfo} returns this
 */
proto.tradecopier.MasterOrderInfo.prototype.setPlacedType = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string expiration = 9;
 * @return {string}
 */
proto.tradecopier.MasterOrderInfo.prototype.getExpiration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.MasterOrderInfo} returns this
 */
proto.tradecopier.MasterOrderInfo.prototype.setExpiration = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string comment = 10;
 * @return {string}
 */
proto.tradecopier.MasterOrderInfo.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.MasterOrderInfo} returns this
 */
proto.tradecopier.MasterOrderInfo.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional bool is_pending_fill = 11;
 * @return {boolean}
 */
proto.tradecopier.MasterOrderInfo.prototype.getIsPendingFill = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tradecopier.MasterOrderInfo} returns this
 */
proto.tradecopier.MasterOrderInfo.prototype.setIsPendingFill = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.SimulateTradeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.SimulateTradeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.SimulateTradeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.SimulateTradeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
masterAccount: jspb.Message.getFieldWithDefault(msg, 2, ""),
slaveAccount: jspb.Message.getFieldWithDefault(msg, 3, ""),
slaveConfig: (f = msg.getSlaveConfig()) && proto.tradecopier.UpdatedSlaveConfig.toObject(includeInstance, f),
masterOrder: (f = msg.getMasterOrder()) && proto.tradecopier.MasterOrderInfo.toObject(includeInstance, f),
slaveSymbol: (f = msg.getSlaveSymbol()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.SimulateTradeReq}
 */
proto.tradecopier.SimulateTradeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.SimulateTradeReq;
  return proto.tradecopier.SimulateTradeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.SimulateTradeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.SimulateTradeReq}
 */
proto.tradecopier.SimulateTradeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveAccount(value);
      break;
    case 4:
      var value = new proto.tradecopier.UpdatedSlaveConfig;
      reader.readMessage(value,proto.tradecopier.UpdatedSlaveConfig.deserializeBinaryFromReader);
      msg.setSlaveConfig(value);
      break;
    case 5:
      var value = new proto.tradecopier.MasterOrderInfo;
      reader.readMessage(value,proto.tradecopier.MasterOrderInfo.deserializeBinaryFromReader);
      msg.setMasterOrder(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSlaveSymbol(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.SimulateTradeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.SimulateTradeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.SimulateTradeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.SimulateTradeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMasterAccount();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlaveAccount();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSlaveConfig();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.tradecopier.UpdatedSlaveConfig.serializeBinaryToWriter
    );
  }
  f = message.getMasterOrder();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.tradecopier.MasterOrderInfo.serializeBinaryToWriter
    );
  }
  f = message.getSlaveSymbol();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.SimulateTradeReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.SimulateTradeReq} returns this
 */
proto.tradecopier.SimulateTradeReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string master_account = 2;
 * @return {string}
 */
proto.tradecopier.SimulateTradeReq.prototype.getMasterAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.SimulateTradeReq} returns this
 */
proto.tradecopier.SimulateTradeReq.prototype.setMasterAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slave_account = 3;
 * @return {string}
 */
proto.tradecopier.SimulateTradeReq.prototype.getSlaveAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.SimulateTradeReq} returns this
 */
proto.tradecopier.SimulateTradeReq.prototype.setSlaveAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional UpdatedSlaveConfig slave_config = 4;
 * @return {?proto.tradecopier.UpdatedSlaveConfig}
 */
proto.tradecopier.SimulateTradeReq.prototype.getSlaveConfig = function() {
  return /** @type{?proto.tradecopier.UpdatedSlaveConfig} */ (
    jspb.Message.getWrapperField(this, proto.tradecopier.UpdatedSlaveConfig, 4));
};


/**
 * @param {?proto.tradecopier.UpdatedSlaveConfig|undefined} value
 * @return {!proto.tradecopier.SimulateTradeReq} returns this
*/
proto.tradecopier.SimulateTradeReq.prototype.setSlaveConfig = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SimulateTradeReq} returns this
 */
proto.tradecopier.SimulateTradeReq.prototype.clearSlaveConfig = function() {
  return this.setSlaveConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SimulateTradeReq.prototype.hasSlaveConfig = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional MasterOrderInfo master_order = 5;
 * @return {?proto.tradecopier.MasterOrderInfo}
 */
proto.tradecopier.SimulateTradeReq.prototype.getMasterOrder = function() {
  return /** @type{?proto.tradecopier.MasterOrderInfo} */ (
    jspb.Message.getWrapperField(this, proto.tradecopier.MasterOrderInfo, 5));
};


/**
 * @param {?proto.tradecopier.MasterOrderInfo|undefined} value
 * @return {!proto.tradecopier.SimulateTradeReq} returns this
*/
proto.tradecopier.SimulateTradeReq.prototype.setMasterOrder = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SimulateTradeReq} returns this
 */
proto.tradecopier.SimulateTradeReq.prototype.clearMasterOrder = function() {
  return this.setMasterOrder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SimulateTradeReq.prototype.hasMasterOrder = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue slave_symbol = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.SimulateTradeReq.prototype.getSlaveSymbol = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.SimulateTradeReq} returns this
*/
proto.tradecopier.SimulateTradeReq.prototype.setSlaveSymbol = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SimulateTradeReq} returns this
 */
proto.tradecopier.SimulateTradeReq.prototype.clearSlaveSymbol = function() {
  return this.setSlaveSymbol(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SimulateTradeReq.prototype.hasSlaveSymbol = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.SlaveOrder.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.SlaveOrder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.SlaveOrder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.SlaveOrder.toObject = function(includeInstance, msg) {
  var f, obj = {
symbol: jspb.Message.getFieldWithDefault(msg, 1, ""),
lots: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
type: jspb.Message.getFieldWithDefault(msg, 3, ""),
openPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
stopLoss: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
takeProfit: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
comment: jspb.Message.getFieldWithDefault(msg, 8, ""),
expiration: jspb.Message.getFieldWithDefault(msg, 9, ""),
placedType: jspb.Message.getFieldWithDefault(msg, 10, ""),
magicNumber: jspb.Message.getFieldWithDefault(msg, 12, 0),
fromPendingOrder: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
delayuntil: (f = msg.getDelayuntil()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
serverTimeZone: jspb.Message.getFieldWithDefault(msg, 19, 0),
tpSlConfigs: (f = msg.getTpSlConfigs()) && proto.tradecopier.TpSlConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.SlaveOrder}
 */
proto.tradecopier.SlaveOrder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.SlaveOrder;
  return proto.tradecopier.SlaveOrder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.SlaveOrder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.SlaveOrder}
 */
proto.tradecopier.SlaveOrder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLots(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOpenPrice(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStopLoss(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTakeProfit(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpiration(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlacedType(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMagicNumber(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFromPendingOrder(value);
      break;
    case 18:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDelayuntil(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setServerTimeZone(value);
      break;
    case 20:
      var value = new proto.tradecopier.TpSlConfig;
      reader.readMessage(value,proto.tradecopier.TpSlConfig.deserializeBinaryFromReader);
      msg.setTpSlConfigs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.SlaveOrder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.SlaveOrder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.SlaveOrder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.SlaveOrder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLots();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOpenPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getStopLoss();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getTakeProfit();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getExpiration();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPlacedType();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getMagicNumber();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getFromPendingOrder();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
  f = message.getDelayuntil();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getServerTimeZone();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
  f = message.getTpSlConfigs();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.tradecopier.TpSlConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional string symbol = 1;
 * @return {string}
 */
proto.tradecopier.SlaveOrder.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.SlaveOrder} returns this
 */
proto.tradecopier.SlaveOrder.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double lots = 2;
 * @return {number}
 */
proto.tradecopier.SlaveOrder.prototype.getLots = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.SlaveOrder} returns this
 */
proto.tradecopier.SlaveOrder.prototype.setLots = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string type = 3;
 * @return {string}
 */
proto.tradecopier.SlaveOrder.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.SlaveOrder} returns this
 */
proto.tradecopier.SlaveOrder.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double open_price = 4;
 * @return {number}
 */
proto.tradecopier.SlaveOrder.prototype.getOpenPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.SlaveOrder} returns this
 */
proto.tradecopier.SlaveOrder.prototype.setOpenPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double stop_loss = 6;
 * @return {number}
 */
proto.tradecopier.SlaveOrder.prototype.getStopLoss = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.SlaveOrder} returns this
 */
proto.tradecopier.SlaveOrder.prototype.setStopLoss = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double take_profit = 7;
 * @return {number}
 */
proto.tradecopier.SlaveOrder.prototype.getTakeProfit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.SlaveOrder} returns this
 */
proto.tradecopier.SlaveOrder.prototype.setTakeProfit = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional string comment = 8;
 * @return {string}
 */
proto.tradecopier.SlaveOrder.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.SlaveOrder} returns this
 */
proto.tradecopier.SlaveOrder.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string expiration = 9;
 * @return {string}
 */
proto.tradecopier.SlaveOrder.prototype.getExpiration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.SlaveOrder} returns this
 */
proto.tradecopier.SlaveOrder.prototype.setExpiration = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string placed_type = 10;
 * @return {string}
 */
proto.tradecopier.SlaveOrder.prototype.getPlacedType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.SlaveOrder} returns this
 */
proto.tradecopier.SlaveOrder.prototype.setPlacedType = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int64 magic_number = 12;
 * @return {number}
 */
proto.tradecopier.SlaveOrder.prototype.getMagicNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.SlaveOrder} returns this
 */
proto.tradecopier.SlaveOrder.prototype.setMagicNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional bool from_pending_order = 17;
 * @return {boolean}
 */
proto.tradecopier.SlaveOrder.prototype.getFromPendingOrder = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tradecopier.SlaveOrder} returns this
 */
proto.tradecopier.SlaveOrder.prototype.setFromPendingOrder = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


/**
 * optional google.protobuf.Timestamp delayUntil = 18;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.tradecopier.SlaveOrder.prototype.getDelayuntil = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 18));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.tradecopier.SlaveOrder} returns this
*/
proto.tradecopier.SlaveOrder.prototype.setDelayuntil = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SlaveOrder} returns this
 */
proto.tradecopier.SlaveOrder.prototype.clearDelayuntil = function() {
  return this.setDelayuntil(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SlaveOrder.prototype.hasDelayuntil = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional int32 server_time_zone = 19;
 * @return {number}
 */
proto.tradecopier.SlaveOrder.prototype.getServerTimeZone = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.SlaveOrder} returns this
 */
proto.tradecopier.SlaveOrder.prototype.setServerTimeZone = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional TpSlConfig tp_sl_configs = 20;
 * @return {?proto.tradecopier.TpSlConfig}
 */
proto.tradecopier.SlaveOrder.prototype.getTpSlConfigs = function() {
  return /** @type{?proto.tradecopier.TpSlConfig} */ (
    jspb.Message.getWrapperField(this, proto.tradecopier.TpSlConfig, 20));
};


/**
 * @param {?proto.tradecopier.TpSlConfig|undefined} value
 * @return {!proto.tradecopier.SlaveOrder} returns this
*/
proto.tradecopier.SlaveOrder.prototype.setTpSlConfigs = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SlaveOrder} returns this
 */
proto.tradecopier.SlaveOrder.prototype.clearTpSlConfigs = function() {
  return this.setTpSlConfigs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SlaveOrder.prototype.hasTpSlConfigs = function() {
  return jspb.Message.getField(this, 20) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.TpSlConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.TpSlConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.TpSlConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.TpSlConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
fixedTakeProfit: (f = msg.getFixedTakeProfit()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
fixedStopLoss: (f = msg.getFixedStopLoss()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
relativeTakeProfit: (f = msg.getRelativeTakeProfit()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
relativeStopLoss: (f = msg.getRelativeStopLoss()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.TpSlConfig}
 */
proto.tradecopier.TpSlConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.TpSlConfig;
  return proto.tradecopier.TpSlConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.TpSlConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.TpSlConfig}
 */
proto.tradecopier.TpSlConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedTakeProfit(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedStopLoss(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setRelativeTakeProfit(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setRelativeStopLoss(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.TpSlConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.TpSlConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.TpSlConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.TpSlConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFixedTakeProfit();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getFixedStopLoss();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getRelativeTakeProfit();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getRelativeStopLoss();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.DoubleValue fixed_take_profit = 1;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.TpSlConfig.prototype.getFixedTakeProfit = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 1));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.TpSlConfig} returns this
*/
proto.tradecopier.TpSlConfig.prototype.setFixedTakeProfit = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.TpSlConfig} returns this
 */
proto.tradecopier.TpSlConfig.prototype.clearFixedTakeProfit = function() {
  return this.setFixedTakeProfit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.TpSlConfig.prototype.hasFixedTakeProfit = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.DoubleValue fixed_stop_loss = 2;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.TpSlConfig.prototype.getFixedStopLoss = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 2));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.TpSlConfig} returns this
*/
proto.tradecopier.TpSlConfig.prototype.setFixedStopLoss = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.TpSlConfig} returns this
 */
proto.tradecopier.TpSlConfig.prototype.clearFixedStopLoss = function() {
  return this.setFixedStopLoss(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.TpSlConfig.prototype.hasFixedStopLoss = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.DoubleValue relative_take_profit = 3;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.TpSlConfig.prototype.getRelativeTakeProfit = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 3));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.TpSlConfig} returns this
*/
proto.tradecopier.TpSlConfig.prototype.setRelativeTakeProfit = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.TpSlConfig} returns this
 */
proto.tradecopier.TpSlConfig.prototype.clearRelativeTakeProfit = function() {
  return this.setRelativeTakeProfit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.TpSlConfig.prototype.hasRelativeTakeProfit = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.DoubleValue relative_stop_loss = 4;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.TpSlConfig.prototype.getRelativeStopLoss = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 4));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.TpSlConfig} returns this
*/
proto.tradecopier.TpSlConfig.prototype.setRelativeStopLoss = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.TpSlConfig} returns this
 */
proto.tradecopier.TpSlConfig.prototype.clearRelativeStopLoss = function() {
  return this.setRelativeStopLoss(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.TpSlConfig.prototype.hasRelativeStopLoss = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.SimulateTradeReply.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.SimulateTradeReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.SimulateTradeReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.SimulateTradeReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.SimulateTradeReply.toObject = function(includeInstance, msg) {
  var f, obj = {
orderInfo: (f = msg.getOrderInfo()) && proto.tradecopier.SlaveOrder.toObject(includeInstance, f),
logList: jspb.Message.toObjectList(msg.getLogList(),
    proto.tradecopier.Log.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.SimulateTradeReply}
 */
proto.tradecopier.SimulateTradeReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.SimulateTradeReply;
  return proto.tradecopier.SimulateTradeReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.SimulateTradeReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.SimulateTradeReply}
 */
proto.tradecopier.SimulateTradeReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tradecopier.SlaveOrder;
      reader.readMessage(value,proto.tradecopier.SlaveOrder.deserializeBinaryFromReader);
      msg.setOrderInfo(value);
      break;
    case 2:
      var value = new proto.tradecopier.Log;
      reader.readMessage(value,proto.tradecopier.Log.deserializeBinaryFromReader);
      msg.addLog(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.SimulateTradeReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.SimulateTradeReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.SimulateTradeReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.SimulateTradeReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.tradecopier.SlaveOrder.serializeBinaryToWriter
    );
  }
  f = message.getLogList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.tradecopier.Log.serializeBinaryToWriter
    );
  }
};


/**
 * optional SlaveOrder order_info = 1;
 * @return {?proto.tradecopier.SlaveOrder}
 */
proto.tradecopier.SimulateTradeReply.prototype.getOrderInfo = function() {
  return /** @type{?proto.tradecopier.SlaveOrder} */ (
    jspb.Message.getWrapperField(this, proto.tradecopier.SlaveOrder, 1));
};


/**
 * @param {?proto.tradecopier.SlaveOrder|undefined} value
 * @return {!proto.tradecopier.SimulateTradeReply} returns this
*/
proto.tradecopier.SimulateTradeReply.prototype.setOrderInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SimulateTradeReply} returns this
 */
proto.tradecopier.SimulateTradeReply.prototype.clearOrderInfo = function() {
  return this.setOrderInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SimulateTradeReply.prototype.hasOrderInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Log log = 2;
 * @return {!Array<!proto.tradecopier.Log>}
 */
proto.tradecopier.SimulateTradeReply.prototype.getLogList = function() {
  return /** @type{!Array<!proto.tradecopier.Log>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tradecopier.Log, 2));
};


/**
 * @param {!Array<!proto.tradecopier.Log>} value
 * @return {!proto.tradecopier.SimulateTradeReply} returns this
*/
proto.tradecopier.SimulateTradeReply.prototype.setLogList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.tradecopier.Log=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.Log}
 */
proto.tradecopier.SimulateTradeReply.prototype.addLog = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.tradecopier.Log, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.SimulateTradeReply} returns this
 */
proto.tradecopier.SimulateTradeReply.prototype.clearLogList = function() {
  return this.setLogList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.UpdateSlaveReq.repeatedFields_ = [26,29,40];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.UpdateSlaveReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.UpdateSlaveReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.UpdateSlaveReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdateSlaveReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
configId: jspb.Message.getFieldWithDefault(msg, 2, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 3, ""),
enable: (f = msg.getEnable()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
riskType: jspb.Message.getFieldWithDefault(msg, 5, 0),
fixedLotValue: (f = msg.getFixedLotValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
lotMultiplierValue: (f = msg.getLotMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
balanceMultiplierValue: (f = msg.getBalanceMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
copyStopLoss: (f = msg.getCopyStopLoss()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyTakeProfit: (f = msg.getCopyTakeProfit()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyPendingOrders: (f = msg.getCopyPendingOrders()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
forceMinimumLotSize: (f = msg.getForceMinimumLotSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyComment: (f = msg.getCopyComment()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
customComment: (f = msg.getCustomComment()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
forceMaximumLotSize: (f = msg.getForceMaximumLotSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
customPlacedType: (f = msg.getCustomPlacedType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
reverseTrade: (f = msg.getReverseTrade()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
strictClose: (f = msg.getStrictClose()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
considerContractSize: (f = msg.getConsiderContractSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyMagicNumber: (f = msg.getCopyMagicNumber()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
magicNumber: (f = msg.getMagicNumber()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
manageExisting: (f = msg.getManageExisting()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
lotRefinerValue: (f = msg.getLotRefinerValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
fixedBalanceMultiplierValue: (f = msg.getFixedBalanceMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
fixedMasterBalance: (f = msg.getFixedMasterBalance()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
magicFiltersList: jspb.Message.toObjectList(msg.getMagicFiltersList(),
    google_protobuf_wrappers_pb.Int64Value.toObject, includeInstance),
minDelayTime: (f = msg.getMinDelayTime()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
copyExpiryTime: (f = msg.getCopyExpiryTime()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
commentFiltersList: jspb.Message.toObjectList(msg.getCommentFiltersList(),
    google_protobuf_wrappers_pb.StringValue.toObject, includeInstance),
minLotFilter: (f = msg.getMinLotFilter()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
maxLotFilter: (f = msg.getMaxLotFilter()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
maxDelayTime: (f = msg.getMaxDelayTime()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
takeProfitPip: (f = msg.getTakeProfitPip()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
stopLossPip: (f = msg.getStopLossPip()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
slRefiner: (f = msg.getSlRefiner()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
tpRefiner: (f = msg.getTpRefiner()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
balancePercentageValue: (f = msg.getBalancePercentageValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
copyExistingTrades: (f = msg.getCopyExistingTrades()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
allowedTradeSide: (f = msg.getAllowedTradeSide()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
tradingHoursList: jspb.Message.toObjectList(msg.getTradingHoursList(),
    proto.tradecopier.TradingHour.toObject, includeInstance),
magicFilterType: jspb.Message.getFieldWithDefault(msg, 41, 0),
commentFilterType: jspb.Message.getFieldWithDefault(msg, 42, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.UpdateSlaveReq}
 */
proto.tradecopier.UpdateSlaveReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.UpdateSlaveReq;
  return proto.tradecopier.UpdateSlaveReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.UpdateSlaveReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.UpdateSlaveReq}
 */
proto.tradecopier.UpdateSlaveReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfigId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEnable(value);
      break;
    case 5:
      var value = /** @type {!proto.tradecopier.RISK_TYPE} */ (reader.readEnum());
      msg.setRiskType(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedLotValue(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLotMultiplierValue(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setBalanceMultiplierValue(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyStopLoss(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyTakeProfit(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyPendingOrders(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setForceMinimumLotSize(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyComment(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomComment(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setForceMaximumLotSize(value);
      break;
    case 16:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomPlacedType(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setReverseTrade(value);
      break;
    case 18:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setStrictClose(value);
      break;
    case 19:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setConsiderContractSize(value);
      break;
    case 20:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyMagicNumber(value);
      break;
    case 21:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMagicNumber(value);
      break;
    case 22:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setManageExisting(value);
      break;
    case 23:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLotRefinerValue(value);
      break;
    case 24:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedBalanceMultiplierValue(value);
      break;
    case 25:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedMasterBalance(value);
      break;
    case 26:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.addMagicFilters(value);
      break;
    case 27:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMinDelayTime(value);
      break;
    case 28:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyExpiryTime(value);
      break;
    case 29:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.addCommentFilters(value);
      break;
    case 30:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMinLotFilter(value);
      break;
    case 31:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMaxLotFilter(value);
      break;
    case 32:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMaxDelayTime(value);
      break;
    case 33:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTakeProfitPip(value);
      break;
    case 34:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setStopLossPip(value);
      break;
    case 35:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setSlRefiner(value);
      break;
    case 36:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTpRefiner(value);
      break;
    case 37:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setBalancePercentageValue(value);
      break;
    case 38:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyExistingTrades(value);
      break;
    case 39:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAllowedTradeSide(value);
      break;
    case 40:
      var value = new proto.tradecopier.TradingHour;
      reader.readMessage(value,proto.tradecopier.TradingHour.deserializeBinaryFromReader);
      msg.addTradingHours(value);
      break;
    case 41:
      var value = /** @type {!proto.tradecopier.FilterType} */ (reader.readEnum());
      msg.setMagicFilterType(value);
      break;
    case 42:
      var value = /** @type {!proto.tradecopier.FilterType} */ (reader.readEnum());
      msg.setCommentFilterType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.UpdateSlaveReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.UpdateSlaveReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.UpdateSlaveReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdateSlaveReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConfigId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEnable();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getRiskType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getFixedLotValue();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getLotMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getBalanceMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyStopLoss();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyTakeProfit();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyPendingOrders();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getForceMinimumLotSize();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyComment();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomComment();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getForceMaximumLotSize();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomPlacedType();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getReverseTrade();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getStrictClose();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getConsiderContractSize();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyMagicNumber();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getMagicNumber();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getManageExisting();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getLotRefinerValue();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getFixedBalanceMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getFixedMasterBalance();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMagicFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      26,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getMinDelayTime();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getCopyExpiryTime();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCommentFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      29,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getMinLotFilter();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxLotFilter();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxDelayTime();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getTakeProfitPip();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getStopLossPip();
  if (f != null) {
    writer.writeMessage(
      34,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getSlRefiner();
  if (f != null) {
    writer.writeMessage(
      35,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTpRefiner();
  if (f != null) {
    writer.writeMessage(
      36,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getBalancePercentageValue();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyExistingTrades();
  if (f != null) {
    writer.writeMessage(
      38,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getAllowedTradeSide();
  if (f != null) {
    writer.writeMessage(
      39,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTradingHoursList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      40,
      f,
      proto.tradecopier.TradingHour.serializeBinaryToWriter
    );
  }
  f = message.getMagicFilterType();
  if (f !== 0.0) {
    writer.writeEnum(
      41,
      f
    );
  }
  f = message.getCommentFilterType();
  if (f !== 0.0) {
    writer.writeEnum(
      42,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string config_id = 2;
 * @return {string}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getConfigId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.setConfigId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slave_id = 3;
 * @return {string}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.BoolValue enable = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getEnable = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setEnable = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearEnable = function() {
  return this.setEnable(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasEnable = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional RISK_TYPE risk_type = 5;
 * @return {!proto.tradecopier.RISK_TYPE}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getRiskType = function() {
  return /** @type {!proto.tradecopier.RISK_TYPE} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.tradecopier.RISK_TYPE} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.setRiskType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional google.protobuf.DoubleValue fixed_lot_value = 6;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getFixedLotValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 6));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setFixedLotValue = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearFixedLotValue = function() {
  return this.setFixedLotValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasFixedLotValue = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.DoubleValue lot_multiplier_value = 7;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getLotMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 7));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setLotMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearLotMultiplierValue = function() {
  return this.setLotMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasLotMultiplierValue = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.DoubleValue balance_multiplier_value = 8;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getBalanceMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 8));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setBalanceMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearBalanceMultiplierValue = function() {
  return this.setBalanceMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasBalanceMultiplierValue = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.BoolValue copy_stop_loss = 9;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getCopyStopLoss = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 9));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setCopyStopLoss = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearCopyStopLoss = function() {
  return this.setCopyStopLoss(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasCopyStopLoss = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.BoolValue copy_take_profit = 10;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getCopyTakeProfit = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 10));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setCopyTakeProfit = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearCopyTakeProfit = function() {
  return this.setCopyTakeProfit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasCopyTakeProfit = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.BoolValue copy_pending_orders = 11;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getCopyPendingOrders = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 11));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setCopyPendingOrders = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearCopyPendingOrders = function() {
  return this.setCopyPendingOrders(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasCopyPendingOrders = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.BoolValue force_minimum_lot_size = 12;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getForceMinimumLotSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 12));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setForceMinimumLotSize = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearForceMinimumLotSize = function() {
  return this.setForceMinimumLotSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasForceMinimumLotSize = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.BoolValue copy_comment = 13;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getCopyComment = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 13));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setCopyComment = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearCopyComment = function() {
  return this.setCopyComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasCopyComment = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.StringValue custom_comment = 14;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getCustomComment = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 14));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setCustomComment = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearCustomComment = function() {
  return this.setCustomComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasCustomComment = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.BoolValue force_maximum_lot_size = 15;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getForceMaximumLotSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 15));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setForceMaximumLotSize = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearForceMaximumLotSize = function() {
  return this.setForceMaximumLotSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasForceMaximumLotSize = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.StringValue custom_placed_type = 16;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getCustomPlacedType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 16));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setCustomPlacedType = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearCustomPlacedType = function() {
  return this.setCustomPlacedType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasCustomPlacedType = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.BoolValue reverse_trade = 17;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getReverseTrade = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 17));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setReverseTrade = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearReverseTrade = function() {
  return this.setReverseTrade(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasReverseTrade = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.BoolValue strict_close = 18;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getStrictClose = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 18));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setStrictClose = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearStrictClose = function() {
  return this.setStrictClose(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasStrictClose = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional google.protobuf.BoolValue consider_contract_size = 19;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getConsiderContractSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 19));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setConsiderContractSize = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearConsiderContractSize = function() {
  return this.setConsiderContractSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasConsiderContractSize = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional google.protobuf.BoolValue copy_magic_number = 20;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getCopyMagicNumber = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 20));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setCopyMagicNumber = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearCopyMagicNumber = function() {
  return this.setCopyMagicNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasCopyMagicNumber = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional google.protobuf.Int64Value magic_number = 21;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getMagicNumber = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 21));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setMagicNumber = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearMagicNumber = function() {
  return this.setMagicNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasMagicNumber = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional google.protobuf.BoolValue manage_existing = 22;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getManageExisting = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 22));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setManageExisting = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearManageExisting = function() {
  return this.setManageExisting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasManageExisting = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.DoubleValue lot_refiner_value = 23;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getLotRefinerValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 23));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setLotRefinerValue = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearLotRefinerValue = function() {
  return this.setLotRefinerValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasLotRefinerValue = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional google.protobuf.DoubleValue fixed_balance_multiplier_value = 24;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getFixedBalanceMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 24));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setFixedBalanceMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearFixedBalanceMultiplierValue = function() {
  return this.setFixedBalanceMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasFixedBalanceMultiplierValue = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional google.protobuf.DoubleValue fixed_master_balance = 25;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getFixedMasterBalance = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 25));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setFixedMasterBalance = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearFixedMasterBalance = function() {
  return this.setFixedMasterBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasFixedMasterBalance = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * repeated google.protobuf.Int64Value magic_filters = 26;
 * @return {!Array<!proto.google.protobuf.Int64Value>}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getMagicFiltersList = function() {
  return /** @type{!Array<!proto.google.protobuf.Int64Value>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 26));
};


/**
 * @param {!Array<!proto.google.protobuf.Int64Value>} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setMagicFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 26, value);
};


/**
 * @param {!proto.google.protobuf.Int64Value=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Int64Value}
 */
proto.tradecopier.UpdateSlaveReq.prototype.addMagicFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 26, opt_value, proto.google.protobuf.Int64Value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearMagicFiltersList = function() {
  return this.setMagicFiltersList([]);
};


/**
 * optional google.protobuf.Int64Value min_delay_time = 27;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getMinDelayTime = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 27));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setMinDelayTime = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearMinDelayTime = function() {
  return this.setMinDelayTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasMinDelayTime = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional google.protobuf.BoolValue copy_expiry_time = 28;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getCopyExpiryTime = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 28));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setCopyExpiryTime = function(value) {
  return jspb.Message.setWrapperField(this, 28, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearCopyExpiryTime = function() {
  return this.setCopyExpiryTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasCopyExpiryTime = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * repeated google.protobuf.StringValue comment_filters = 29;
 * @return {!Array<!proto.google.protobuf.StringValue>}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getCommentFiltersList = function() {
  return /** @type{!Array<!proto.google.protobuf.StringValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_wrappers_pb.StringValue, 29));
};


/**
 * @param {!Array<!proto.google.protobuf.StringValue>} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setCommentFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 29, value);
};


/**
 * @param {!proto.google.protobuf.StringValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.StringValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.addCommentFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 29, opt_value, proto.google.protobuf.StringValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearCommentFiltersList = function() {
  return this.setCommentFiltersList([]);
};


/**
 * optional google.protobuf.DoubleValue min_lot_filter = 30;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getMinLotFilter = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 30));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setMinLotFilter = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearMinLotFilter = function() {
  return this.setMinLotFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasMinLotFilter = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional google.protobuf.DoubleValue max_lot_filter = 31;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getMaxLotFilter = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 31));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setMaxLotFilter = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearMaxLotFilter = function() {
  return this.setMaxLotFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasMaxLotFilter = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional google.protobuf.Int64Value max_delay_time = 32;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getMaxDelayTime = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 32));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setMaxDelayTime = function(value) {
  return jspb.Message.setWrapperField(this, 32, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearMaxDelayTime = function() {
  return this.setMaxDelayTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasMaxDelayTime = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional google.protobuf.DoubleValue take_profit_pip = 33;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getTakeProfitPip = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 33));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setTakeProfitPip = function(value) {
  return jspb.Message.setWrapperField(this, 33, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearTakeProfitPip = function() {
  return this.setTakeProfitPip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasTakeProfitPip = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional google.protobuf.DoubleValue stop_loss_pip = 34;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getStopLossPip = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 34));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setStopLossPip = function(value) {
  return jspb.Message.setWrapperField(this, 34, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearStopLossPip = function() {
  return this.setStopLossPip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasStopLossPip = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional google.protobuf.DoubleValue sl_refiner = 35;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getSlRefiner = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 35));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setSlRefiner = function(value) {
  return jspb.Message.setWrapperField(this, 35, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearSlRefiner = function() {
  return this.setSlRefiner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasSlRefiner = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional google.protobuf.DoubleValue tp_refiner = 36;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getTpRefiner = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 36));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setTpRefiner = function(value) {
  return jspb.Message.setWrapperField(this, 36, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearTpRefiner = function() {
  return this.setTpRefiner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasTpRefiner = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional google.protobuf.DoubleValue balance_percentage_value = 37;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getBalancePercentageValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 37));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setBalancePercentageValue = function(value) {
  return jspb.Message.setWrapperField(this, 37, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearBalancePercentageValue = function() {
  return this.setBalancePercentageValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasBalancePercentageValue = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional google.protobuf.BoolValue copy_existing_trades = 38;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getCopyExistingTrades = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 38));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setCopyExistingTrades = function(value) {
  return jspb.Message.setWrapperField(this, 38, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearCopyExistingTrades = function() {
  return this.setCopyExistingTrades(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasCopyExistingTrades = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional google.protobuf.StringValue allowed_trade_side = 39;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getAllowedTradeSide = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 39));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setAllowedTradeSide = function(value) {
  return jspb.Message.setWrapperField(this, 39, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearAllowedTradeSide = function() {
  return this.setAllowedTradeSide(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSlaveReq.prototype.hasAllowedTradeSide = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * repeated TradingHour trading_hours = 40;
 * @return {!Array<!proto.tradecopier.TradingHour>}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getTradingHoursList = function() {
  return /** @type{!Array<!proto.tradecopier.TradingHour>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tradecopier.TradingHour, 40));
};


/**
 * @param {!Array<!proto.tradecopier.TradingHour>} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
*/
proto.tradecopier.UpdateSlaveReq.prototype.setTradingHoursList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 40, value);
};


/**
 * @param {!proto.tradecopier.TradingHour=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.TradingHour}
 */
proto.tradecopier.UpdateSlaveReq.prototype.addTradingHours = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 40, opt_value, proto.tradecopier.TradingHour, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.clearTradingHoursList = function() {
  return this.setTradingHoursList([]);
};


/**
 * optional FilterType magic_filter_type = 41;
 * @return {!proto.tradecopier.FilterType}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getMagicFilterType = function() {
  return /** @type {!proto.tradecopier.FilterType} */ (jspb.Message.getFieldWithDefault(this, 41, 0));
};


/**
 * @param {!proto.tradecopier.FilterType} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.setMagicFilterType = function(value) {
  return jspb.Message.setProto3EnumField(this, 41, value);
};


/**
 * optional FilterType comment_filter_type = 42;
 * @return {!proto.tradecopier.FilterType}
 */
proto.tradecopier.UpdateSlaveReq.prototype.getCommentFilterType = function() {
  return /** @type {!proto.tradecopier.FilterType} */ (jspb.Message.getFieldWithDefault(this, 42, 0));
};


/**
 * @param {!proto.tradecopier.FilterType} value
 * @return {!proto.tradecopier.UpdateSlaveReq} returns this
 */
proto.tradecopier.UpdateSlaveReq.prototype.setCommentFilterType = function(value) {
  return jspb.Message.setProto3EnumField(this, 42, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.UpdateSlaveReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.UpdateSlaveReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.UpdateSlaveReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdateSlaveReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.UpdateSlaveReply}
 */
proto.tradecopier.UpdateSlaveReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.UpdateSlaveReply;
  return proto.tradecopier.UpdateSlaveReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.UpdateSlaveReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.UpdateSlaveReply}
 */
proto.tradecopier.UpdateSlaveReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.UpdateSlaveReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.UpdateSlaveReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.UpdateSlaveReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdateSlaveReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.ListSymbolMappingsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.ListSymbolMappingsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.ListSymbolMappingsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.ListSymbolMappingsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.ListSymbolMappingsReq}
 */
proto.tradecopier.ListSymbolMappingsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.ListSymbolMappingsReq;
  return proto.tradecopier.ListSymbolMappingsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.ListSymbolMappingsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.ListSymbolMappingsReq}
 */
proto.tradecopier.ListSymbolMappingsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.ListSymbolMappingsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.ListSymbolMappingsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.ListSymbolMappingsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.ListSymbolMappingsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.ListSymbolMappingsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.ListSymbolMappingsReq} returns this
 */
proto.tradecopier.ListSymbolMappingsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slave_id = 2;
 * @return {string}
 */
proto.tradecopier.ListSymbolMappingsReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.ListSymbolMappingsReq} returns this
 */
proto.tradecopier.ListSymbolMappingsReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.ListSymbolMappingsReply.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.ListSymbolMappingsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.ListSymbolMappingsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.ListSymbolMappingsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.ListSymbolMappingsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
slaveId: jspb.Message.getFieldWithDefault(msg, 1, ""),
mappingsList: jspb.Message.toObjectList(msg.getMappingsList(),
    proto.tradecopier.Mapping.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.ListSymbolMappingsReply}
 */
proto.tradecopier.ListSymbolMappingsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.ListSymbolMappingsReply;
  return proto.tradecopier.ListSymbolMappingsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.ListSymbolMappingsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.ListSymbolMappingsReply}
 */
proto.tradecopier.ListSymbolMappingsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 2:
      var value = new proto.tradecopier.Mapping;
      reader.readMessage(value,proto.tradecopier.Mapping.deserializeBinaryFromReader);
      msg.addMappings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.ListSymbolMappingsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.ListSymbolMappingsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.ListSymbolMappingsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.ListSymbolMappingsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMappingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.tradecopier.Mapping.serializeBinaryToWriter
    );
  }
};


/**
 * optional string slave_id = 1;
 * @return {string}
 */
proto.tradecopier.ListSymbolMappingsReply.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.ListSymbolMappingsReply} returns this
 */
proto.tradecopier.ListSymbolMappingsReply.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Mapping mappings = 2;
 * @return {!Array<!proto.tradecopier.Mapping>}
 */
proto.tradecopier.ListSymbolMappingsReply.prototype.getMappingsList = function() {
  return /** @type{!Array<!proto.tradecopier.Mapping>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tradecopier.Mapping, 2));
};


/**
 * @param {!Array<!proto.tradecopier.Mapping>} value
 * @return {!proto.tradecopier.ListSymbolMappingsReply} returns this
*/
proto.tradecopier.ListSymbolMappingsReply.prototype.setMappingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.tradecopier.Mapping=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.Mapping}
 */
proto.tradecopier.ListSymbolMappingsReply.prototype.addMappings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.tradecopier.Mapping, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.ListSymbolMappingsReply} returns this
 */
proto.tradecopier.ListSymbolMappingsReply.prototype.clearMappingsList = function() {
  return this.setMappingsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.Mapping.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.Mapping.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.Mapping} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.Mapping.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
master: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.Mapping}
 */
proto.tradecopier.Mapping.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.Mapping;
  return proto.tradecopier.Mapping.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.Mapping} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.Mapping}
 */
proto.tradecopier.Mapping.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMaster(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.Mapping.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.Mapping.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.Mapping} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.Mapping.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMaster();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.tradecopier.Mapping.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.Mapping} returns this
 */
proto.tradecopier.Mapping.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.tradecopier.Mapping.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.Mapping} returns this
 */
proto.tradecopier.Mapping.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string master = 3;
 * @return {string}
 */
proto.tradecopier.Mapping.prototype.getMaster = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.Mapping} returns this
 */
proto.tradecopier.Mapping.prototype.setMaster = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.AddSymbolMappingReq.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AddSymbolMappingReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AddSymbolMappingReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AddSymbolMappingReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AddSymbolMappingReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 2, ""),
mappingsList: jspb.Message.toObjectList(msg.getMappingsList(),
    proto.tradecopier.MappingReq.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AddSymbolMappingReq}
 */
proto.tradecopier.AddSymbolMappingReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AddSymbolMappingReq;
  return proto.tradecopier.AddSymbolMappingReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AddSymbolMappingReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AddSymbolMappingReq}
 */
proto.tradecopier.AddSymbolMappingReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 3:
      var value = new proto.tradecopier.MappingReq;
      reader.readMessage(value,proto.tradecopier.MappingReq.deserializeBinaryFromReader);
      msg.addMappings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AddSymbolMappingReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AddSymbolMappingReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AddSymbolMappingReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AddSymbolMappingReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMappingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.tradecopier.MappingReq.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.AddSymbolMappingReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AddSymbolMappingReq} returns this
 */
proto.tradecopier.AddSymbolMappingReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slave_id = 2;
 * @return {string}
 */
proto.tradecopier.AddSymbolMappingReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AddSymbolMappingReq} returns this
 */
proto.tradecopier.AddSymbolMappingReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated MappingReq mappings = 3;
 * @return {!Array<!proto.tradecopier.MappingReq>}
 */
proto.tradecopier.AddSymbolMappingReq.prototype.getMappingsList = function() {
  return /** @type{!Array<!proto.tradecopier.MappingReq>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tradecopier.MappingReq, 3));
};


/**
 * @param {!Array<!proto.tradecopier.MappingReq>} value
 * @return {!proto.tradecopier.AddSymbolMappingReq} returns this
*/
proto.tradecopier.AddSymbolMappingReq.prototype.setMappingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.tradecopier.MappingReq=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.MappingReq}
 */
proto.tradecopier.AddSymbolMappingReq.prototype.addMappings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.tradecopier.MappingReq, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.AddSymbolMappingReq} returns this
 */
proto.tradecopier.AddSymbolMappingReq.prototype.clearMappingsList = function() {
  return this.setMappingsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.MappingReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.MappingReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.MappingReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.MappingReq.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
master: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.MappingReq}
 */
proto.tradecopier.MappingReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.MappingReq;
  return proto.tradecopier.MappingReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.MappingReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.MappingReq}
 */
proto.tradecopier.MappingReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMaster(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.MappingReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.MappingReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.MappingReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.MappingReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMaster();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.tradecopier.MappingReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.MappingReq} returns this
 */
proto.tradecopier.MappingReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string master = 2;
 * @return {string}
 */
proto.tradecopier.MappingReq.prototype.getMaster = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.MappingReq} returns this
 */
proto.tradecopier.MappingReq.prototype.setMaster = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AddSymbolMappingReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AddSymbolMappingReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AddSymbolMappingReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AddSymbolMappingReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AddSymbolMappingReply}
 */
proto.tradecopier.AddSymbolMappingReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AddSymbolMappingReply;
  return proto.tradecopier.AddSymbolMappingReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AddSymbolMappingReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AddSymbolMappingReply}
 */
proto.tradecopier.AddSymbolMappingReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AddSymbolMappingReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AddSymbolMappingReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AddSymbolMappingReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AddSymbolMappingReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.DeleteSymbolMappingReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.DeleteSymbolMappingReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.DeleteSymbolMappingReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.DeleteSymbolMappingReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 2, ""),
symbolId: jspb.Message.getFieldWithDefault(msg, 4, 0),
deleteAll: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.DeleteSymbolMappingReq}
 */
proto.tradecopier.DeleteSymbolMappingReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.DeleteSymbolMappingReq;
  return proto.tradecopier.DeleteSymbolMappingReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.DeleteSymbolMappingReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.DeleteSymbolMappingReq}
 */
proto.tradecopier.DeleteSymbolMappingReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSymbolId(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeleteAll(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.DeleteSymbolMappingReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.DeleteSymbolMappingReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.DeleteSymbolMappingReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.DeleteSymbolMappingReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbolId();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getDeleteAll();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.DeleteSymbolMappingReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.DeleteSymbolMappingReq} returns this
 */
proto.tradecopier.DeleteSymbolMappingReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slave_id = 2;
 * @return {string}
 */
proto.tradecopier.DeleteSymbolMappingReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.DeleteSymbolMappingReq} returns this
 */
proto.tradecopier.DeleteSymbolMappingReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 symbol_id = 4;
 * @return {number}
 */
proto.tradecopier.DeleteSymbolMappingReq.prototype.getSymbolId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.DeleteSymbolMappingReq} returns this
 */
proto.tradecopier.DeleteSymbolMappingReq.prototype.setSymbolId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool delete_all = 5;
 * @return {boolean}
 */
proto.tradecopier.DeleteSymbolMappingReq.prototype.getDeleteAll = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tradecopier.DeleteSymbolMappingReq} returns this
 */
proto.tradecopier.DeleteSymbolMappingReq.prototype.setDeleteAll = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.DeleteSymbolMappingReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.DeleteSymbolMappingReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.DeleteSymbolMappingReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.DeleteSymbolMappingReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.DeleteSymbolMappingReply}
 */
proto.tradecopier.DeleteSymbolMappingReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.DeleteSymbolMappingReply;
  return proto.tradecopier.DeleteSymbolMappingReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.DeleteSymbolMappingReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.DeleteSymbolMappingReply}
 */
proto.tradecopier.DeleteSymbolMappingReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.DeleteSymbolMappingReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.DeleteSymbolMappingReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.DeleteSymbolMappingReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.DeleteSymbolMappingReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.IntDeleteMasterSlavesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.IntDeleteMasterSlavesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.IntDeleteMasterSlavesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntDeleteMasterSlavesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.IntDeleteMasterSlavesReq}
 */
proto.tradecopier.IntDeleteMasterSlavesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.IntDeleteMasterSlavesReq;
  return proto.tradecopier.IntDeleteMasterSlavesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.IntDeleteMasterSlavesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.IntDeleteMasterSlavesReq}
 */
proto.tradecopier.IntDeleteMasterSlavesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.IntDeleteMasterSlavesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.IntDeleteMasterSlavesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.IntDeleteMasterSlavesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntDeleteMasterSlavesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.IntDeleteMasterSlavesReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.IntDeleteMasterSlavesReq} returns this
 */
proto.tradecopier.IntDeleteMasterSlavesReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.tradecopier.IntDeleteMasterSlavesReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.IntDeleteMasterSlavesReq} returns this
 */
proto.tradecopier.IntDeleteMasterSlavesReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.IntDeleteMasterSlavesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.IntDeleteMasterSlavesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.IntDeleteMasterSlavesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntDeleteMasterSlavesReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.IntDeleteMasterSlavesReply}
 */
proto.tradecopier.IntDeleteMasterSlavesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.IntDeleteMasterSlavesReply;
  return proto.tradecopier.IntDeleteMasterSlavesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.IntDeleteMasterSlavesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.IntDeleteMasterSlavesReply}
 */
proto.tradecopier.IntDeleteMasterSlavesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.IntDeleteMasterSlavesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.IntDeleteMasterSlavesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.IntDeleteMasterSlavesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntDeleteMasterSlavesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.IntGetUserMasterAccountsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.IntGetUserMasterAccountsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.IntGetUserMasterAccountsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntGetUserMasterAccountsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.IntGetUserMasterAccountsReq}
 */
proto.tradecopier.IntGetUserMasterAccountsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.IntGetUserMasterAccountsReq;
  return proto.tradecopier.IntGetUserMasterAccountsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.IntGetUserMasterAccountsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.IntGetUserMasterAccountsReq}
 */
proto.tradecopier.IntGetUserMasterAccountsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.IntGetUserMasterAccountsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.IntGetUserMasterAccountsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.IntGetUserMasterAccountsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntGetUserMasterAccountsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.IntGetUserMasterAccountsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.IntGetUserMasterAccountsReq} returns this
 */
proto.tradecopier.IntGetUserMasterAccountsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.IntGetUserMasterAccountsReply.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.IntGetUserMasterAccountsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.IntGetUserMasterAccountsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.IntGetUserMasterAccountsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntGetUserMasterAccountsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
mastersList: jspb.Message.toObjectList(msg.getMastersList(),
    proto.tradecopier.MasterMeta.toObject, includeInstance),
copiedExistingTradesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.IntGetUserMasterAccountsReply}
 */
proto.tradecopier.IntGetUserMasterAccountsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.IntGetUserMasterAccountsReply;
  return proto.tradecopier.IntGetUserMasterAccountsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.IntGetUserMasterAccountsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.IntGetUserMasterAccountsReply}
 */
proto.tradecopier.IntGetUserMasterAccountsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tradecopier.MasterMeta;
      reader.readMessage(value,proto.tradecopier.MasterMeta.deserializeBinaryFromReader);
      msg.addMasters(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addCopiedExistingTrades(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.IntGetUserMasterAccountsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.IntGetUserMasterAccountsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.IntGetUserMasterAccountsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntGetUserMasterAccountsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMastersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tradecopier.MasterMeta.serializeBinaryToWriter
    );
  }
  f = message.getCopiedExistingTradesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated MasterMeta masters = 1;
 * @return {!Array<!proto.tradecopier.MasterMeta>}
 */
proto.tradecopier.IntGetUserMasterAccountsReply.prototype.getMastersList = function() {
  return /** @type{!Array<!proto.tradecopier.MasterMeta>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tradecopier.MasterMeta, 1));
};


/**
 * @param {!Array<!proto.tradecopier.MasterMeta>} value
 * @return {!proto.tradecopier.IntGetUserMasterAccountsReply} returns this
*/
proto.tradecopier.IntGetUserMasterAccountsReply.prototype.setMastersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tradecopier.MasterMeta=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.MasterMeta}
 */
proto.tradecopier.IntGetUserMasterAccountsReply.prototype.addMasters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tradecopier.MasterMeta, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.IntGetUserMasterAccountsReply} returns this
 */
proto.tradecopier.IntGetUserMasterAccountsReply.prototype.clearMastersList = function() {
  return this.setMastersList([]);
};


/**
 * repeated string copied_existing_trades = 2;
 * @return {!Array<string>}
 */
proto.tradecopier.IntGetUserMasterAccountsReply.prototype.getCopiedExistingTradesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.tradecopier.IntGetUserMasterAccountsReply} returns this
 */
proto.tradecopier.IntGetUserMasterAccountsReply.prototype.setCopiedExistingTradesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.IntGetUserMasterAccountsReply} returns this
 */
proto.tradecopier.IntGetUserMasterAccountsReply.prototype.addCopiedExistingTrades = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.IntGetUserMasterAccountsReply} returns this
 */
proto.tradecopier.IntGetUserMasterAccountsReply.prototype.clearCopiedExistingTradesList = function() {
  return this.setCopiedExistingTradesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.IntGetLogsReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.IntGetLogsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.IntGetLogsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.IntGetLogsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntGetLogsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
masterTicketsList: jspb.Message.toObjectList(msg.getMasterTicketsList(),
    proto.tradecopier.MasterTicket.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.IntGetLogsReq}
 */
proto.tradecopier.IntGetLogsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.IntGetLogsReq;
  return proto.tradecopier.IntGetLogsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.IntGetLogsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.IntGetLogsReq}
 */
proto.tradecopier.IntGetLogsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tradecopier.MasterTicket;
      reader.readMessage(value,proto.tradecopier.MasterTicket.deserializeBinaryFromReader);
      msg.addMasterTickets(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.IntGetLogsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.IntGetLogsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.IntGetLogsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntGetLogsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMasterTicketsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tradecopier.MasterTicket.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MasterTicket master_tickets = 1;
 * @return {!Array<!proto.tradecopier.MasterTicket>}
 */
proto.tradecopier.IntGetLogsReq.prototype.getMasterTicketsList = function() {
  return /** @type{!Array<!proto.tradecopier.MasterTicket>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tradecopier.MasterTicket, 1));
};


/**
 * @param {!Array<!proto.tradecopier.MasterTicket>} value
 * @return {!proto.tradecopier.IntGetLogsReq} returns this
*/
proto.tradecopier.IntGetLogsReq.prototype.setMasterTicketsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tradecopier.MasterTicket=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.MasterTicket}
 */
proto.tradecopier.IntGetLogsReq.prototype.addMasterTickets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tradecopier.MasterTicket, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.IntGetLogsReq} returns this
 */
proto.tradecopier.IntGetLogsReq.prototype.clearMasterTicketsList = function() {
  return this.setMasterTicketsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.MasterTicket.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.MasterTicket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.MasterTicket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.MasterTicket.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
ticket: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.MasterTicket}
 */
proto.tradecopier.MasterTicket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.MasterTicket;
  return proto.tradecopier.MasterTicket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.MasterTicket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.MasterTicket}
 */
proto.tradecopier.MasterTicket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicket(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.MasterTicket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.MasterTicket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.MasterTicket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.MasterTicket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicket();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.tradecopier.MasterTicket.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.MasterTicket} returns this
 */
proto.tradecopier.MasterTicket.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticket = 2;
 * @return {string}
 */
proto.tradecopier.MasterTicket.prototype.getTicket = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.MasterTicket} returns this
 */
proto.tradecopier.MasterTicket.prototype.setTicket = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.IntGetLogsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.IntGetLogsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.IntGetLogsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.IntGetLogsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntGetLogsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
logsList: jspb.Message.toObjectList(msg.getLogsList(),
    proto.tradecopier.Log.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.IntGetLogsReply}
 */
proto.tradecopier.IntGetLogsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.IntGetLogsReply;
  return proto.tradecopier.IntGetLogsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.IntGetLogsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.IntGetLogsReply}
 */
proto.tradecopier.IntGetLogsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tradecopier.Log;
      reader.readMessage(value,proto.tradecopier.Log.deserializeBinaryFromReader);
      msg.addLogs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.IntGetLogsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.IntGetLogsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.IntGetLogsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntGetLogsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLogsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tradecopier.Log.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Log logs = 1;
 * @return {!Array<!proto.tradecopier.Log>}
 */
proto.tradecopier.IntGetLogsReply.prototype.getLogsList = function() {
  return /** @type{!Array<!proto.tradecopier.Log>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tradecopier.Log, 1));
};


/**
 * @param {!Array<!proto.tradecopier.Log>} value
 * @return {!proto.tradecopier.IntGetLogsReply} returns this
*/
proto.tradecopier.IntGetLogsReply.prototype.setLogsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tradecopier.Log=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.Log}
 */
proto.tradecopier.IntGetLogsReply.prototype.addLogs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tradecopier.Log, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.IntGetLogsReply} returns this
 */
proto.tradecopier.IntGetLogsReply.prototype.clearLogsList = function() {
  return this.setLogsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.Log.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.Log.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.Log} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.Log.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
type: jspb.Message.getFieldWithDefault(msg, 2, ""),
masterTicket: jspb.Message.getFieldWithDefault(msg, 3, ""),
error: (f = msg.getError()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
accountId: jspb.Message.getFieldWithDefault(msg, 5, ""),
level: jspb.Message.getFieldWithDefault(msg, 6, ""),
masterAccountId: jspb.Message.getFieldWithDefault(msg, 7, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.Log}
 */
proto.tradecopier.Log.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.Log;
  return proto.tradecopier.Log.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.Log} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.Log}
 */
proto.tradecopier.Log.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterTicket(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLevel(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountId(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.Log.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.Log.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.Log} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.Log.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMasterTicket();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLevel();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMasterAccountId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.tradecopier.Log.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.Log} returns this
 */
proto.tradecopier.Log.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.tradecopier.Log.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.Log} returns this
 */
proto.tradecopier.Log.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string master_ticket = 3;
 * @return {string}
 */
proto.tradecopier.Log.prototype.getMasterTicket = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.Log} returns this
 */
proto.tradecopier.Log.prototype.setMasterTicket = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue error = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.Log.prototype.getError = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.Log} returns this
*/
proto.tradecopier.Log.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Log} returns this
 */
proto.tradecopier.Log.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Log.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string account_id = 5;
 * @return {string}
 */
proto.tradecopier.Log.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.Log} returns this
 */
proto.tradecopier.Log.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string level = 6;
 * @return {string}
 */
proto.tradecopier.Log.prototype.getLevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.Log} returns this
 */
proto.tradecopier.Log.prototype.setLevel = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string master_account_id = 7;
 * @return {string}
 */
proto.tradecopier.Log.prototype.getMasterAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.Log} returns this
 */
proto.tradecopier.Log.prototype.setMasterAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.tradecopier.Log.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.tradecopier.Log} returns this
*/
proto.tradecopier.Log.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.Log} returns this
 */
proto.tradecopier.Log.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.Log.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.EditSymbolMappingReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.EditSymbolMappingReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.EditSymbolMappingReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.EditSymbolMappingReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 2, ""),
symbolId: jspb.Message.getFieldWithDefault(msg, 3, 0),
name: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.EditSymbolMappingReq}
 */
proto.tradecopier.EditSymbolMappingReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.EditSymbolMappingReq;
  return proto.tradecopier.EditSymbolMappingReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.EditSymbolMappingReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.EditSymbolMappingReq}
 */
proto.tradecopier.EditSymbolMappingReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSymbolId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.EditSymbolMappingReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.EditSymbolMappingReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.EditSymbolMappingReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.EditSymbolMappingReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbolId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.EditSymbolMappingReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.EditSymbolMappingReq} returns this
 */
proto.tradecopier.EditSymbolMappingReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slave_id = 2;
 * @return {string}
 */
proto.tradecopier.EditSymbolMappingReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.EditSymbolMappingReq} returns this
 */
proto.tradecopier.EditSymbolMappingReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 symbol_id = 3;
 * @return {number}
 */
proto.tradecopier.EditSymbolMappingReq.prototype.getSymbolId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.EditSymbolMappingReq} returns this
 */
proto.tradecopier.EditSymbolMappingReq.prototype.setSymbolId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.tradecopier.EditSymbolMappingReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.EditSymbolMappingReq} returns this
 */
proto.tradecopier.EditSymbolMappingReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.EditSymbolMappingReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.EditSymbolMappingReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.EditSymbolMappingReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.EditSymbolMappingReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.EditSymbolMappingReply}
 */
proto.tradecopier.EditSymbolMappingReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.EditSymbolMappingReply;
  return proto.tradecopier.EditSymbolMappingReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.EditSymbolMappingReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.EditSymbolMappingReply}
 */
proto.tradecopier.EditSymbolMappingReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.EditSymbolMappingReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.EditSymbolMappingReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.EditSymbolMappingReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.EditSymbolMappingReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AdminEditSymbolMappingReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AdminEditSymbolMappingReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AdminEditSymbolMappingReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminEditSymbolMappingReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 2, ""),
symbolId: jspb.Message.getFieldWithDefault(msg, 3, 0),
name: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AdminEditSymbolMappingReq}
 */
proto.tradecopier.AdminEditSymbolMappingReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AdminEditSymbolMappingReq;
  return proto.tradecopier.AdminEditSymbolMappingReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AdminEditSymbolMappingReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AdminEditSymbolMappingReq}
 */
proto.tradecopier.AdminEditSymbolMappingReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSymbolId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AdminEditSymbolMappingReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AdminEditSymbolMappingReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AdminEditSymbolMappingReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminEditSymbolMappingReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbolId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.AdminEditSymbolMappingReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AdminEditSymbolMappingReq} returns this
 */
proto.tradecopier.AdminEditSymbolMappingReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slave_id = 2;
 * @return {string}
 */
proto.tradecopier.AdminEditSymbolMappingReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AdminEditSymbolMappingReq} returns this
 */
proto.tradecopier.AdminEditSymbolMappingReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 symbol_id = 3;
 * @return {number}
 */
proto.tradecopier.AdminEditSymbolMappingReq.prototype.getSymbolId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.AdminEditSymbolMappingReq} returns this
 */
proto.tradecopier.AdminEditSymbolMappingReq.prototype.setSymbolId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.tradecopier.AdminEditSymbolMappingReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AdminEditSymbolMappingReq} returns this
 */
proto.tradecopier.AdminEditSymbolMappingReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AdminEditSymbolMappingReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AdminEditSymbolMappingReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AdminEditSymbolMappingReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminEditSymbolMappingReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AdminEditSymbolMappingReply}
 */
proto.tradecopier.AdminEditSymbolMappingReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AdminEditSymbolMappingReply;
  return proto.tradecopier.AdminEditSymbolMappingReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AdminEditSymbolMappingReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AdminEditSymbolMappingReply}
 */
proto.tradecopier.AdminEditSymbolMappingReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AdminEditSymbolMappingReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AdminEditSymbolMappingReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AdminEditSymbolMappingReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AdminEditSymbolMappingReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.IntListSymbolMappingReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.IntListSymbolMappingReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.IntListSymbolMappingReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntListSymbolMappingReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.IntListSymbolMappingReq}
 */
proto.tradecopier.IntListSymbolMappingReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.IntListSymbolMappingReq;
  return proto.tradecopier.IntListSymbolMappingReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.IntListSymbolMappingReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.IntListSymbolMappingReq}
 */
proto.tradecopier.IntListSymbolMappingReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.IntListSymbolMappingReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.IntListSymbolMappingReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.IntListSymbolMappingReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntListSymbolMappingReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.IntListSymbolMappingReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.IntListSymbolMappingReq} returns this
 */
proto.tradecopier.IntListSymbolMappingReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slave_id = 2;
 * @return {string}
 */
proto.tradecopier.IntListSymbolMappingReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.IntListSymbolMappingReq} returns this
 */
proto.tradecopier.IntListSymbolMappingReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.IntListSymbolMappingReply.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.IntListSymbolMappingReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.IntListSymbolMappingReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.IntListSymbolMappingReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntListSymbolMappingReply.toObject = function(includeInstance, msg) {
  var f, obj = {
slaveId: jspb.Message.getFieldWithDefault(msg, 1, ""),
mappingsList: jspb.Message.toObjectList(msg.getMappingsList(),
    proto.tradecopier.Mapping.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.IntListSymbolMappingReply}
 */
proto.tradecopier.IntListSymbolMappingReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.IntListSymbolMappingReply;
  return proto.tradecopier.IntListSymbolMappingReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.IntListSymbolMappingReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.IntListSymbolMappingReply}
 */
proto.tradecopier.IntListSymbolMappingReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 2:
      var value = new proto.tradecopier.Mapping;
      reader.readMessage(value,proto.tradecopier.Mapping.deserializeBinaryFromReader);
      msg.addMappings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.IntListSymbolMappingReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.IntListSymbolMappingReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.IntListSymbolMappingReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntListSymbolMappingReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMappingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.tradecopier.Mapping.serializeBinaryToWriter
    );
  }
};


/**
 * optional string slave_id = 1;
 * @return {string}
 */
proto.tradecopier.IntListSymbolMappingReply.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.IntListSymbolMappingReply} returns this
 */
proto.tradecopier.IntListSymbolMappingReply.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Mapping mappings = 2;
 * @return {!Array<!proto.tradecopier.Mapping>}
 */
proto.tradecopier.IntListSymbolMappingReply.prototype.getMappingsList = function() {
  return /** @type{!Array<!proto.tradecopier.Mapping>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tradecopier.Mapping, 2));
};


/**
 * @param {!Array<!proto.tradecopier.Mapping>} value
 * @return {!proto.tradecopier.IntListSymbolMappingReply} returns this
*/
proto.tradecopier.IntListSymbolMappingReply.prototype.setMappingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.tradecopier.Mapping=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.Mapping}
 */
proto.tradecopier.IntListSymbolMappingReply.prototype.addMappings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.tradecopier.Mapping, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.IntListSymbolMappingReply} returns this
 */
proto.tradecopier.IntListSymbolMappingReply.prototype.clearMappingsList = function() {
  return this.setMappingsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.IntMapSymbolInBulkReq.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.IntMapSymbolInBulkReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.IntMapSymbolInBulkReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.IntMapSymbolInBulkReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntMapSymbolInBulkReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 2, ""),
mappingsList: jspb.Message.toObjectList(msg.getMappingsList(),
    proto.tradecopier.MappingReq.toObject, includeInstance),
overwriteExisting: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.IntMapSymbolInBulkReq}
 */
proto.tradecopier.IntMapSymbolInBulkReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.IntMapSymbolInBulkReq;
  return proto.tradecopier.IntMapSymbolInBulkReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.IntMapSymbolInBulkReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.IntMapSymbolInBulkReq}
 */
proto.tradecopier.IntMapSymbolInBulkReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 3:
      var value = new proto.tradecopier.MappingReq;
      reader.readMessage(value,proto.tradecopier.MappingReq.deserializeBinaryFromReader);
      msg.addMappings(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOverwriteExisting(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.IntMapSymbolInBulkReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.IntMapSymbolInBulkReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.IntMapSymbolInBulkReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntMapSymbolInBulkReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMappingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.tradecopier.MappingReq.serializeBinaryToWriter
    );
  }
  f = message.getOverwriteExisting();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.IntMapSymbolInBulkReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.IntMapSymbolInBulkReq} returns this
 */
proto.tradecopier.IntMapSymbolInBulkReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slave_id = 2;
 * @return {string}
 */
proto.tradecopier.IntMapSymbolInBulkReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.IntMapSymbolInBulkReq} returns this
 */
proto.tradecopier.IntMapSymbolInBulkReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated MappingReq mappings = 3;
 * @return {!Array<!proto.tradecopier.MappingReq>}
 */
proto.tradecopier.IntMapSymbolInBulkReq.prototype.getMappingsList = function() {
  return /** @type{!Array<!proto.tradecopier.MappingReq>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tradecopier.MappingReq, 3));
};


/**
 * @param {!Array<!proto.tradecopier.MappingReq>} value
 * @return {!proto.tradecopier.IntMapSymbolInBulkReq} returns this
*/
proto.tradecopier.IntMapSymbolInBulkReq.prototype.setMappingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.tradecopier.MappingReq=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.MappingReq}
 */
proto.tradecopier.IntMapSymbolInBulkReq.prototype.addMappings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.tradecopier.MappingReq, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.IntMapSymbolInBulkReq} returns this
 */
proto.tradecopier.IntMapSymbolInBulkReq.prototype.clearMappingsList = function() {
  return this.setMappingsList([]);
};


/**
 * optional bool overwrite_existing = 4;
 * @return {boolean}
 */
proto.tradecopier.IntMapSymbolInBulkReq.prototype.getOverwriteExisting = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tradecopier.IntMapSymbolInBulkReq} returns this
 */
proto.tradecopier.IntMapSymbolInBulkReq.prototype.setOverwriteExisting = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.IntMapSymbolInBulkReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.IntMapSymbolInBulkReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.IntMapSymbolInBulkReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntMapSymbolInBulkReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.IntMapSymbolInBulkReply}
 */
proto.tradecopier.IntMapSymbolInBulkReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.IntMapSymbolInBulkReply;
  return proto.tradecopier.IntMapSymbolInBulkReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.IntMapSymbolInBulkReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.IntMapSymbolInBulkReply}
 */
proto.tradecopier.IntMapSymbolInBulkReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.IntMapSymbolInBulkReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.IntMapSymbolInBulkReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.IntMapSymbolInBulkReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntMapSymbolInBulkReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.MasterMeta.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.MasterMeta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.MasterMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.MasterMeta.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.MasterMeta}
 */
proto.tradecopier.MasterMeta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.MasterMeta;
  return proto.tradecopier.MasterMeta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.MasterMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.MasterMeta}
 */
proto.tradecopier.MasterMeta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.MasterMeta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.MasterMeta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.MasterMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.MasterMeta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.tradecopier.MasterMeta.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.MasterMeta} returns this
 */
proto.tradecopier.MasterMeta.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.tradecopier.MasterMeta.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.tradecopier.MasterMeta} returns this
*/
proto.tradecopier.MasterMeta.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.MasterMeta} returns this
 */
proto.tradecopier.MasterMeta.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.MasterMeta.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.UpdateSlaveManyReq.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.UpdateSlaveManyReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.UpdateSlaveManyReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.UpdateSlaveManyReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdateSlaveManyReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
configId: jspb.Message.getFieldWithDefault(msg, 2, ""),
updatedSlaveConfigsList: jspb.Message.toObjectList(msg.getUpdatedSlaveConfigsList(),
    proto.tradecopier.UpdatedSlaveConfig.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.UpdateSlaveManyReq}
 */
proto.tradecopier.UpdateSlaveManyReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.UpdateSlaveManyReq;
  return proto.tradecopier.UpdateSlaveManyReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.UpdateSlaveManyReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.UpdateSlaveManyReq}
 */
proto.tradecopier.UpdateSlaveManyReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfigId(value);
      break;
    case 3:
      var value = new proto.tradecopier.UpdatedSlaveConfig;
      reader.readMessage(value,proto.tradecopier.UpdatedSlaveConfig.deserializeBinaryFromReader);
      msg.addUpdatedSlaveConfigs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.UpdateSlaveManyReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.UpdateSlaveManyReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.UpdateSlaveManyReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdateSlaveManyReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConfigId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUpdatedSlaveConfigsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.tradecopier.UpdatedSlaveConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.UpdateSlaveManyReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.UpdateSlaveManyReq} returns this
 */
proto.tradecopier.UpdateSlaveManyReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string config_id = 2;
 * @return {string}
 */
proto.tradecopier.UpdateSlaveManyReq.prototype.getConfigId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.UpdateSlaveManyReq} returns this
 */
proto.tradecopier.UpdateSlaveManyReq.prototype.setConfigId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated UpdatedSlaveConfig updated_slave_configs = 3;
 * @return {!Array<!proto.tradecopier.UpdatedSlaveConfig>}
 */
proto.tradecopier.UpdateSlaveManyReq.prototype.getUpdatedSlaveConfigsList = function() {
  return /** @type{!Array<!proto.tradecopier.UpdatedSlaveConfig>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tradecopier.UpdatedSlaveConfig, 3));
};


/**
 * @param {!Array<!proto.tradecopier.UpdatedSlaveConfig>} value
 * @return {!proto.tradecopier.UpdateSlaveManyReq} returns this
*/
proto.tradecopier.UpdateSlaveManyReq.prototype.setUpdatedSlaveConfigsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.tradecopier.UpdatedSlaveConfig=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.UpdatedSlaveConfig}
 */
proto.tradecopier.UpdateSlaveManyReq.prototype.addUpdatedSlaveConfigs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.tradecopier.UpdatedSlaveConfig, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.UpdateSlaveManyReq} returns this
 */
proto.tradecopier.UpdateSlaveManyReq.prototype.clearUpdatedSlaveConfigsList = function() {
  return this.setUpdatedSlaveConfigsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.TradingHour.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.TradingHour.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.TradingHour} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.TradingHour.toObject = function(includeInstance, msg) {
  var f, obj = {
startTime: jspb.Message.getFieldWithDefault(msg, 1, 0),
endTime: jspb.Message.getFieldWithDefault(msg, 2, 0),
dayOfWeek: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.TradingHour}
 */
proto.tradecopier.TradingHour.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.TradingHour;
  return proto.tradecopier.TradingHour.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.TradingHour} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.TradingHour}
 */
proto.tradecopier.TradingHour.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartTime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndTime(value);
      break;
    case 3:
      var value = /** @type {!proto.tradecopier.DayOfWeek} */ (reader.readEnum());
      msg.setDayOfWeek(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.TradingHour.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.TradingHour.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.TradingHour} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.TradingHour.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartTime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEndTime();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getDayOfWeek();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int64 start_time = 1;
 * @return {number}
 */
proto.tradecopier.TradingHour.prototype.getStartTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.TradingHour} returns this
 */
proto.tradecopier.TradingHour.prototype.setStartTime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 end_time = 2;
 * @return {number}
 */
proto.tradecopier.TradingHour.prototype.getEndTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.TradingHour} returns this
 */
proto.tradecopier.TradingHour.prototype.setEndTime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional DayOfWeek day_of_week = 3;
 * @return {!proto.tradecopier.DayOfWeek}
 */
proto.tradecopier.TradingHour.prototype.getDayOfWeek = function() {
  return /** @type {!proto.tradecopier.DayOfWeek} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.tradecopier.DayOfWeek} value
 * @return {!proto.tradecopier.TradingHour} returns this
 */
proto.tradecopier.TradingHour.prototype.setDayOfWeek = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.UpdatedSlaveConfig.repeatedFields_ = [24,27,37];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.UpdatedSlaveConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.UpdatedSlaveConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdatedSlaveConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
enable: (f = msg.getEnable()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
riskType: jspb.Message.getFieldWithDefault(msg, 3, 0),
fixedLotValue: (f = msg.getFixedLotValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
lotMultiplierValue: (f = msg.getLotMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
balanceMultiplierValue: (f = msg.getBalanceMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
copyStopLoss: (f = msg.getCopyStopLoss()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyTakeProfit: (f = msg.getCopyTakeProfit()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyPendingOrders: (f = msg.getCopyPendingOrders()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
forceMinimumLotSize: (f = msg.getForceMinimumLotSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyComment: (f = msg.getCopyComment()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
customComment: (f = msg.getCustomComment()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
forceMaximumLotSize: (f = msg.getForceMaximumLotSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
customPlacedType: (f = msg.getCustomPlacedType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
reverseTrade: (f = msg.getReverseTrade()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
strictClose: (f = msg.getStrictClose()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
considerContractSize: (f = msg.getConsiderContractSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyMagicNumber: (f = msg.getCopyMagicNumber()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
magicNumber: (f = msg.getMagicNumber()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
manageExisting: (f = msg.getManageExisting()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
lotRefinerValue: (f = msg.getLotRefinerValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
fixedBalanceMultiplierValue: (f = msg.getFixedBalanceMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
fixedMasterBalance: (f = msg.getFixedMasterBalance()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
magicFiltersList: jspb.Message.toObjectList(msg.getMagicFiltersList(),
    google_protobuf_wrappers_pb.Int64Value.toObject, includeInstance),
minDelayTime: (f = msg.getMinDelayTime()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
copyExpiryTime: (f = msg.getCopyExpiryTime()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
commentFiltersList: jspb.Message.toObjectList(msg.getCommentFiltersList(),
    google_protobuf_wrappers_pb.StringValue.toObject, includeInstance),
minLotFilter: (f = msg.getMinLotFilter()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
maxLotFilter: (f = msg.getMaxLotFilter()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
maxDelayTime: (f = msg.getMaxDelayTime()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
takeProfitPip: (f = msg.getTakeProfitPip()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
stopLossPip: (f = msg.getStopLossPip()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
slRefiner: (f = msg.getSlRefiner()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
tpRefiner: (f = msg.getTpRefiner()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
balancePercentageValue: (f = msg.getBalancePercentageValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
allowedTradeSide: (f = msg.getAllowedTradeSide()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
tradingHoursList: jspb.Message.toObjectList(msg.getTradingHoursList(),
    proto.tradecopier.TradingHour.toObject, includeInstance),
magicFilterType: jspb.Message.getFieldWithDefault(msg, 38, 0),
commentFilterType: jspb.Message.getFieldWithDefault(msg, 39, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.UpdatedSlaveConfig}
 */
proto.tradecopier.UpdatedSlaveConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.UpdatedSlaveConfig;
  return proto.tradecopier.UpdatedSlaveConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.UpdatedSlaveConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.UpdatedSlaveConfig}
 */
proto.tradecopier.UpdatedSlaveConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEnable(value);
      break;
    case 3:
      var value = /** @type {!proto.tradecopier.RISK_TYPE} */ (reader.readEnum());
      msg.setRiskType(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedLotValue(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLotMultiplierValue(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setBalanceMultiplierValue(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyStopLoss(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyTakeProfit(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyPendingOrders(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setForceMinimumLotSize(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyComment(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomComment(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setForceMaximumLotSize(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomPlacedType(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setReverseTrade(value);
      break;
    case 16:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setStrictClose(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setConsiderContractSize(value);
      break;
    case 18:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyMagicNumber(value);
      break;
    case 19:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMagicNumber(value);
      break;
    case 20:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setManageExisting(value);
      break;
    case 21:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLotRefinerValue(value);
      break;
    case 22:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedBalanceMultiplierValue(value);
      break;
    case 23:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedMasterBalance(value);
      break;
    case 24:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.addMagicFilters(value);
      break;
    case 25:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMinDelayTime(value);
      break;
    case 26:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyExpiryTime(value);
      break;
    case 27:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.addCommentFilters(value);
      break;
    case 28:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMinLotFilter(value);
      break;
    case 29:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMaxLotFilter(value);
      break;
    case 30:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMaxDelayTime(value);
      break;
    case 31:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTakeProfitPip(value);
      break;
    case 32:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setStopLossPip(value);
      break;
    case 33:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setSlRefiner(value);
      break;
    case 34:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTpRefiner(value);
      break;
    case 35:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setBalancePercentageValue(value);
      break;
    case 36:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAllowedTradeSide(value);
      break;
    case 37:
      var value = new proto.tradecopier.TradingHour;
      reader.readMessage(value,proto.tradecopier.TradingHour.deserializeBinaryFromReader);
      msg.addTradingHours(value);
      break;
    case 38:
      var value = /** @type {!proto.tradecopier.FilterType} */ (reader.readEnum());
      msg.setMagicFilterType(value);
      break;
    case 39:
      var value = /** @type {!proto.tradecopier.FilterType} */ (reader.readEnum());
      msg.setCommentFilterType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.UpdatedSlaveConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.UpdatedSlaveConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdatedSlaveConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEnable();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getRiskType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getFixedLotValue();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getLotMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getBalanceMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyStopLoss();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyTakeProfit();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyPendingOrders();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getForceMinimumLotSize();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyComment();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomComment();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getForceMaximumLotSize();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomPlacedType();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getReverseTrade();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getStrictClose();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getConsiderContractSize();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyMagicNumber();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getMagicNumber();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getManageExisting();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getLotRefinerValue();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getFixedBalanceMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getFixedMasterBalance();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMagicFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      24,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getMinDelayTime();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getCopyExpiryTime();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCommentFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      27,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getMinLotFilter();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxLotFilter();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxDelayTime();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getTakeProfitPip();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getStopLossPip();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getSlRefiner();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTpRefiner();
  if (f != null) {
    writer.writeMessage(
      34,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getBalancePercentageValue();
  if (f != null) {
    writer.writeMessage(
      35,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getAllowedTradeSide();
  if (f != null) {
    writer.writeMessage(
      36,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getTradingHoursList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      37,
      f,
      proto.tradecopier.TradingHour.serializeBinaryToWriter
    );
  }
  f = message.getMagicFilterType();
  if (f !== 0.0) {
    writer.writeEnum(
      38,
      f
    );
  }
  f = message.getCommentFilterType();
  if (f !== 0.0) {
    writer.writeEnum(
      39,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.BoolValue enable = 2;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getEnable = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 2));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setEnable = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearEnable = function() {
  return this.setEnable(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasEnable = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional RISK_TYPE risk_type = 3;
 * @return {!proto.tradecopier.RISK_TYPE}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getRiskType = function() {
  return /** @type {!proto.tradecopier.RISK_TYPE} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.tradecopier.RISK_TYPE} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.setRiskType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional google.protobuf.DoubleValue fixed_lot_value = 4;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getFixedLotValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 4));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setFixedLotValue = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearFixedLotValue = function() {
  return this.setFixedLotValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasFixedLotValue = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.DoubleValue lot_multiplier_value = 5;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getLotMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 5));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setLotMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearLotMultiplierValue = function() {
  return this.setLotMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasLotMultiplierValue = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.DoubleValue balance_multiplier_value = 6;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getBalanceMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 6));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setBalanceMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearBalanceMultiplierValue = function() {
  return this.setBalanceMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasBalanceMultiplierValue = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.BoolValue copy_stop_loss = 7;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getCopyStopLoss = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 7));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setCopyStopLoss = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearCopyStopLoss = function() {
  return this.setCopyStopLoss(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasCopyStopLoss = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.BoolValue copy_take_profit = 8;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getCopyTakeProfit = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 8));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setCopyTakeProfit = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearCopyTakeProfit = function() {
  return this.setCopyTakeProfit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasCopyTakeProfit = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.BoolValue copy_pending_orders = 9;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getCopyPendingOrders = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 9));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setCopyPendingOrders = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearCopyPendingOrders = function() {
  return this.setCopyPendingOrders(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasCopyPendingOrders = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.BoolValue force_minimum_lot_size = 10;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getForceMinimumLotSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 10));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setForceMinimumLotSize = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearForceMinimumLotSize = function() {
  return this.setForceMinimumLotSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasForceMinimumLotSize = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.BoolValue copy_comment = 11;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getCopyComment = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 11));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setCopyComment = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearCopyComment = function() {
  return this.setCopyComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasCopyComment = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue custom_comment = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getCustomComment = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setCustomComment = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearCustomComment = function() {
  return this.setCustomComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasCustomComment = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.BoolValue force_maximum_lot_size = 13;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getForceMaximumLotSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 13));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setForceMaximumLotSize = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearForceMaximumLotSize = function() {
  return this.setForceMaximumLotSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasForceMaximumLotSize = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.StringValue custom_placed_type = 14;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getCustomPlacedType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 14));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setCustomPlacedType = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearCustomPlacedType = function() {
  return this.setCustomPlacedType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasCustomPlacedType = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.BoolValue reverse_trade = 15;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getReverseTrade = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 15));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setReverseTrade = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearReverseTrade = function() {
  return this.setReverseTrade(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasReverseTrade = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.BoolValue strict_close = 16;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getStrictClose = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 16));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setStrictClose = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearStrictClose = function() {
  return this.setStrictClose(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasStrictClose = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.BoolValue consider_contract_size = 17;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getConsiderContractSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 17));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setConsiderContractSize = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearConsiderContractSize = function() {
  return this.setConsiderContractSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasConsiderContractSize = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.BoolValue copy_magic_number = 18;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getCopyMagicNumber = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 18));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setCopyMagicNumber = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearCopyMagicNumber = function() {
  return this.setCopyMagicNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasCopyMagicNumber = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional google.protobuf.Int64Value magic_number = 19;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getMagicNumber = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 19));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setMagicNumber = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearMagicNumber = function() {
  return this.setMagicNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasMagicNumber = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional google.protobuf.BoolValue manage_existing = 20;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getManageExisting = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 20));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setManageExisting = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearManageExisting = function() {
  return this.setManageExisting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasManageExisting = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional google.protobuf.DoubleValue lot_refiner_value = 21;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getLotRefinerValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 21));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setLotRefinerValue = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearLotRefinerValue = function() {
  return this.setLotRefinerValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasLotRefinerValue = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional google.protobuf.DoubleValue fixed_balance_multiplier_value = 22;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getFixedBalanceMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 22));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setFixedBalanceMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearFixedBalanceMultiplierValue = function() {
  return this.setFixedBalanceMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasFixedBalanceMultiplierValue = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.DoubleValue fixed_master_balance = 23;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getFixedMasterBalance = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 23));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setFixedMasterBalance = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearFixedMasterBalance = function() {
  return this.setFixedMasterBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasFixedMasterBalance = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * repeated google.protobuf.Int64Value magic_filters = 24;
 * @return {!Array<!proto.google.protobuf.Int64Value>}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getMagicFiltersList = function() {
  return /** @type{!Array<!proto.google.protobuf.Int64Value>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 24));
};


/**
 * @param {!Array<!proto.google.protobuf.Int64Value>} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setMagicFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 24, value);
};


/**
 * @param {!proto.google.protobuf.Int64Value=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Int64Value}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.addMagicFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 24, opt_value, proto.google.protobuf.Int64Value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearMagicFiltersList = function() {
  return this.setMagicFiltersList([]);
};


/**
 * optional google.protobuf.Int64Value min_delay_time = 25;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getMinDelayTime = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 25));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setMinDelayTime = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearMinDelayTime = function() {
  return this.setMinDelayTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasMinDelayTime = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional google.protobuf.BoolValue copy_expiry_time = 26;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getCopyExpiryTime = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 26));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setCopyExpiryTime = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearCopyExpiryTime = function() {
  return this.setCopyExpiryTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasCopyExpiryTime = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * repeated google.protobuf.StringValue comment_filters = 27;
 * @return {!Array<!proto.google.protobuf.StringValue>}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getCommentFiltersList = function() {
  return /** @type{!Array<!proto.google.protobuf.StringValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_wrappers_pb.StringValue, 27));
};


/**
 * @param {!Array<!proto.google.protobuf.StringValue>} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setCommentFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 27, value);
};


/**
 * @param {!proto.google.protobuf.StringValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.StringValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.addCommentFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 27, opt_value, proto.google.protobuf.StringValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearCommentFiltersList = function() {
  return this.setCommentFiltersList([]);
};


/**
 * optional google.protobuf.DoubleValue min_lot_filter = 28;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getMinLotFilter = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 28));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setMinLotFilter = function(value) {
  return jspb.Message.setWrapperField(this, 28, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearMinLotFilter = function() {
  return this.setMinLotFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasMinLotFilter = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional google.protobuf.DoubleValue max_lot_filter = 29;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getMaxLotFilter = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 29));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setMaxLotFilter = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearMaxLotFilter = function() {
  return this.setMaxLotFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasMaxLotFilter = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional google.protobuf.Int64Value max_delay_time = 30;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getMaxDelayTime = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 30));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setMaxDelayTime = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearMaxDelayTime = function() {
  return this.setMaxDelayTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasMaxDelayTime = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional google.protobuf.DoubleValue take_profit_pip = 31;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getTakeProfitPip = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 31));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setTakeProfitPip = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearTakeProfitPip = function() {
  return this.setTakeProfitPip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasTakeProfitPip = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional google.protobuf.DoubleValue stop_loss_pip = 32;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getStopLossPip = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 32));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setStopLossPip = function(value) {
  return jspb.Message.setWrapperField(this, 32, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearStopLossPip = function() {
  return this.setStopLossPip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasStopLossPip = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional google.protobuf.DoubleValue sl_refiner = 33;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getSlRefiner = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 33));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setSlRefiner = function(value) {
  return jspb.Message.setWrapperField(this, 33, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearSlRefiner = function() {
  return this.setSlRefiner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasSlRefiner = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional google.protobuf.DoubleValue tp_refiner = 34;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getTpRefiner = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 34));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setTpRefiner = function(value) {
  return jspb.Message.setWrapperField(this, 34, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearTpRefiner = function() {
  return this.setTpRefiner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasTpRefiner = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional google.protobuf.DoubleValue balance_percentage_value = 35;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getBalancePercentageValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 35));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setBalancePercentageValue = function(value) {
  return jspb.Message.setWrapperField(this, 35, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearBalancePercentageValue = function() {
  return this.setBalancePercentageValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasBalancePercentageValue = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional google.protobuf.StringValue allowed_trade_side = 36;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getAllowedTradeSide = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 36));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setAllowedTradeSide = function(value) {
  return jspb.Message.setWrapperField(this, 36, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearAllowedTradeSide = function() {
  return this.setAllowedTradeSide(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.hasAllowedTradeSide = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * repeated TradingHour trading_hours = 37;
 * @return {!Array<!proto.tradecopier.TradingHour>}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getTradingHoursList = function() {
  return /** @type{!Array<!proto.tradecopier.TradingHour>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tradecopier.TradingHour, 37));
};


/**
 * @param {!Array<!proto.tradecopier.TradingHour>} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
*/
proto.tradecopier.UpdatedSlaveConfig.prototype.setTradingHoursList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 37, value);
};


/**
 * @param {!proto.tradecopier.TradingHour=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.TradingHour}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.addTradingHours = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 37, opt_value, proto.tradecopier.TradingHour, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.clearTradingHoursList = function() {
  return this.setTradingHoursList([]);
};


/**
 * optional FilterType magic_filter_type = 38;
 * @return {!proto.tradecopier.FilterType}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getMagicFilterType = function() {
  return /** @type {!proto.tradecopier.FilterType} */ (jspb.Message.getFieldWithDefault(this, 38, 0));
};


/**
 * @param {!proto.tradecopier.FilterType} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.setMagicFilterType = function(value) {
  return jspb.Message.setProto3EnumField(this, 38, value);
};


/**
 * optional FilterType comment_filter_type = 39;
 * @return {!proto.tradecopier.FilterType}
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.getCommentFilterType = function() {
  return /** @type {!proto.tradecopier.FilterType} */ (jspb.Message.getFieldWithDefault(this, 39, 0));
};


/**
 * @param {!proto.tradecopier.FilterType} value
 * @return {!proto.tradecopier.UpdatedSlaveConfig} returns this
 */
proto.tradecopier.UpdatedSlaveConfig.prototype.setCommentFilterType = function(value) {
  return jspb.Message.setProto3EnumField(this, 39, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.UpdateSlaveManyReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.UpdateSlaveManyReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.UpdateSlaveManyReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdateSlaveManyReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.UpdateSlaveManyReply}
 */
proto.tradecopier.UpdateSlaveManyReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.UpdateSlaveManyReply;
  return proto.tradecopier.UpdateSlaveManyReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.UpdateSlaveManyReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.UpdateSlaveManyReply}
 */
proto.tradecopier.UpdateSlaveManyReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.UpdateSlaveManyReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.UpdateSlaveManyReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.UpdateSlaveManyReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdateSlaveManyReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.IntSlaveAccountIDsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.IntSlaveAccountIDsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.IntSlaveAccountIDsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntSlaveAccountIDsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
masterAccountId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.IntSlaveAccountIDsReq}
 */
proto.tradecopier.IntSlaveAccountIDsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.IntSlaveAccountIDsReq;
  return proto.tradecopier.IntSlaveAccountIDsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.IntSlaveAccountIDsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.IntSlaveAccountIDsReq}
 */
proto.tradecopier.IntSlaveAccountIDsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.IntSlaveAccountIDsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.IntSlaveAccountIDsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.IntSlaveAccountIDsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntSlaveAccountIDsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMasterAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string master_account_id = 2;
 * @return {string}
 */
proto.tradecopier.IntSlaveAccountIDsReq.prototype.getMasterAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.IntSlaveAccountIDsReq} returns this
 */
proto.tradecopier.IntSlaveAccountIDsReq.prototype.setMasterAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.IntSlaveAccountIDsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.IntSlaveAccountIDsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.IntSlaveAccountIDsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.IntSlaveAccountIDsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntSlaveAccountIDsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
slaveAccountsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.IntSlaveAccountIDsReply}
 */
proto.tradecopier.IntSlaveAccountIDsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.IntSlaveAccountIDsReply;
  return proto.tradecopier.IntSlaveAccountIDsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.IntSlaveAccountIDsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.IntSlaveAccountIDsReply}
 */
proto.tradecopier.IntSlaveAccountIDsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addSlaveAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.IntSlaveAccountIDsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.IntSlaveAccountIDsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.IntSlaveAccountIDsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.IntSlaveAccountIDsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSlaveAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string slave_accounts = 1;
 * @return {!Array<string>}
 */
proto.tradecopier.IntSlaveAccountIDsReply.prototype.getSlaveAccountsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.tradecopier.IntSlaveAccountIDsReply} returns this
 */
proto.tradecopier.IntSlaveAccountIDsReply.prototype.setSlaveAccountsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.IntSlaveAccountIDsReply} returns this
 */
proto.tradecopier.IntSlaveAccountIDsReply.prototype.addSlaveAccounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.IntSlaveAccountIDsReply} returns this
 */
proto.tradecopier.IntSlaveAccountIDsReply.prototype.clearSlaveAccountsList = function() {
  return this.setSlaveAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.CopyExistingTradeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.CopyExistingTradeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.CopyExistingTradeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.CopyExistingTradeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 2, ""),
masterAccountId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.CopyExistingTradeReq}
 */
proto.tradecopier.CopyExistingTradeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.CopyExistingTradeReq;
  return proto.tradecopier.CopyExistingTradeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.CopyExistingTradeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.CopyExistingTradeReq}
 */
proto.tradecopier.CopyExistingTradeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.CopyExistingTradeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.CopyExistingTradeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.CopyExistingTradeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.CopyExistingTradeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMasterAccountId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.CopyExistingTradeReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.CopyExistingTradeReq} returns this
 */
proto.tradecopier.CopyExistingTradeReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slave_id = 2;
 * @return {string}
 */
proto.tradecopier.CopyExistingTradeReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.CopyExistingTradeReq} returns this
 */
proto.tradecopier.CopyExistingTradeReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string master_account_id = 3;
 * @return {string}
 */
proto.tradecopier.CopyExistingTradeReq.prototype.getMasterAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.CopyExistingTradeReq} returns this
 */
proto.tradecopier.CopyExistingTradeReq.prototype.setMasterAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.CopyExistingTradeReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.CopyExistingTradeReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.CopyExistingTradeReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.CopyExistingTradeReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.CopyExistingTradeReply}
 */
proto.tradecopier.CopyExistingTradeReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.CopyExistingTradeReply;
  return proto.tradecopier.CopyExistingTradeReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.CopyExistingTradeReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.CopyExistingTradeReply}
 */
proto.tradecopier.CopyExistingTradeReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.CopyExistingTradeReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.CopyExistingTradeReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.CopyExistingTradeReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.CopyExistingTradeReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.UpdateSymbolSettingsReq.repeatedFields_ = [27,30];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.UpdateSymbolSettingsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.UpdateSymbolSettingsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdateSymbolSettingsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 2, ""),
masterSymbolName: jspb.Message.getFieldWithDefault(msg, 3, ""),
slaveSymbolName: jspb.Message.getFieldWithDefault(msg, 4, ""),
enable: (f = msg.getEnable()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
riskType: jspb.Message.getFieldWithDefault(msg, 6, 0),
fixedLotValue: (f = msg.getFixedLotValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
lotMultiplierValue: (f = msg.getLotMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
balanceMultiplierValue: (f = msg.getBalanceMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
copyStopLoss: (f = msg.getCopyStopLoss()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyTakeProfit: (f = msg.getCopyTakeProfit()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyPendingOrders: (f = msg.getCopyPendingOrders()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
forceMinimumLotSize: (f = msg.getForceMinimumLotSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyComment: (f = msg.getCopyComment()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
customComment: (f = msg.getCustomComment()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
forceMaximumLotSize: (f = msg.getForceMaximumLotSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
customPlacedType: (f = msg.getCustomPlacedType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
reverseTrade: (f = msg.getReverseTrade()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
strictClose: (f = msg.getStrictClose()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
considerContractSize: (f = msg.getConsiderContractSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyMagicNumber: (f = msg.getCopyMagicNumber()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
magicNumber: (f = msg.getMagicNumber()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
manageExisting: (f = msg.getManageExisting()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
lotRefinerValue: (f = msg.getLotRefinerValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
fixedBalanceMultiplierValue: (f = msg.getFixedBalanceMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
fixedMasterBalance: (f = msg.getFixedMasterBalance()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
magicFiltersList: jspb.Message.toObjectList(msg.getMagicFiltersList(),
    google_protobuf_wrappers_pb.Int64Value.toObject, includeInstance),
minDelayTime: (f = msg.getMinDelayTime()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
copyExpiryTime: (f = msg.getCopyExpiryTime()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
commentFiltersList: jspb.Message.toObjectList(msg.getCommentFiltersList(),
    google_protobuf_wrappers_pb.StringValue.toObject, includeInstance),
minLotFilter: (f = msg.getMinLotFilter()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
maxLotFilter: (f = msg.getMaxLotFilter()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
maxDelayTime: (f = msg.getMaxDelayTime()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
takeProfitPip: (f = msg.getTakeProfitPip()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
stopLossPip: (f = msg.getStopLossPip()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
slRefiner: (f = msg.getSlRefiner()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
tpRefiner: (f = msg.getTpRefiner()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
balancePercentageValue: (f = msg.getBalancePercentageValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
allowedTradeSide: (f = msg.getAllowedTradeSide()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
magicFilterType: jspb.Message.getFieldWithDefault(msg, 40, 0),
commentFilterType: jspb.Message.getFieldWithDefault(msg, 41, 0),
configId: jspb.Message.getFieldWithDefault(msg, 42, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq}
 */
proto.tradecopier.UpdateSymbolSettingsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.UpdateSymbolSettingsReq;
  return proto.tradecopier.UpdateSymbolSettingsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.UpdateSymbolSettingsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq}
 */
proto.tradecopier.UpdateSymbolSettingsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterSymbolName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveSymbolName(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEnable(value);
      break;
    case 6:
      var value = /** @type {!proto.tradecopier.RISK_TYPE} */ (reader.readEnum());
      msg.setRiskType(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedLotValue(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLotMultiplierValue(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setBalanceMultiplierValue(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyStopLoss(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyTakeProfit(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyPendingOrders(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setForceMinimumLotSize(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyComment(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomComment(value);
      break;
    case 16:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setForceMaximumLotSize(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomPlacedType(value);
      break;
    case 18:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setReverseTrade(value);
      break;
    case 19:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setStrictClose(value);
      break;
    case 20:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setConsiderContractSize(value);
      break;
    case 21:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyMagicNumber(value);
      break;
    case 22:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMagicNumber(value);
      break;
    case 23:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setManageExisting(value);
      break;
    case 24:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLotRefinerValue(value);
      break;
    case 25:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedBalanceMultiplierValue(value);
      break;
    case 26:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedMasterBalance(value);
      break;
    case 27:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.addMagicFilters(value);
      break;
    case 28:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMinDelayTime(value);
      break;
    case 29:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyExpiryTime(value);
      break;
    case 30:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.addCommentFilters(value);
      break;
    case 31:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMinLotFilter(value);
      break;
    case 32:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMaxLotFilter(value);
      break;
    case 33:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMaxDelayTime(value);
      break;
    case 34:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTakeProfitPip(value);
      break;
    case 35:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setStopLossPip(value);
      break;
    case 36:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setSlRefiner(value);
      break;
    case 37:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTpRefiner(value);
      break;
    case 38:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setBalancePercentageValue(value);
      break;
    case 39:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAllowedTradeSide(value);
      break;
    case 40:
      var value = /** @type {!proto.tradecopier.FilterType} */ (reader.readEnum());
      msg.setMagicFilterType(value);
      break;
    case 41:
      var value = /** @type {!proto.tradecopier.FilterType} */ (reader.readEnum());
      msg.setCommentFilterType(value);
      break;
    case 42:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfigId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.UpdateSymbolSettingsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.UpdateSymbolSettingsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdateSymbolSettingsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMasterSymbolName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSlaveSymbolName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEnable();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getRiskType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getFixedLotValue();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getLotMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getBalanceMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyStopLoss();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyTakeProfit();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyPendingOrders();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getForceMinimumLotSize();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyComment();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomComment();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getForceMaximumLotSize();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomPlacedType();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getReverseTrade();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getStrictClose();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getConsiderContractSize();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyMagicNumber();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getMagicNumber();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getManageExisting();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getLotRefinerValue();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getFixedBalanceMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getFixedMasterBalance();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMagicFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      27,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getMinDelayTime();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getCopyExpiryTime();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCommentFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      30,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getMinLotFilter();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxLotFilter();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxDelayTime();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getTakeProfitPip();
  if (f != null) {
    writer.writeMessage(
      34,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getStopLossPip();
  if (f != null) {
    writer.writeMessage(
      35,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getSlRefiner();
  if (f != null) {
    writer.writeMessage(
      36,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTpRefiner();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getBalancePercentageValue();
  if (f != null) {
    writer.writeMessage(
      38,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getAllowedTradeSide();
  if (f != null) {
    writer.writeMessage(
      39,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getMagicFilterType();
  if (f !== 0.0) {
    writer.writeEnum(
      40,
      f
    );
  }
  f = message.getCommentFilterType();
  if (f !== 0.0) {
    writer.writeEnum(
      41,
      f
    );
  }
  f = message.getConfigId();
  if (f.length > 0) {
    writer.writeString(
      42,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slave_id = 2;
 * @return {string}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string master_symbol_name = 3;
 * @return {string}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getMasterSymbolName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setMasterSymbolName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string slave_symbol_name = 4;
 * @return {string}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getSlaveSymbolName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setSlaveSymbolName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.BoolValue enable = 5;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getEnable = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 5));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setEnable = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearEnable = function() {
  return this.setEnable(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasEnable = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional RISK_TYPE risk_type = 6;
 * @return {!proto.tradecopier.RISK_TYPE}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getRiskType = function() {
  return /** @type {!proto.tradecopier.RISK_TYPE} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.tradecopier.RISK_TYPE} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setRiskType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional google.protobuf.DoubleValue fixed_lot_value = 7;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getFixedLotValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 7));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setFixedLotValue = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearFixedLotValue = function() {
  return this.setFixedLotValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasFixedLotValue = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.DoubleValue lot_multiplier_value = 8;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getLotMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 8));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setLotMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearLotMultiplierValue = function() {
  return this.setLotMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasLotMultiplierValue = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.DoubleValue balance_multiplier_value = 9;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getBalanceMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 9));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setBalanceMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearBalanceMultiplierValue = function() {
  return this.setBalanceMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasBalanceMultiplierValue = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.BoolValue copy_stop_loss = 10;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getCopyStopLoss = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 10));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setCopyStopLoss = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearCopyStopLoss = function() {
  return this.setCopyStopLoss(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasCopyStopLoss = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.BoolValue copy_take_profit = 11;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getCopyTakeProfit = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 11));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setCopyTakeProfit = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearCopyTakeProfit = function() {
  return this.setCopyTakeProfit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasCopyTakeProfit = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.BoolValue copy_pending_orders = 12;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getCopyPendingOrders = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 12));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setCopyPendingOrders = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearCopyPendingOrders = function() {
  return this.setCopyPendingOrders(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasCopyPendingOrders = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.BoolValue force_minimum_lot_size = 13;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getForceMinimumLotSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 13));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setForceMinimumLotSize = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearForceMinimumLotSize = function() {
  return this.setForceMinimumLotSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasForceMinimumLotSize = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.BoolValue copy_comment = 14;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getCopyComment = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 14));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setCopyComment = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearCopyComment = function() {
  return this.setCopyComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasCopyComment = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.StringValue custom_comment = 15;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getCustomComment = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 15));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setCustomComment = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearCustomComment = function() {
  return this.setCustomComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasCustomComment = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.BoolValue force_maximum_lot_size = 16;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getForceMaximumLotSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 16));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setForceMaximumLotSize = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearForceMaximumLotSize = function() {
  return this.setForceMaximumLotSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasForceMaximumLotSize = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.StringValue custom_placed_type = 17;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getCustomPlacedType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 17));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setCustomPlacedType = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearCustomPlacedType = function() {
  return this.setCustomPlacedType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasCustomPlacedType = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.BoolValue reverse_trade = 18;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getReverseTrade = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 18));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setReverseTrade = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearReverseTrade = function() {
  return this.setReverseTrade(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasReverseTrade = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional google.protobuf.BoolValue strict_close = 19;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getStrictClose = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 19));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setStrictClose = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearStrictClose = function() {
  return this.setStrictClose(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasStrictClose = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional google.protobuf.BoolValue consider_contract_size = 20;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getConsiderContractSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 20));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setConsiderContractSize = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearConsiderContractSize = function() {
  return this.setConsiderContractSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasConsiderContractSize = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional google.protobuf.BoolValue copy_magic_number = 21;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getCopyMagicNumber = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 21));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setCopyMagicNumber = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearCopyMagicNumber = function() {
  return this.setCopyMagicNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasCopyMagicNumber = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional google.protobuf.Int64Value magic_number = 22;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getMagicNumber = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 22));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setMagicNumber = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearMagicNumber = function() {
  return this.setMagicNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasMagicNumber = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.BoolValue manage_existing = 23;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getManageExisting = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 23));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setManageExisting = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearManageExisting = function() {
  return this.setManageExisting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasManageExisting = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional google.protobuf.DoubleValue lot_refiner_value = 24;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getLotRefinerValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 24));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setLotRefinerValue = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearLotRefinerValue = function() {
  return this.setLotRefinerValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasLotRefinerValue = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional google.protobuf.DoubleValue fixed_balance_multiplier_value = 25;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getFixedBalanceMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 25));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setFixedBalanceMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearFixedBalanceMultiplierValue = function() {
  return this.setFixedBalanceMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasFixedBalanceMultiplierValue = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional google.protobuf.DoubleValue fixed_master_balance = 26;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getFixedMasterBalance = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 26));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setFixedMasterBalance = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearFixedMasterBalance = function() {
  return this.setFixedMasterBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasFixedMasterBalance = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * repeated google.protobuf.Int64Value magic_filters = 27;
 * @return {!Array<!proto.google.protobuf.Int64Value>}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getMagicFiltersList = function() {
  return /** @type{!Array<!proto.google.protobuf.Int64Value>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 27));
};


/**
 * @param {!Array<!proto.google.protobuf.Int64Value>} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setMagicFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 27, value);
};


/**
 * @param {!proto.google.protobuf.Int64Value=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Int64Value}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.addMagicFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 27, opt_value, proto.google.protobuf.Int64Value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearMagicFiltersList = function() {
  return this.setMagicFiltersList([]);
};


/**
 * optional google.protobuf.Int64Value min_delay_time = 28;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getMinDelayTime = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 28));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setMinDelayTime = function(value) {
  return jspb.Message.setWrapperField(this, 28, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearMinDelayTime = function() {
  return this.setMinDelayTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasMinDelayTime = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional google.protobuf.BoolValue copy_expiry_time = 29;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getCopyExpiryTime = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 29));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setCopyExpiryTime = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearCopyExpiryTime = function() {
  return this.setCopyExpiryTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasCopyExpiryTime = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * repeated google.protobuf.StringValue comment_filters = 30;
 * @return {!Array<!proto.google.protobuf.StringValue>}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getCommentFiltersList = function() {
  return /** @type{!Array<!proto.google.protobuf.StringValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_wrappers_pb.StringValue, 30));
};


/**
 * @param {!Array<!proto.google.protobuf.StringValue>} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setCommentFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 30, value);
};


/**
 * @param {!proto.google.protobuf.StringValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.StringValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.addCommentFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 30, opt_value, proto.google.protobuf.StringValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearCommentFiltersList = function() {
  return this.setCommentFiltersList([]);
};


/**
 * optional google.protobuf.DoubleValue min_lot_filter = 31;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getMinLotFilter = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 31));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setMinLotFilter = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearMinLotFilter = function() {
  return this.setMinLotFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasMinLotFilter = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional google.protobuf.DoubleValue max_lot_filter = 32;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getMaxLotFilter = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 32));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setMaxLotFilter = function(value) {
  return jspb.Message.setWrapperField(this, 32, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearMaxLotFilter = function() {
  return this.setMaxLotFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasMaxLotFilter = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional google.protobuf.Int64Value max_delay_time = 33;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getMaxDelayTime = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 33));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setMaxDelayTime = function(value) {
  return jspb.Message.setWrapperField(this, 33, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearMaxDelayTime = function() {
  return this.setMaxDelayTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasMaxDelayTime = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional google.protobuf.DoubleValue take_profit_pip = 34;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getTakeProfitPip = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 34));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setTakeProfitPip = function(value) {
  return jspb.Message.setWrapperField(this, 34, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearTakeProfitPip = function() {
  return this.setTakeProfitPip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasTakeProfitPip = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional google.protobuf.DoubleValue stop_loss_pip = 35;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getStopLossPip = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 35));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setStopLossPip = function(value) {
  return jspb.Message.setWrapperField(this, 35, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearStopLossPip = function() {
  return this.setStopLossPip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasStopLossPip = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional google.protobuf.DoubleValue sl_refiner = 36;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getSlRefiner = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 36));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setSlRefiner = function(value) {
  return jspb.Message.setWrapperField(this, 36, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearSlRefiner = function() {
  return this.setSlRefiner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasSlRefiner = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional google.protobuf.DoubleValue tp_refiner = 37;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getTpRefiner = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 37));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setTpRefiner = function(value) {
  return jspb.Message.setWrapperField(this, 37, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearTpRefiner = function() {
  return this.setTpRefiner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasTpRefiner = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional google.protobuf.DoubleValue balance_percentage_value = 38;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getBalancePercentageValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 38));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setBalancePercentageValue = function(value) {
  return jspb.Message.setWrapperField(this, 38, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearBalancePercentageValue = function() {
  return this.setBalancePercentageValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasBalancePercentageValue = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional google.protobuf.StringValue allowed_trade_side = 39;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getAllowedTradeSide = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 39));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
*/
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setAllowedTradeSide = function(value) {
  return jspb.Message.setWrapperField(this, 39, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.clearAllowedTradeSide = function() {
  return this.setAllowedTradeSide(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.hasAllowedTradeSide = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * optional FilterType magic_filter_type = 40;
 * @return {!proto.tradecopier.FilterType}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getMagicFilterType = function() {
  return /** @type {!proto.tradecopier.FilterType} */ (jspb.Message.getFieldWithDefault(this, 40, 0));
};


/**
 * @param {!proto.tradecopier.FilterType} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setMagicFilterType = function(value) {
  return jspb.Message.setProto3EnumField(this, 40, value);
};


/**
 * optional FilterType comment_filter_type = 41;
 * @return {!proto.tradecopier.FilterType}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getCommentFilterType = function() {
  return /** @type {!proto.tradecopier.FilterType} */ (jspb.Message.getFieldWithDefault(this, 41, 0));
};


/**
 * @param {!proto.tradecopier.FilterType} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setCommentFilterType = function(value) {
  return jspb.Message.setProto3EnumField(this, 41, value);
};


/**
 * optional string config_id = 42;
 * @return {string}
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.getConfigId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 42, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.UpdateSymbolSettingsReq} returns this
 */
proto.tradecopier.UpdateSymbolSettingsReq.prototype.setConfigId = function(value) {
  return jspb.Message.setProto3StringField(this, 42, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.UpdateSymbolSettingsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.UpdateSymbolSettingsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.UpdateSymbolSettingsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdateSymbolSettingsReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReply}
 */
proto.tradecopier.UpdateSymbolSettingsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.UpdateSymbolSettingsReply;
  return proto.tradecopier.UpdateSymbolSettingsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.UpdateSymbolSettingsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.UpdateSymbolSettingsReply}
 */
proto.tradecopier.UpdateSymbolSettingsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.UpdateSymbolSettingsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.UpdateSymbolSettingsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.UpdateSymbolSettingsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdateSymbolSettingsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.ListSymbolSettingsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.ListSymbolSettingsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.ListSymbolSettingsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.ListSymbolSettingsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
slaveId: jspb.Message.getFieldWithDefault(msg, 1, ""),
userId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.ListSymbolSettingsReq}
 */
proto.tradecopier.ListSymbolSettingsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.ListSymbolSettingsReq;
  return proto.tradecopier.ListSymbolSettingsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.ListSymbolSettingsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.ListSymbolSettingsReq}
 */
proto.tradecopier.ListSymbolSettingsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.ListSymbolSettingsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.ListSymbolSettingsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.ListSymbolSettingsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.ListSymbolSettingsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string slave_id = 1;
 * @return {string}
 */
proto.tradecopier.ListSymbolSettingsReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.ListSymbolSettingsReq} returns this
 */
proto.tradecopier.ListSymbolSettingsReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.tradecopier.ListSymbolSettingsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.ListSymbolSettingsReq} returns this
 */
proto.tradecopier.ListSymbolSettingsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.ListSymbolSettingsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.ListSymbolSettingsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.ListSymbolSettingsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.ListSymbolSettingsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.ListSymbolSettingsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
symbolSettingsList: jspb.Message.toObjectList(msg.getSymbolSettingsList(),
    proto.tradecopier.SymbolSettings.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.ListSymbolSettingsReply}
 */
proto.tradecopier.ListSymbolSettingsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.ListSymbolSettingsReply;
  return proto.tradecopier.ListSymbolSettingsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.ListSymbolSettingsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.ListSymbolSettingsReply}
 */
proto.tradecopier.ListSymbolSettingsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tradecopier.SymbolSettings;
      reader.readMessage(value,proto.tradecopier.SymbolSettings.deserializeBinaryFromReader);
      msg.addSymbolSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.ListSymbolSettingsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.ListSymbolSettingsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.ListSymbolSettingsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.ListSymbolSettingsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbolSettingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tradecopier.SymbolSettings.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SymbolSettings symbol_settings = 1;
 * @return {!Array<!proto.tradecopier.SymbolSettings>}
 */
proto.tradecopier.ListSymbolSettingsReply.prototype.getSymbolSettingsList = function() {
  return /** @type{!Array<!proto.tradecopier.SymbolSettings>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tradecopier.SymbolSettings, 1));
};


/**
 * @param {!Array<!proto.tradecopier.SymbolSettings>} value
 * @return {!proto.tradecopier.ListSymbolSettingsReply} returns this
*/
proto.tradecopier.ListSymbolSettingsReply.prototype.setSymbolSettingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tradecopier.SymbolSettings=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.SymbolSettings}
 */
proto.tradecopier.ListSymbolSettingsReply.prototype.addSymbolSettings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tradecopier.SymbolSettings, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.ListSymbolSettingsReply} returns this
 */
proto.tradecopier.ListSymbolSettingsReply.prototype.clearSymbolSettingsList = function() {
  return this.setSymbolSettingsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.SymbolSettings.repeatedFields_ = [24,27];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.SymbolSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.SymbolSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.SymbolSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.SymbolSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
enabled: (f = msg.getEnabled()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
riskType: (f = msg.getRiskType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
fixedLotValue: (f = msg.getFixedLotValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
lotMultiplierValue: (f = msg.getLotMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
balanceMultiplierValue: (f = msg.getBalanceMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
copyStopLoss: (f = msg.getCopyStopLoss()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyTakeProfit: (f = msg.getCopyTakeProfit()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyPendingOrders: (f = msg.getCopyPendingOrders()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
forceMinimumLotSize: (f = msg.getForceMinimumLotSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyComment: (f = msg.getCopyComment()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
customComment: (f = msg.getCustomComment()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
forceMaximumLotSize: (f = msg.getForceMaximumLotSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
customPlacedType: (f = msg.getCustomPlacedType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
reverseTrade: (f = msg.getReverseTrade()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
strictClose: (f = msg.getStrictClose()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
considerContractSize: (f = msg.getConsiderContractSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyMagicNumber: (f = msg.getCopyMagicNumber()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
magicNumber: (f = msg.getMagicNumber()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
manageExisting: (f = msg.getManageExisting()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
lotRefinerValue: (f = msg.getLotRefinerValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
fixedBalanceMultiplierValue: (f = msg.getFixedBalanceMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
fixedMasterBalance: (f = msg.getFixedMasterBalance()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
magicFiltersList: jspb.Message.toObjectList(msg.getMagicFiltersList(),
    google_protobuf_wrappers_pb.Int64Value.toObject, includeInstance),
minDelayTime: (f = msg.getMinDelayTime()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
copyExpiryTime: (f = msg.getCopyExpiryTime()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
commentFiltersList: jspb.Message.toObjectList(msg.getCommentFiltersList(),
    google_protobuf_wrappers_pb.StringValue.toObject, includeInstance),
minLotFilter: (f = msg.getMinLotFilter()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
maxLotFilter: (f = msg.getMaxLotFilter()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
maxDelayTime: (f = msg.getMaxDelayTime()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
takeProfitPip: (f = msg.getTakeProfitPip()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
stopLossPip: (f = msg.getStopLossPip()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
slRefiner: (f = msg.getSlRefiner()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
tpRefiner: (f = msg.getTpRefiner()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
balancePercentageValue: (f = msg.getBalancePercentageValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
allowedTradeSide: (f = msg.getAllowedTradeSide()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
magicFilterType: (f = msg.getMagicFilterType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
commentFilterType: (f = msg.getCommentFilterType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
symbol: jspb.Message.getFieldWithDefault(msg, 39, ""),
masterSymbol: jspb.Message.getFieldWithDefault(msg, 40, ""),
pauseUntil: (f = msg.getPauseUntil()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.SymbolSettings}
 */
proto.tradecopier.SymbolSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.SymbolSettings;
  return proto.tradecopier.SymbolSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.SymbolSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.SymbolSettings}
 */
proto.tradecopier.SymbolSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEnabled(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRiskType(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedLotValue(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLotMultiplierValue(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setBalanceMultiplierValue(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyStopLoss(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyTakeProfit(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyPendingOrders(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setForceMinimumLotSize(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyComment(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomComment(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setForceMaximumLotSize(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomPlacedType(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setReverseTrade(value);
      break;
    case 16:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setStrictClose(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setConsiderContractSize(value);
      break;
    case 18:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyMagicNumber(value);
      break;
    case 19:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMagicNumber(value);
      break;
    case 20:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setManageExisting(value);
      break;
    case 21:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLotRefinerValue(value);
      break;
    case 22:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedBalanceMultiplierValue(value);
      break;
    case 23:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedMasterBalance(value);
      break;
    case 24:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.addMagicFilters(value);
      break;
    case 25:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMinDelayTime(value);
      break;
    case 26:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyExpiryTime(value);
      break;
    case 27:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.addCommentFilters(value);
      break;
    case 28:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMinLotFilter(value);
      break;
    case 29:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMaxLotFilter(value);
      break;
    case 30:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMaxDelayTime(value);
      break;
    case 31:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTakeProfitPip(value);
      break;
    case 32:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setStopLossPip(value);
      break;
    case 33:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setSlRefiner(value);
      break;
    case 34:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTpRefiner(value);
      break;
    case 35:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setBalancePercentageValue(value);
      break;
    case 36:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAllowedTradeSide(value);
      break;
    case 37:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setMagicFilterType(value);
      break;
    case 38:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCommentFilterType(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterSymbol(value);
      break;
    case 41:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPauseUntil(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.SymbolSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.SymbolSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.SymbolSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.SymbolSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getEnabled();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getRiskType();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getFixedLotValue();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getLotMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getBalanceMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyStopLoss();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyTakeProfit();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyPendingOrders();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getForceMinimumLotSize();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyComment();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomComment();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getForceMaximumLotSize();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomPlacedType();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getReverseTrade();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getStrictClose();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getConsiderContractSize();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyMagicNumber();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getMagicNumber();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getManageExisting();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getLotRefinerValue();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getFixedBalanceMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getFixedMasterBalance();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMagicFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      24,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getMinDelayTime();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getCopyExpiryTime();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCommentFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      27,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getMinLotFilter();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxLotFilter();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxDelayTime();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getTakeProfitPip();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getStopLossPip();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getSlRefiner();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTpRefiner();
  if (f != null) {
    writer.writeMessage(
      34,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getBalancePercentageValue();
  if (f != null) {
    writer.writeMessage(
      35,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getAllowedTradeSide();
  if (f != null) {
    writer.writeMessage(
      36,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getMagicFilterType();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCommentFilterType();
  if (f != null) {
    writer.writeMessage(
      38,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      39,
      f
    );
  }
  f = message.getMasterSymbol();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getPauseUntil();
  if (f != null) {
    writer.writeMessage(
      41,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.tradecopier.SymbolSettings.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.protobuf.BoolValue enabled = 2;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.SymbolSettings.prototype.getEnabled = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 2));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setEnabled = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearEnabled = function() {
  return this.setEnabled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasEnabled = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue risk_type = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.SymbolSettings.prototype.getRiskType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setRiskType = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearRiskType = function() {
  return this.setRiskType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasRiskType = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.DoubleValue fixed_lot_value = 4;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.SymbolSettings.prototype.getFixedLotValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 4));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setFixedLotValue = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearFixedLotValue = function() {
  return this.setFixedLotValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasFixedLotValue = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.DoubleValue lot_multiplier_value = 5;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.SymbolSettings.prototype.getLotMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 5));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setLotMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearLotMultiplierValue = function() {
  return this.setLotMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasLotMultiplierValue = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.DoubleValue balance_multiplier_value = 6;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.SymbolSettings.prototype.getBalanceMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 6));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setBalanceMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearBalanceMultiplierValue = function() {
  return this.setBalanceMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasBalanceMultiplierValue = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.BoolValue copy_stop_loss = 7;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.SymbolSettings.prototype.getCopyStopLoss = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 7));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setCopyStopLoss = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearCopyStopLoss = function() {
  return this.setCopyStopLoss(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasCopyStopLoss = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.BoolValue copy_take_profit = 8;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.SymbolSettings.prototype.getCopyTakeProfit = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 8));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setCopyTakeProfit = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearCopyTakeProfit = function() {
  return this.setCopyTakeProfit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasCopyTakeProfit = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.BoolValue copy_pending_orders = 9;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.SymbolSettings.prototype.getCopyPendingOrders = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 9));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setCopyPendingOrders = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearCopyPendingOrders = function() {
  return this.setCopyPendingOrders(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasCopyPendingOrders = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.BoolValue force_minimum_lot_size = 10;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.SymbolSettings.prototype.getForceMinimumLotSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 10));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setForceMinimumLotSize = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearForceMinimumLotSize = function() {
  return this.setForceMinimumLotSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasForceMinimumLotSize = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.BoolValue copy_comment = 11;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.SymbolSettings.prototype.getCopyComment = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 11));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setCopyComment = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearCopyComment = function() {
  return this.setCopyComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasCopyComment = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue custom_comment = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.SymbolSettings.prototype.getCustomComment = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setCustomComment = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearCustomComment = function() {
  return this.setCustomComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasCustomComment = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.BoolValue force_maximum_lot_size = 13;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.SymbolSettings.prototype.getForceMaximumLotSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 13));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setForceMaximumLotSize = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearForceMaximumLotSize = function() {
  return this.setForceMaximumLotSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasForceMaximumLotSize = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.StringValue custom_placed_type = 14;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.SymbolSettings.prototype.getCustomPlacedType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 14));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setCustomPlacedType = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearCustomPlacedType = function() {
  return this.setCustomPlacedType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasCustomPlacedType = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.BoolValue reverse_trade = 15;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.SymbolSettings.prototype.getReverseTrade = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 15));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setReverseTrade = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearReverseTrade = function() {
  return this.setReverseTrade(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasReverseTrade = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.BoolValue strict_close = 16;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.SymbolSettings.prototype.getStrictClose = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 16));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setStrictClose = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearStrictClose = function() {
  return this.setStrictClose(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasStrictClose = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.BoolValue consider_contract_size = 17;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.SymbolSettings.prototype.getConsiderContractSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 17));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setConsiderContractSize = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearConsiderContractSize = function() {
  return this.setConsiderContractSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasConsiderContractSize = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.BoolValue copy_magic_number = 18;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.SymbolSettings.prototype.getCopyMagicNumber = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 18));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setCopyMagicNumber = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearCopyMagicNumber = function() {
  return this.setCopyMagicNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasCopyMagicNumber = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional google.protobuf.Int64Value magic_number = 19;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.SymbolSettings.prototype.getMagicNumber = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 19));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setMagicNumber = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearMagicNumber = function() {
  return this.setMagicNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasMagicNumber = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional google.protobuf.BoolValue manage_existing = 20;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.SymbolSettings.prototype.getManageExisting = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 20));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setManageExisting = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearManageExisting = function() {
  return this.setManageExisting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasManageExisting = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional google.protobuf.DoubleValue lot_refiner_value = 21;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.SymbolSettings.prototype.getLotRefinerValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 21));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setLotRefinerValue = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearLotRefinerValue = function() {
  return this.setLotRefinerValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasLotRefinerValue = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional google.protobuf.DoubleValue fixed_balance_multiplier_value = 22;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.SymbolSettings.prototype.getFixedBalanceMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 22));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setFixedBalanceMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearFixedBalanceMultiplierValue = function() {
  return this.setFixedBalanceMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasFixedBalanceMultiplierValue = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.DoubleValue fixed_master_balance = 23;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.SymbolSettings.prototype.getFixedMasterBalance = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 23));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setFixedMasterBalance = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearFixedMasterBalance = function() {
  return this.setFixedMasterBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasFixedMasterBalance = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * repeated google.protobuf.Int64Value magic_filters = 24;
 * @return {!Array<!proto.google.protobuf.Int64Value>}
 */
proto.tradecopier.SymbolSettings.prototype.getMagicFiltersList = function() {
  return /** @type{!Array<!proto.google.protobuf.Int64Value>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 24));
};


/**
 * @param {!Array<!proto.google.protobuf.Int64Value>} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setMagicFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 24, value);
};


/**
 * @param {!proto.google.protobuf.Int64Value=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Int64Value}
 */
proto.tradecopier.SymbolSettings.prototype.addMagicFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 24, opt_value, proto.google.protobuf.Int64Value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearMagicFiltersList = function() {
  return this.setMagicFiltersList([]);
};


/**
 * optional google.protobuf.Int64Value min_delay_time = 25;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.SymbolSettings.prototype.getMinDelayTime = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 25));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setMinDelayTime = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearMinDelayTime = function() {
  return this.setMinDelayTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasMinDelayTime = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional google.protobuf.BoolValue copy_expiry_time = 26;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.SymbolSettings.prototype.getCopyExpiryTime = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 26));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setCopyExpiryTime = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearCopyExpiryTime = function() {
  return this.setCopyExpiryTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasCopyExpiryTime = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * repeated google.protobuf.StringValue comment_filters = 27;
 * @return {!Array<!proto.google.protobuf.StringValue>}
 */
proto.tradecopier.SymbolSettings.prototype.getCommentFiltersList = function() {
  return /** @type{!Array<!proto.google.protobuf.StringValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_wrappers_pb.StringValue, 27));
};


/**
 * @param {!Array<!proto.google.protobuf.StringValue>} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setCommentFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 27, value);
};


/**
 * @param {!proto.google.protobuf.StringValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.StringValue}
 */
proto.tradecopier.SymbolSettings.prototype.addCommentFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 27, opt_value, proto.google.protobuf.StringValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearCommentFiltersList = function() {
  return this.setCommentFiltersList([]);
};


/**
 * optional google.protobuf.DoubleValue min_lot_filter = 28;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.SymbolSettings.prototype.getMinLotFilter = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 28));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setMinLotFilter = function(value) {
  return jspb.Message.setWrapperField(this, 28, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearMinLotFilter = function() {
  return this.setMinLotFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasMinLotFilter = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional google.protobuf.DoubleValue max_lot_filter = 29;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.SymbolSettings.prototype.getMaxLotFilter = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 29));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setMaxLotFilter = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearMaxLotFilter = function() {
  return this.setMaxLotFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasMaxLotFilter = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional google.protobuf.Int64Value max_delay_time = 30;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.SymbolSettings.prototype.getMaxDelayTime = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 30));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setMaxDelayTime = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearMaxDelayTime = function() {
  return this.setMaxDelayTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasMaxDelayTime = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional google.protobuf.DoubleValue take_profit_pip = 31;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.SymbolSettings.prototype.getTakeProfitPip = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 31));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setTakeProfitPip = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearTakeProfitPip = function() {
  return this.setTakeProfitPip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasTakeProfitPip = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional google.protobuf.DoubleValue stop_loss_pip = 32;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.SymbolSettings.prototype.getStopLossPip = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 32));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setStopLossPip = function(value) {
  return jspb.Message.setWrapperField(this, 32, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearStopLossPip = function() {
  return this.setStopLossPip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasStopLossPip = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional google.protobuf.DoubleValue sl_refiner = 33;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.SymbolSettings.prototype.getSlRefiner = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 33));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setSlRefiner = function(value) {
  return jspb.Message.setWrapperField(this, 33, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearSlRefiner = function() {
  return this.setSlRefiner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasSlRefiner = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional google.protobuf.DoubleValue tp_refiner = 34;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.SymbolSettings.prototype.getTpRefiner = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 34));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setTpRefiner = function(value) {
  return jspb.Message.setWrapperField(this, 34, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearTpRefiner = function() {
  return this.setTpRefiner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasTpRefiner = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional google.protobuf.DoubleValue balance_percentage_value = 35;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.SymbolSettings.prototype.getBalancePercentageValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 35));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setBalancePercentageValue = function(value) {
  return jspb.Message.setWrapperField(this, 35, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearBalancePercentageValue = function() {
  return this.setBalancePercentageValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasBalancePercentageValue = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional google.protobuf.StringValue allowed_trade_side = 36;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.SymbolSettings.prototype.getAllowedTradeSide = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 36));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setAllowedTradeSide = function(value) {
  return jspb.Message.setWrapperField(this, 36, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearAllowedTradeSide = function() {
  return this.setAllowedTradeSide(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasAllowedTradeSide = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional google.protobuf.StringValue magic_filter_type = 37;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.SymbolSettings.prototype.getMagicFilterType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 37));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setMagicFilterType = function(value) {
  return jspb.Message.setWrapperField(this, 37, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearMagicFilterType = function() {
  return this.setMagicFilterType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasMagicFilterType = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional google.protobuf.StringValue comment_filter_type = 38;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.SymbolSettings.prototype.getCommentFilterType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 38));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setCommentFilterType = function(value) {
  return jspb.Message.setWrapperField(this, 38, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearCommentFilterType = function() {
  return this.setCommentFilterType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasCommentFilterType = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional string symbol = 39;
 * @return {string}
 */
proto.tradecopier.SymbolSettings.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 39, value);
};


/**
 * optional string master_symbol = 40;
 * @return {string}
 */
proto.tradecopier.SymbolSettings.prototype.getMasterSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.setMasterSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional google.protobuf.Timestamp pause_until = 41;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.tradecopier.SymbolSettings.prototype.getPauseUntil = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 41));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.tradecopier.SymbolSettings} returns this
*/
proto.tradecopier.SymbolSettings.prototype.setPauseUntil = function(value) {
  return jspb.Message.setWrapperField(this, 41, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.SymbolSettings} returns this
 */
proto.tradecopier.SymbolSettings.prototype.clearPauseUntil = function() {
  return this.setPauseUntil(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.SymbolSettings.prototype.hasPauseUntil = function() {
  return jspb.Message.getField(this, 41) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.DeleteSymbolSettingsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.DeleteSymbolSettingsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.DeleteSymbolSettingsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.DeleteSymbolSettingsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 2, ""),
mappingId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.DeleteSymbolSettingsReq}
 */
proto.tradecopier.DeleteSymbolSettingsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.DeleteSymbolSettingsReq;
  return proto.tradecopier.DeleteSymbolSettingsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.DeleteSymbolSettingsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.DeleteSymbolSettingsReq}
 */
proto.tradecopier.DeleteSymbolSettingsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMappingId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.DeleteSymbolSettingsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.DeleteSymbolSettingsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.DeleteSymbolSettingsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.DeleteSymbolSettingsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMappingId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.DeleteSymbolSettingsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.DeleteSymbolSettingsReq} returns this
 */
proto.tradecopier.DeleteSymbolSettingsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slave_id = 2;
 * @return {string}
 */
proto.tradecopier.DeleteSymbolSettingsReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.DeleteSymbolSettingsReq} returns this
 */
proto.tradecopier.DeleteSymbolSettingsReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 mapping_id = 3;
 * @return {number}
 */
proto.tradecopier.DeleteSymbolSettingsReq.prototype.getMappingId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tradecopier.DeleteSymbolSettingsReq} returns this
 */
proto.tradecopier.DeleteSymbolSettingsReq.prototype.setMappingId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.DeleteSymbolSettingsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.DeleteSymbolSettingsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.DeleteSymbolSettingsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.DeleteSymbolSettingsReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.DeleteSymbolSettingsReply}
 */
proto.tradecopier.DeleteSymbolSettingsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.DeleteSymbolSettingsReply;
  return proto.tradecopier.DeleteSymbolSettingsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.DeleteSymbolSettingsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.DeleteSymbolSettingsReply}
 */
proto.tradecopier.DeleteSymbolSettingsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.DeleteSymbolSettingsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.DeleteSymbolSettingsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.DeleteSymbolSettingsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.DeleteSymbolSettingsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.PauseAccountSymbolReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.PauseAccountSymbolReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.PauseAccountSymbolReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.PauseAccountSymbolReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 2, ""),
slaveSymbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
masterSymbol: jspb.Message.getFieldWithDefault(msg, 4, ""),
pauseUntil: (f = msg.getPauseUntil()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.PauseAccountSymbolReq}
 */
proto.tradecopier.PauseAccountSymbolReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.PauseAccountSymbolReq;
  return proto.tradecopier.PauseAccountSymbolReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.PauseAccountSymbolReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.PauseAccountSymbolReq}
 */
proto.tradecopier.PauseAccountSymbolReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveSymbol(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterSymbol(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPauseUntil(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.PauseAccountSymbolReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.PauseAccountSymbolReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.PauseAccountSymbolReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.PauseAccountSymbolReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlaveSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMasterSymbol();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPauseUntil();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.PauseAccountSymbolReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.PauseAccountSymbolReq} returns this
 */
proto.tradecopier.PauseAccountSymbolReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slave_id = 2;
 * @return {string}
 */
proto.tradecopier.PauseAccountSymbolReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.PauseAccountSymbolReq} returns this
 */
proto.tradecopier.PauseAccountSymbolReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slave_symbol = 3;
 * @return {string}
 */
proto.tradecopier.PauseAccountSymbolReq.prototype.getSlaveSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.PauseAccountSymbolReq} returns this
 */
proto.tradecopier.PauseAccountSymbolReq.prototype.setSlaveSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string master_symbol = 4;
 * @return {string}
 */
proto.tradecopier.PauseAccountSymbolReq.prototype.getMasterSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.PauseAccountSymbolReq} returns this
 */
proto.tradecopier.PauseAccountSymbolReq.prototype.setMasterSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp pause_until = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.tradecopier.PauseAccountSymbolReq.prototype.getPauseUntil = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.tradecopier.PauseAccountSymbolReq} returns this
*/
proto.tradecopier.PauseAccountSymbolReq.prototype.setPauseUntil = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.PauseAccountSymbolReq} returns this
 */
proto.tradecopier.PauseAccountSymbolReq.prototype.clearPauseUntil = function() {
  return this.setPauseUntil(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.PauseAccountSymbolReq.prototype.hasPauseUntil = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.PauseAccountSymbolReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.PauseAccountSymbolReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.PauseAccountSymbolReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.PauseAccountSymbolReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.PauseAccountSymbolReply}
 */
proto.tradecopier.PauseAccountSymbolReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.PauseAccountSymbolReply;
  return proto.tradecopier.PauseAccountSymbolReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.PauseAccountSymbolReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.PauseAccountSymbolReply}
 */
proto.tradecopier.PauseAccountSymbolReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.PauseAccountSymbolReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.PauseAccountSymbolReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.PauseAccountSymbolReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.PauseAccountSymbolReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AssociatedMasterSymbolReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AssociatedMasterSymbolReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AssociatedMasterSymbolReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AssociatedMasterSymbolReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
slaveId: jspb.Message.getFieldWithDefault(msg, 2, ""),
slaveSymbol: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AssociatedMasterSymbolReq}
 */
proto.tradecopier.AssociatedMasterSymbolReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AssociatedMasterSymbolReq;
  return proto.tradecopier.AssociatedMasterSymbolReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AssociatedMasterSymbolReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AssociatedMasterSymbolReq}
 */
proto.tradecopier.AssociatedMasterSymbolReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlaveSymbol(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AssociatedMasterSymbolReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AssociatedMasterSymbolReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AssociatedMasterSymbolReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AssociatedMasterSymbolReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlaveId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSlaveSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.AssociatedMasterSymbolReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AssociatedMasterSymbolReq} returns this
 */
proto.tradecopier.AssociatedMasterSymbolReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slave_id = 2;
 * @return {string}
 */
proto.tradecopier.AssociatedMasterSymbolReq.prototype.getSlaveId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AssociatedMasterSymbolReq} returns this
 */
proto.tradecopier.AssociatedMasterSymbolReq.prototype.setSlaveId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string slave_symbol = 3;
 * @return {string}
 */
proto.tradecopier.AssociatedMasterSymbolReq.prototype.getSlaveSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AssociatedMasterSymbolReq} returns this
 */
proto.tradecopier.AssociatedMasterSymbolReq.prototype.setSlaveSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AssociatedMasterSymbolReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AssociatedMasterSymbolReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AssociatedMasterSymbolReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AssociatedMasterSymbolReply.toObject = function(includeInstance, msg) {
  var f, obj = {
masterSymbol: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AssociatedMasterSymbolReply}
 */
proto.tradecopier.AssociatedMasterSymbolReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AssociatedMasterSymbolReply;
  return proto.tradecopier.AssociatedMasterSymbolReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AssociatedMasterSymbolReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AssociatedMasterSymbolReply}
 */
proto.tradecopier.AssociatedMasterSymbolReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterSymbol(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AssociatedMasterSymbolReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AssociatedMasterSymbolReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AssociatedMasterSymbolReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AssociatedMasterSymbolReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMasterSymbol();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string master_symbol = 1;
 * @return {string}
 */
proto.tradecopier.AssociatedMasterSymbolReply.prototype.getMasterSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AssociatedMasterSymbolReply} returns this
 */
proto.tradecopier.AssociatedMasterSymbolReply.prototype.setMasterSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.AddCopierTemplateReq.repeatedFields_ = [13,14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AddCopierTemplateReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AddCopierTemplateReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AddCopierTemplateReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
riskType: jspb.Message.getFieldWithDefault(msg, 3, 0),
fixedLotValue: (f = msg.getFixedLotValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
lotMultiplierValue: (f = msg.getLotMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
balanceMultiplierValue: (f = msg.getBalanceMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
lotRefinerValue: (f = msg.getLotRefinerValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
fixedBalanceMultiplierValue: (f = msg.getFixedBalanceMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
fixedMasterBalance: (f = msg.getFixedMasterBalance()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
balancePercentageValue: (f = msg.getBalancePercentageValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
minDelayTime: (f = msg.getMinDelayTime()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
maxDelayTime: (f = msg.getMaxDelayTime()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
magicFiltersList: jspb.Message.toObjectList(msg.getMagicFiltersList(),
    google_protobuf_wrappers_pb.Int64Value.toObject, includeInstance),
commentFiltersList: jspb.Message.toObjectList(msg.getCommentFiltersList(),
    google_protobuf_wrappers_pb.StringValue.toObject, includeInstance),
minLotFilter: (f = msg.getMinLotFilter()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
maxLotFilter: (f = msg.getMaxLotFilter()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
copyStopLoss: (f = msg.getCopyStopLoss()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyTakeProfit: (f = msg.getCopyTakeProfit()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyPendingOrders: (f = msg.getCopyPendingOrders()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyComment: (f = msg.getCopyComment()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
customComment: (f = msg.getCustomComment()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
customPlacedType: (f = msg.getCustomPlacedType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
reverseTrade: (f = msg.getReverseTrade()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
strictClose: (f = msg.getStrictClose()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyMagicNumber: (f = msg.getCopyMagicNumber()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
magicNumber: (f = msg.getMagicNumber()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
copyExpiryTime: (f = msg.getCopyExpiryTime()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
forceMinimumLotSize: (f = msg.getForceMinimumLotSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
forceMaximumLotSize: (f = msg.getForceMaximumLotSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
considerContractSize: (f = msg.getConsiderContractSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
stopLossPip: (f = msg.getStopLossPip()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
takeProfitPip: (f = msg.getTakeProfitPip()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
slRefiner: (f = msg.getSlRefiner()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
tpRefiner: (f = msg.getTpRefiner()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
magicFilterType: jspb.Message.getFieldWithDefault(msg, 35, 0),
commentFilterType: jspb.Message.getFieldWithDefault(msg, 36, 0),
allowedTradeSide: (f = msg.getAllowedTradeSide()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AddCopierTemplateReq}
 */
proto.tradecopier.AddCopierTemplateReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AddCopierTemplateReq;
  return proto.tradecopier.AddCopierTemplateReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AddCopierTemplateReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AddCopierTemplateReq}
 */
proto.tradecopier.AddCopierTemplateReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {!proto.tradecopier.RISK_TYPE} */ (reader.readEnum());
      msg.setRiskType(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedLotValue(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLotMultiplierValue(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setBalanceMultiplierValue(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLotRefinerValue(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedBalanceMultiplierValue(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedMasterBalance(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setBalancePercentageValue(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMinDelayTime(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMaxDelayTime(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.addMagicFilters(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.addCommentFilters(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMinLotFilter(value);
      break;
    case 16:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMaxLotFilter(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyStopLoss(value);
      break;
    case 18:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyTakeProfit(value);
      break;
    case 19:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyPendingOrders(value);
      break;
    case 20:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyComment(value);
      break;
    case 21:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomComment(value);
      break;
    case 22:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomPlacedType(value);
      break;
    case 23:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setReverseTrade(value);
      break;
    case 24:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setStrictClose(value);
      break;
    case 25:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyMagicNumber(value);
      break;
    case 26:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMagicNumber(value);
      break;
    case 27:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyExpiryTime(value);
      break;
    case 28:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setForceMinimumLotSize(value);
      break;
    case 29:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setForceMaximumLotSize(value);
      break;
    case 30:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setConsiderContractSize(value);
      break;
    case 31:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setStopLossPip(value);
      break;
    case 32:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTakeProfitPip(value);
      break;
    case 33:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setSlRefiner(value);
      break;
    case 34:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTpRefiner(value);
      break;
    case 35:
      var value = /** @type {!proto.tradecopier.FilterType} */ (reader.readEnum());
      msg.setMagicFilterType(value);
      break;
    case 36:
      var value = /** @type {!proto.tradecopier.FilterType} */ (reader.readEnum());
      msg.setCommentFilterType(value);
      break;
    case 37:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAllowedTradeSide(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AddCopierTemplateReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AddCopierTemplateReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AddCopierTemplateReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRiskType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getFixedLotValue();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getLotMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getBalanceMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getLotRefinerValue();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getFixedBalanceMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getFixedMasterBalance();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getBalancePercentageValue();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMinDelayTime();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getMaxDelayTime();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getMagicFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getCommentFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getMinLotFilter();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxLotFilter();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyStopLoss();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyTakeProfit();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyPendingOrders();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyComment();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomComment();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomPlacedType();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getReverseTrade();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getStrictClose();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyMagicNumber();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getMagicNumber();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getCopyExpiryTime();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getForceMinimumLotSize();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getForceMaximumLotSize();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getConsiderContractSize();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getStopLossPip();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTakeProfitPip();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getSlRefiner();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTpRefiner();
  if (f != null) {
    writer.writeMessage(
      34,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMagicFilterType();
  if (f !== 0.0) {
    writer.writeEnum(
      35,
      f
    );
  }
  f = message.getCommentFilterType();
  if (f !== 0.0) {
    writer.writeEnum(
      36,
      f
    );
  }
  f = message.getAllowedTradeSide();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional RISK_TYPE risk_type = 3;
 * @return {!proto.tradecopier.RISK_TYPE}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getRiskType = function() {
  return /** @type {!proto.tradecopier.RISK_TYPE} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.tradecopier.RISK_TYPE} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.setRiskType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional google.protobuf.DoubleValue fixed_lot_value = 4;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getFixedLotValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 4));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setFixedLotValue = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearFixedLotValue = function() {
  return this.setFixedLotValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasFixedLotValue = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.DoubleValue lot_multiplier_value = 5;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getLotMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 5));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setLotMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearLotMultiplierValue = function() {
  return this.setLotMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasLotMultiplierValue = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.DoubleValue balance_multiplier_value = 6;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getBalanceMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 6));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setBalanceMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearBalanceMultiplierValue = function() {
  return this.setBalanceMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasBalanceMultiplierValue = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.DoubleValue lot_refiner_value = 7;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getLotRefinerValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 7));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setLotRefinerValue = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearLotRefinerValue = function() {
  return this.setLotRefinerValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasLotRefinerValue = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.DoubleValue fixed_balance_multiplier_value = 8;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getFixedBalanceMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 8));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setFixedBalanceMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearFixedBalanceMultiplierValue = function() {
  return this.setFixedBalanceMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasFixedBalanceMultiplierValue = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.DoubleValue fixed_master_balance = 9;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getFixedMasterBalance = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 9));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setFixedMasterBalance = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearFixedMasterBalance = function() {
  return this.setFixedMasterBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasFixedMasterBalance = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.DoubleValue balance_percentage_value = 10;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getBalancePercentageValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 10));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setBalancePercentageValue = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearBalancePercentageValue = function() {
  return this.setBalancePercentageValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasBalancePercentageValue = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Int64Value min_delay_time = 11;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getMinDelayTime = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 11));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setMinDelayTime = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearMinDelayTime = function() {
  return this.setMinDelayTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasMinDelayTime = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.Int64Value max_delay_time = 12;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getMaxDelayTime = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 12));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setMaxDelayTime = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearMaxDelayTime = function() {
  return this.setMaxDelayTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasMaxDelayTime = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * repeated google.protobuf.Int64Value magic_filters = 13;
 * @return {!Array<!proto.google.protobuf.Int64Value>}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getMagicFiltersList = function() {
  return /** @type{!Array<!proto.google.protobuf.Int64Value>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 13));
};


/**
 * @param {!Array<!proto.google.protobuf.Int64Value>} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setMagicFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.google.protobuf.Int64Value=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Int64Value}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.addMagicFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.google.protobuf.Int64Value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearMagicFiltersList = function() {
  return this.setMagicFiltersList([]);
};


/**
 * repeated google.protobuf.StringValue comment_filters = 14;
 * @return {!Array<!proto.google.protobuf.StringValue>}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getCommentFiltersList = function() {
  return /** @type{!Array<!proto.google.protobuf.StringValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_wrappers_pb.StringValue, 14));
};


/**
 * @param {!Array<!proto.google.protobuf.StringValue>} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setCommentFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.google.protobuf.StringValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.StringValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.addCommentFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.google.protobuf.StringValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearCommentFiltersList = function() {
  return this.setCommentFiltersList([]);
};


/**
 * optional google.protobuf.DoubleValue min_lot_filter = 15;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getMinLotFilter = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 15));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setMinLotFilter = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearMinLotFilter = function() {
  return this.setMinLotFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasMinLotFilter = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.DoubleValue max_lot_filter = 16;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getMaxLotFilter = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 16));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setMaxLotFilter = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearMaxLotFilter = function() {
  return this.setMaxLotFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasMaxLotFilter = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.BoolValue copy_stop_loss = 17;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getCopyStopLoss = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 17));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setCopyStopLoss = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearCopyStopLoss = function() {
  return this.setCopyStopLoss(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasCopyStopLoss = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.BoolValue copy_take_profit = 18;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getCopyTakeProfit = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 18));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setCopyTakeProfit = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearCopyTakeProfit = function() {
  return this.setCopyTakeProfit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasCopyTakeProfit = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional google.protobuf.BoolValue copy_pending_orders = 19;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getCopyPendingOrders = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 19));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setCopyPendingOrders = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearCopyPendingOrders = function() {
  return this.setCopyPendingOrders(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasCopyPendingOrders = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional google.protobuf.BoolValue copy_comment = 20;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getCopyComment = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 20));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setCopyComment = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearCopyComment = function() {
  return this.setCopyComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasCopyComment = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional google.protobuf.StringValue custom_comment = 21;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getCustomComment = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 21));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setCustomComment = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearCustomComment = function() {
  return this.setCustomComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasCustomComment = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional google.protobuf.StringValue custom_placed_type = 22;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getCustomPlacedType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 22));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setCustomPlacedType = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearCustomPlacedType = function() {
  return this.setCustomPlacedType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasCustomPlacedType = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.BoolValue reverse_trade = 23;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getReverseTrade = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 23));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setReverseTrade = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearReverseTrade = function() {
  return this.setReverseTrade(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasReverseTrade = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional google.protobuf.BoolValue strict_close = 24;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getStrictClose = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 24));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setStrictClose = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearStrictClose = function() {
  return this.setStrictClose(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasStrictClose = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional google.protobuf.BoolValue copy_magic_number = 25;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getCopyMagicNumber = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 25));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setCopyMagicNumber = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearCopyMagicNumber = function() {
  return this.setCopyMagicNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasCopyMagicNumber = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional google.protobuf.Int64Value magic_number = 26;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getMagicNumber = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 26));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setMagicNumber = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearMagicNumber = function() {
  return this.setMagicNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasMagicNumber = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional google.protobuf.BoolValue copy_expiry_time = 27;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getCopyExpiryTime = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 27));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setCopyExpiryTime = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearCopyExpiryTime = function() {
  return this.setCopyExpiryTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasCopyExpiryTime = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional google.protobuf.BoolValue force_minimum_lot_size = 28;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getForceMinimumLotSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 28));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setForceMinimumLotSize = function(value) {
  return jspb.Message.setWrapperField(this, 28, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearForceMinimumLotSize = function() {
  return this.setForceMinimumLotSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasForceMinimumLotSize = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional google.protobuf.BoolValue force_maximum_lot_size = 29;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getForceMaximumLotSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 29));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setForceMaximumLotSize = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearForceMaximumLotSize = function() {
  return this.setForceMaximumLotSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasForceMaximumLotSize = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional google.protobuf.BoolValue consider_contract_size = 30;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getConsiderContractSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 30));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setConsiderContractSize = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearConsiderContractSize = function() {
  return this.setConsiderContractSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasConsiderContractSize = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional google.protobuf.DoubleValue stop_loss_pip = 31;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getStopLossPip = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 31));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setStopLossPip = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearStopLossPip = function() {
  return this.setStopLossPip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasStopLossPip = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional google.protobuf.DoubleValue take_profit_pip = 32;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getTakeProfitPip = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 32));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setTakeProfitPip = function(value) {
  return jspb.Message.setWrapperField(this, 32, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearTakeProfitPip = function() {
  return this.setTakeProfitPip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasTakeProfitPip = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional google.protobuf.DoubleValue sl_refiner = 33;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getSlRefiner = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 33));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setSlRefiner = function(value) {
  return jspb.Message.setWrapperField(this, 33, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearSlRefiner = function() {
  return this.setSlRefiner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasSlRefiner = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional google.protobuf.DoubleValue tp_refiner = 34;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getTpRefiner = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 34));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setTpRefiner = function(value) {
  return jspb.Message.setWrapperField(this, 34, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearTpRefiner = function() {
  return this.setTpRefiner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasTpRefiner = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional FilterType magic_filter_type = 35;
 * @return {!proto.tradecopier.FilterType}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getMagicFilterType = function() {
  return /** @type {!proto.tradecopier.FilterType} */ (jspb.Message.getFieldWithDefault(this, 35, 0));
};


/**
 * @param {!proto.tradecopier.FilterType} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.setMagicFilterType = function(value) {
  return jspb.Message.setProto3EnumField(this, 35, value);
};


/**
 * optional FilterType comment_filter_type = 36;
 * @return {!proto.tradecopier.FilterType}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getCommentFilterType = function() {
  return /** @type {!proto.tradecopier.FilterType} */ (jspb.Message.getFieldWithDefault(this, 36, 0));
};


/**
 * @param {!proto.tradecopier.FilterType} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.setCommentFilterType = function(value) {
  return jspb.Message.setProto3EnumField(this, 36, value);
};


/**
 * optional google.protobuf.StringValue allowed_trade_side = 37;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.getAllowedTradeSide = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 37));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
*/
proto.tradecopier.AddCopierTemplateReq.prototype.setAllowedTradeSide = function(value) {
  return jspb.Message.setWrapperField(this, 37, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.AddCopierTemplateReq} returns this
 */
proto.tradecopier.AddCopierTemplateReq.prototype.clearAllowedTradeSide = function() {
  return this.setAllowedTradeSide(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.AddCopierTemplateReq.prototype.hasAllowedTradeSide = function() {
  return jspb.Message.getField(this, 37) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.AddCopierTemplateReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.AddCopierTemplateReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.AddCopierTemplateReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AddCopierTemplateReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.AddCopierTemplateReply}
 */
proto.tradecopier.AddCopierTemplateReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.AddCopierTemplateReply;
  return proto.tradecopier.AddCopierTemplateReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.AddCopierTemplateReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.AddCopierTemplateReply}
 */
proto.tradecopier.AddCopierTemplateReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.AddCopierTemplateReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.AddCopierTemplateReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.AddCopierTemplateReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.AddCopierTemplateReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.ListCopierTemplateReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.ListCopierTemplateReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.ListCopierTemplateReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.ListCopierTemplateReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.ListCopierTemplateReq}
 */
proto.tradecopier.ListCopierTemplateReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.ListCopierTemplateReq;
  return proto.tradecopier.ListCopierTemplateReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.ListCopierTemplateReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.ListCopierTemplateReq}
 */
proto.tradecopier.ListCopierTemplateReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.ListCopierTemplateReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.ListCopierTemplateReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.ListCopierTemplateReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.ListCopierTemplateReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.ListCopierTemplateReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.ListCopierTemplateReq} returns this
 */
proto.tradecopier.ListCopierTemplateReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.ListCopierTemplateReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.ListCopierTemplateReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.ListCopierTemplateReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.ListCopierTemplateReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.ListCopierTemplateReply.toObject = function(includeInstance, msg) {
  var f, obj = {
copierTemplatesList: jspb.Message.toObjectList(msg.getCopierTemplatesList(),
    proto.tradecopier.CopierTemplate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.ListCopierTemplateReply}
 */
proto.tradecopier.ListCopierTemplateReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.ListCopierTemplateReply;
  return proto.tradecopier.ListCopierTemplateReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.ListCopierTemplateReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.ListCopierTemplateReply}
 */
proto.tradecopier.ListCopierTemplateReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tradecopier.CopierTemplate;
      reader.readMessage(value,proto.tradecopier.CopierTemplate.deserializeBinaryFromReader);
      msg.addCopierTemplates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.ListCopierTemplateReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.ListCopierTemplateReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.ListCopierTemplateReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.ListCopierTemplateReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCopierTemplatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tradecopier.CopierTemplate.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CopierTemplate copier_templates = 1;
 * @return {!Array<!proto.tradecopier.CopierTemplate>}
 */
proto.tradecopier.ListCopierTemplateReply.prototype.getCopierTemplatesList = function() {
  return /** @type{!Array<!proto.tradecopier.CopierTemplate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tradecopier.CopierTemplate, 1));
};


/**
 * @param {!Array<!proto.tradecopier.CopierTemplate>} value
 * @return {!proto.tradecopier.ListCopierTemplateReply} returns this
*/
proto.tradecopier.ListCopierTemplateReply.prototype.setCopierTemplatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tradecopier.CopierTemplate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tradecopier.CopierTemplate}
 */
proto.tradecopier.ListCopierTemplateReply.prototype.addCopierTemplates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tradecopier.CopierTemplate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.ListCopierTemplateReply} returns this
 */
proto.tradecopier.ListCopierTemplateReply.prototype.clearCopierTemplatesList = function() {
  return this.setCopierTemplatesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.CopierTemplate.repeatedFields_ = [27,28];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.CopierTemplate.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.CopierTemplate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.CopierTemplate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.CopierTemplate.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
riskType: (f = msg.getRiskType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
fixedLotValue: (f = msg.getFixedLotValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
lotMultiplierValue: (f = msg.getLotMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
balanceMultiplierValue: (f = msg.getBalanceMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
lotRefinerValue: (f = msg.getLotRefinerValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
fixedBalanceMultiplierValue: (f = msg.getFixedBalanceMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
fixedMasterBalance: (f = msg.getFixedMasterBalance()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
balancePercentageValue: (f = msg.getBalancePercentageValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
minDelayTime: (f = msg.getMinDelayTime()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
maxDelayTime: (f = msg.getMaxDelayTime()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
copyStopLoss: (f = msg.getCopyStopLoss()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyTakeProfit: (f = msg.getCopyTakeProfit()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyPendingOrders: (f = msg.getCopyPendingOrders()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyComment: (f = msg.getCopyComment()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
customComment: (f = msg.getCustomComment()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
forceMinimumLotSize: (f = msg.getForceMinimumLotSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
forceMaximumLotSize: (f = msg.getForceMaximumLotSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
customPlacedType: (f = msg.getCustomPlacedType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
reverseTrade: (f = msg.getReverseTrade()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
strictClose: (f = msg.getStrictClose()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
considerContractSize: (f = msg.getConsiderContractSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyMagicNumber: (f = msg.getCopyMagicNumber()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
magicNumber: (f = msg.getMagicNumber()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
copyExpiryTime: (f = msg.getCopyExpiryTime()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
magicFiltersList: jspb.Message.toObjectList(msg.getMagicFiltersList(),
    google_protobuf_wrappers_pb.Int64Value.toObject, includeInstance),
commentFiltersList: jspb.Message.toObjectList(msg.getCommentFiltersList(),
    google_protobuf_wrappers_pb.StringValue.toObject, includeInstance),
minLotFilter: (f = msg.getMinLotFilter()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
maxLotFilter: (f = msg.getMaxLotFilter()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
magicFilterType: (f = msg.getMagicFilterType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
commentFilterType: (f = msg.getCommentFilterType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
stopLossPip: (f = msg.getStopLossPip()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
takeProfitPip: (f = msg.getTakeProfitPip()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
slRefiner: (f = msg.getSlRefiner()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
tpRefiner: (f = msg.getTpRefiner()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
allowedTradeSide: (f = msg.getAllowedTradeSide()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.CopierTemplate}
 */
proto.tradecopier.CopierTemplate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.CopierTemplate;
  return proto.tradecopier.CopierTemplate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.CopierTemplate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.CopierTemplate}
 */
proto.tradecopier.CopierTemplate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRiskType(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedLotValue(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLotMultiplierValue(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setBalanceMultiplierValue(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLotRefinerValue(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedBalanceMultiplierValue(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedMasterBalance(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setBalancePercentageValue(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMinDelayTime(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMaxDelayTime(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyStopLoss(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyTakeProfit(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyPendingOrders(value);
      break;
    case 16:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyComment(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomComment(value);
      break;
    case 18:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setForceMinimumLotSize(value);
      break;
    case 19:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setForceMaximumLotSize(value);
      break;
    case 20:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomPlacedType(value);
      break;
    case 21:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setReverseTrade(value);
      break;
    case 22:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setStrictClose(value);
      break;
    case 23:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setConsiderContractSize(value);
      break;
    case 24:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyMagicNumber(value);
      break;
    case 25:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMagicNumber(value);
      break;
    case 26:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyExpiryTime(value);
      break;
    case 27:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.addMagicFilters(value);
      break;
    case 28:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.addCommentFilters(value);
      break;
    case 29:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMinLotFilter(value);
      break;
    case 30:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMaxLotFilter(value);
      break;
    case 31:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setMagicFilterType(value);
      break;
    case 32:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCommentFilterType(value);
      break;
    case 33:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setStopLossPip(value);
      break;
    case 34:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTakeProfitPip(value);
      break;
    case 35:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setSlRefiner(value);
      break;
    case 36:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTpRefiner(value);
      break;
    case 37:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAllowedTradeSide(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.CopierTemplate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.CopierTemplate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.CopierTemplate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.CopierTemplate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRiskType();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getFixedLotValue();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getLotMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getBalanceMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getLotRefinerValue();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getFixedBalanceMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getFixedMasterBalance();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getBalancePercentageValue();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMinDelayTime();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getMaxDelayTime();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getCopyStopLoss();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyTakeProfit();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyPendingOrders();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyComment();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomComment();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getForceMinimumLotSize();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getForceMaximumLotSize();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomPlacedType();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getReverseTrade();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getStrictClose();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getConsiderContractSize();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyMagicNumber();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getMagicNumber();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getCopyExpiryTime();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getMagicFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      27,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getCommentFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      28,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getMinLotFilter();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxLotFilter();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMagicFilterType();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCommentFilterType();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getStopLossPip();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTakeProfitPip();
  if (f != null) {
    writer.writeMessage(
      34,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getSlRefiner();
  if (f != null) {
    writer.writeMessage(
      35,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTpRefiner();
  if (f != null) {
    writer.writeMessage(
      36,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getAllowedTradeSide();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.tradecopier.CopierTemplate.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.tradecopier.CopierTemplate.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue risk_type = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.CopierTemplate.prototype.getRiskType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setRiskType = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearRiskType = function() {
  return this.setRiskType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasRiskType = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.DoubleValue fixed_lot_value = 4;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.CopierTemplate.prototype.getFixedLotValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 4));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setFixedLotValue = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearFixedLotValue = function() {
  return this.setFixedLotValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasFixedLotValue = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.DoubleValue lot_multiplier_value = 5;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.CopierTemplate.prototype.getLotMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 5));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setLotMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearLotMultiplierValue = function() {
  return this.setLotMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasLotMultiplierValue = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.DoubleValue balance_multiplier_value = 6;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.CopierTemplate.prototype.getBalanceMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 6));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setBalanceMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearBalanceMultiplierValue = function() {
  return this.setBalanceMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasBalanceMultiplierValue = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.DoubleValue lot_refiner_value = 7;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.CopierTemplate.prototype.getLotRefinerValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 7));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setLotRefinerValue = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearLotRefinerValue = function() {
  return this.setLotRefinerValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasLotRefinerValue = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.DoubleValue fixed_balance_multiplier_value = 8;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.CopierTemplate.prototype.getFixedBalanceMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 8));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setFixedBalanceMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearFixedBalanceMultiplierValue = function() {
  return this.setFixedBalanceMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasFixedBalanceMultiplierValue = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.DoubleValue fixed_master_balance = 9;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.CopierTemplate.prototype.getFixedMasterBalance = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 9));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setFixedMasterBalance = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearFixedMasterBalance = function() {
  return this.setFixedMasterBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasFixedMasterBalance = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.DoubleValue balance_percentage_value = 10;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.CopierTemplate.prototype.getBalancePercentageValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 10));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setBalancePercentageValue = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearBalancePercentageValue = function() {
  return this.setBalancePercentageValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasBalancePercentageValue = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Int64Value min_delay_time = 11;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.CopierTemplate.prototype.getMinDelayTime = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 11));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setMinDelayTime = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearMinDelayTime = function() {
  return this.setMinDelayTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasMinDelayTime = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.Int64Value max_delay_time = 12;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.CopierTemplate.prototype.getMaxDelayTime = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 12));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setMaxDelayTime = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearMaxDelayTime = function() {
  return this.setMaxDelayTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasMaxDelayTime = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.BoolValue copy_stop_loss = 13;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.CopierTemplate.prototype.getCopyStopLoss = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 13));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setCopyStopLoss = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearCopyStopLoss = function() {
  return this.setCopyStopLoss(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasCopyStopLoss = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.BoolValue copy_take_profit = 14;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.CopierTemplate.prototype.getCopyTakeProfit = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 14));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setCopyTakeProfit = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearCopyTakeProfit = function() {
  return this.setCopyTakeProfit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasCopyTakeProfit = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.BoolValue copy_pending_orders = 15;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.CopierTemplate.prototype.getCopyPendingOrders = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 15));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setCopyPendingOrders = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearCopyPendingOrders = function() {
  return this.setCopyPendingOrders(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasCopyPendingOrders = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.BoolValue copy_comment = 16;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.CopierTemplate.prototype.getCopyComment = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 16));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setCopyComment = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearCopyComment = function() {
  return this.setCopyComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasCopyComment = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.StringValue custom_comment = 17;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.CopierTemplate.prototype.getCustomComment = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 17));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setCustomComment = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearCustomComment = function() {
  return this.setCustomComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasCustomComment = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.BoolValue force_minimum_lot_size = 18;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.CopierTemplate.prototype.getForceMinimumLotSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 18));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setForceMinimumLotSize = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearForceMinimumLotSize = function() {
  return this.setForceMinimumLotSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasForceMinimumLotSize = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional google.protobuf.BoolValue force_maximum_lot_size = 19;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.CopierTemplate.prototype.getForceMaximumLotSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 19));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setForceMaximumLotSize = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearForceMaximumLotSize = function() {
  return this.setForceMaximumLotSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasForceMaximumLotSize = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional google.protobuf.StringValue custom_placed_type = 20;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.CopierTemplate.prototype.getCustomPlacedType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 20));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setCustomPlacedType = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearCustomPlacedType = function() {
  return this.setCustomPlacedType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasCustomPlacedType = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional google.protobuf.BoolValue reverse_trade = 21;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.CopierTemplate.prototype.getReverseTrade = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 21));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setReverseTrade = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearReverseTrade = function() {
  return this.setReverseTrade(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasReverseTrade = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional google.protobuf.BoolValue strict_close = 22;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.CopierTemplate.prototype.getStrictClose = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 22));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setStrictClose = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearStrictClose = function() {
  return this.setStrictClose(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasStrictClose = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.BoolValue consider_contract_size = 23;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.CopierTemplate.prototype.getConsiderContractSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 23));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setConsiderContractSize = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearConsiderContractSize = function() {
  return this.setConsiderContractSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasConsiderContractSize = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional google.protobuf.BoolValue copy_magic_number = 24;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.CopierTemplate.prototype.getCopyMagicNumber = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 24));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setCopyMagicNumber = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearCopyMagicNumber = function() {
  return this.setCopyMagicNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasCopyMagicNumber = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional google.protobuf.Int64Value magic_number = 25;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.CopierTemplate.prototype.getMagicNumber = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 25));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setMagicNumber = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearMagicNumber = function() {
  return this.setMagicNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasMagicNumber = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional google.protobuf.BoolValue copy_expiry_time = 26;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.CopierTemplate.prototype.getCopyExpiryTime = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 26));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setCopyExpiryTime = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearCopyExpiryTime = function() {
  return this.setCopyExpiryTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasCopyExpiryTime = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * repeated google.protobuf.Int64Value magic_filters = 27;
 * @return {!Array<!proto.google.protobuf.Int64Value>}
 */
proto.tradecopier.CopierTemplate.prototype.getMagicFiltersList = function() {
  return /** @type{!Array<!proto.google.protobuf.Int64Value>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 27));
};


/**
 * @param {!Array<!proto.google.protobuf.Int64Value>} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setMagicFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 27, value);
};


/**
 * @param {!proto.google.protobuf.Int64Value=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Int64Value}
 */
proto.tradecopier.CopierTemplate.prototype.addMagicFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 27, opt_value, proto.google.protobuf.Int64Value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearMagicFiltersList = function() {
  return this.setMagicFiltersList([]);
};


/**
 * repeated google.protobuf.StringValue comment_filters = 28;
 * @return {!Array<!proto.google.protobuf.StringValue>}
 */
proto.tradecopier.CopierTemplate.prototype.getCommentFiltersList = function() {
  return /** @type{!Array<!proto.google.protobuf.StringValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_wrappers_pb.StringValue, 28));
};


/**
 * @param {!Array<!proto.google.protobuf.StringValue>} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setCommentFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 28, value);
};


/**
 * @param {!proto.google.protobuf.StringValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.StringValue}
 */
proto.tradecopier.CopierTemplate.prototype.addCommentFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 28, opt_value, proto.google.protobuf.StringValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearCommentFiltersList = function() {
  return this.setCommentFiltersList([]);
};


/**
 * optional google.protobuf.DoubleValue min_lot_filter = 29;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.CopierTemplate.prototype.getMinLotFilter = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 29));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setMinLotFilter = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearMinLotFilter = function() {
  return this.setMinLotFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasMinLotFilter = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional google.protobuf.DoubleValue max_lot_filter = 30;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.CopierTemplate.prototype.getMaxLotFilter = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 30));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setMaxLotFilter = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearMaxLotFilter = function() {
  return this.setMaxLotFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasMaxLotFilter = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional google.protobuf.StringValue magic_filter_type = 31;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.CopierTemplate.prototype.getMagicFilterType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 31));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setMagicFilterType = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearMagicFilterType = function() {
  return this.setMagicFilterType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasMagicFilterType = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional google.protobuf.StringValue comment_filter_type = 32;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.CopierTemplate.prototype.getCommentFilterType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 32));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setCommentFilterType = function(value) {
  return jspb.Message.setWrapperField(this, 32, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearCommentFilterType = function() {
  return this.setCommentFilterType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasCommentFilterType = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional google.protobuf.DoubleValue stop_loss_pip = 33;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.CopierTemplate.prototype.getStopLossPip = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 33));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setStopLossPip = function(value) {
  return jspb.Message.setWrapperField(this, 33, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearStopLossPip = function() {
  return this.setStopLossPip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasStopLossPip = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional google.protobuf.DoubleValue take_profit_pip = 34;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.CopierTemplate.prototype.getTakeProfitPip = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 34));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setTakeProfitPip = function(value) {
  return jspb.Message.setWrapperField(this, 34, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearTakeProfitPip = function() {
  return this.setTakeProfitPip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasTakeProfitPip = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional google.protobuf.DoubleValue sl_refiner = 35;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.CopierTemplate.prototype.getSlRefiner = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 35));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setSlRefiner = function(value) {
  return jspb.Message.setWrapperField(this, 35, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearSlRefiner = function() {
  return this.setSlRefiner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasSlRefiner = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional google.protobuf.DoubleValue tp_refiner = 36;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.CopierTemplate.prototype.getTpRefiner = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 36));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setTpRefiner = function(value) {
  return jspb.Message.setWrapperField(this, 36, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearTpRefiner = function() {
  return this.setTpRefiner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasTpRefiner = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional google.protobuf.StringValue allowed_trade_side = 37;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.CopierTemplate.prototype.getAllowedTradeSide = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 37));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.CopierTemplate} returns this
*/
proto.tradecopier.CopierTemplate.prototype.setAllowedTradeSide = function(value) {
  return jspb.Message.setWrapperField(this, 37, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.CopierTemplate} returns this
 */
proto.tradecopier.CopierTemplate.prototype.clearAllowedTradeSide = function() {
  return this.setAllowedTradeSide(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.CopierTemplate.prototype.hasAllowedTradeSide = function() {
  return jspb.Message.getField(this, 37) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tradecopier.UpdateCopierTemplateReq.repeatedFields_ = [13,14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.UpdateCopierTemplateReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.UpdateCopierTemplateReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdateCopierTemplateReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
riskType: jspb.Message.getFieldWithDefault(msg, 3, 0),
fixedLotValue: (f = msg.getFixedLotValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
lotMultiplierValue: (f = msg.getLotMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
balanceMultiplierValue: (f = msg.getBalanceMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
lotRefinerValue: (f = msg.getLotRefinerValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
fixedBalanceMultiplierValue: (f = msg.getFixedBalanceMultiplierValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
fixedMasterBalance: (f = msg.getFixedMasterBalance()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
balancePercentageValue: (f = msg.getBalancePercentageValue()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
minDelayTime: (f = msg.getMinDelayTime()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
maxDelayTime: (f = msg.getMaxDelayTime()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
magicFiltersList: jspb.Message.toObjectList(msg.getMagicFiltersList(),
    google_protobuf_wrappers_pb.Int64Value.toObject, includeInstance),
commentFiltersList: jspb.Message.toObjectList(msg.getCommentFiltersList(),
    google_protobuf_wrappers_pb.StringValue.toObject, includeInstance),
minLotFilter: (f = msg.getMinLotFilter()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
maxLotFilter: (f = msg.getMaxLotFilter()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
copyStopLoss: (f = msg.getCopyStopLoss()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyTakeProfit: (f = msg.getCopyTakeProfit()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyPendingOrders: (f = msg.getCopyPendingOrders()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyComment: (f = msg.getCopyComment()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
customComment: (f = msg.getCustomComment()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
customPlacedType: (f = msg.getCustomPlacedType()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
reverseTrade: (f = msg.getReverseTrade()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
strictClose: (f = msg.getStrictClose()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
copyMagicNumber: (f = msg.getCopyMagicNumber()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
magicNumber: (f = msg.getMagicNumber()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
copyExpiryTime: (f = msg.getCopyExpiryTime()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
forceMinimumLotSize: (f = msg.getForceMinimumLotSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
forceMaximumLotSize: (f = msg.getForceMaximumLotSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
considerContractSize: (f = msg.getConsiderContractSize()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
stopLossPip: (f = msg.getStopLossPip()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
takeProfitPip: (f = msg.getTakeProfitPip()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
slRefiner: (f = msg.getSlRefiner()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
tpRefiner: (f = msg.getTpRefiner()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
magicFilterType: jspb.Message.getFieldWithDefault(msg, 35, 0),
commentFilterType: jspb.Message.getFieldWithDefault(msg, 36, 0),
allowedTradeSide: (f = msg.getAllowedTradeSide()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
id: jspb.Message.getFieldWithDefault(msg, 38, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq}
 */
proto.tradecopier.UpdateCopierTemplateReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.UpdateCopierTemplateReq;
  return proto.tradecopier.UpdateCopierTemplateReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.UpdateCopierTemplateReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq}
 */
proto.tradecopier.UpdateCopierTemplateReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {!proto.tradecopier.RISK_TYPE} */ (reader.readEnum());
      msg.setRiskType(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedLotValue(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLotMultiplierValue(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setBalanceMultiplierValue(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLotRefinerValue(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedBalanceMultiplierValue(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setFixedMasterBalance(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setBalancePercentageValue(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMinDelayTime(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMaxDelayTime(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.addMagicFilters(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.addCommentFilters(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMinLotFilter(value);
      break;
    case 16:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setMaxLotFilter(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyStopLoss(value);
      break;
    case 18:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyTakeProfit(value);
      break;
    case 19:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyPendingOrders(value);
      break;
    case 20:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyComment(value);
      break;
    case 21:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomComment(value);
      break;
    case 22:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomPlacedType(value);
      break;
    case 23:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setReverseTrade(value);
      break;
    case 24:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setStrictClose(value);
      break;
    case 25:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyMagicNumber(value);
      break;
    case 26:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMagicNumber(value);
      break;
    case 27:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setCopyExpiryTime(value);
      break;
    case 28:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setForceMinimumLotSize(value);
      break;
    case 29:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setForceMaximumLotSize(value);
      break;
    case 30:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setConsiderContractSize(value);
      break;
    case 31:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setStopLossPip(value);
      break;
    case 32:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTakeProfitPip(value);
      break;
    case 33:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setSlRefiner(value);
      break;
    case 34:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setTpRefiner(value);
      break;
    case 35:
      var value = /** @type {!proto.tradecopier.FilterType} */ (reader.readEnum());
      msg.setMagicFilterType(value);
      break;
    case 36:
      var value = /** @type {!proto.tradecopier.FilterType} */ (reader.readEnum());
      msg.setCommentFilterType(value);
      break;
    case 37:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAllowedTradeSide(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.UpdateCopierTemplateReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.UpdateCopierTemplateReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdateCopierTemplateReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRiskType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getFixedLotValue();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getLotMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getBalanceMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getLotRefinerValue();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getFixedBalanceMultiplierValue();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getFixedMasterBalance();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getBalancePercentageValue();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMinDelayTime();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getMaxDelayTime();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getMagicFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getCommentFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getMinLotFilter();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxLotFilter();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyStopLoss();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyTakeProfit();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyPendingOrders();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyComment();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomComment();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomPlacedType();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getReverseTrade();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getStrictClose();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCopyMagicNumber();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getMagicNumber();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getCopyExpiryTime();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getForceMinimumLotSize();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getForceMaximumLotSize();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getConsiderContractSize();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getStopLossPip();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTakeProfitPip();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getSlRefiner();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getTpRefiner();
  if (f != null) {
    writer.writeMessage(
      34,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getMagicFilterType();
  if (f !== 0.0) {
    writer.writeEnum(
      35,
      f
    );
  }
  f = message.getCommentFilterType();
  if (f !== 0.0) {
    writer.writeEnum(
      36,
      f
    );
  }
  f = message.getAllowedTradeSide();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional RISK_TYPE risk_type = 3;
 * @return {!proto.tradecopier.RISK_TYPE}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getRiskType = function() {
  return /** @type {!proto.tradecopier.RISK_TYPE} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.tradecopier.RISK_TYPE} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.setRiskType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional google.protobuf.DoubleValue fixed_lot_value = 4;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getFixedLotValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 4));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setFixedLotValue = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearFixedLotValue = function() {
  return this.setFixedLotValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasFixedLotValue = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.DoubleValue lot_multiplier_value = 5;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getLotMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 5));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setLotMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearLotMultiplierValue = function() {
  return this.setLotMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasLotMultiplierValue = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.DoubleValue balance_multiplier_value = 6;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getBalanceMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 6));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setBalanceMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearBalanceMultiplierValue = function() {
  return this.setBalanceMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasBalanceMultiplierValue = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.DoubleValue lot_refiner_value = 7;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getLotRefinerValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 7));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setLotRefinerValue = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearLotRefinerValue = function() {
  return this.setLotRefinerValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasLotRefinerValue = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.DoubleValue fixed_balance_multiplier_value = 8;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getFixedBalanceMultiplierValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 8));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setFixedBalanceMultiplierValue = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearFixedBalanceMultiplierValue = function() {
  return this.setFixedBalanceMultiplierValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasFixedBalanceMultiplierValue = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.DoubleValue fixed_master_balance = 9;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getFixedMasterBalance = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 9));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setFixedMasterBalance = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearFixedMasterBalance = function() {
  return this.setFixedMasterBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasFixedMasterBalance = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.DoubleValue balance_percentage_value = 10;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getBalancePercentageValue = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 10));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setBalancePercentageValue = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearBalancePercentageValue = function() {
  return this.setBalancePercentageValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasBalancePercentageValue = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Int64Value min_delay_time = 11;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getMinDelayTime = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 11));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setMinDelayTime = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearMinDelayTime = function() {
  return this.setMinDelayTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasMinDelayTime = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.Int64Value max_delay_time = 12;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getMaxDelayTime = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 12));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setMaxDelayTime = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearMaxDelayTime = function() {
  return this.setMaxDelayTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasMaxDelayTime = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * repeated google.protobuf.Int64Value magic_filters = 13;
 * @return {!Array<!proto.google.protobuf.Int64Value>}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getMagicFiltersList = function() {
  return /** @type{!Array<!proto.google.protobuf.Int64Value>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 13));
};


/**
 * @param {!Array<!proto.google.protobuf.Int64Value>} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setMagicFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.google.protobuf.Int64Value=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Int64Value}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.addMagicFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.google.protobuf.Int64Value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearMagicFiltersList = function() {
  return this.setMagicFiltersList([]);
};


/**
 * repeated google.protobuf.StringValue comment_filters = 14;
 * @return {!Array<!proto.google.protobuf.StringValue>}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getCommentFiltersList = function() {
  return /** @type{!Array<!proto.google.protobuf.StringValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_wrappers_pb.StringValue, 14));
};


/**
 * @param {!Array<!proto.google.protobuf.StringValue>} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setCommentFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.google.protobuf.StringValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.StringValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.addCommentFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.google.protobuf.StringValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearCommentFiltersList = function() {
  return this.setCommentFiltersList([]);
};


/**
 * optional google.protobuf.DoubleValue min_lot_filter = 15;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getMinLotFilter = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 15));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setMinLotFilter = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearMinLotFilter = function() {
  return this.setMinLotFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasMinLotFilter = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.DoubleValue max_lot_filter = 16;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getMaxLotFilter = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 16));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setMaxLotFilter = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearMaxLotFilter = function() {
  return this.setMaxLotFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasMaxLotFilter = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.BoolValue copy_stop_loss = 17;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getCopyStopLoss = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 17));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setCopyStopLoss = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearCopyStopLoss = function() {
  return this.setCopyStopLoss(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasCopyStopLoss = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.BoolValue copy_take_profit = 18;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getCopyTakeProfit = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 18));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setCopyTakeProfit = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearCopyTakeProfit = function() {
  return this.setCopyTakeProfit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasCopyTakeProfit = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional google.protobuf.BoolValue copy_pending_orders = 19;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getCopyPendingOrders = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 19));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setCopyPendingOrders = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearCopyPendingOrders = function() {
  return this.setCopyPendingOrders(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasCopyPendingOrders = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional google.protobuf.BoolValue copy_comment = 20;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getCopyComment = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 20));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setCopyComment = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearCopyComment = function() {
  return this.setCopyComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasCopyComment = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional google.protobuf.StringValue custom_comment = 21;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getCustomComment = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 21));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setCustomComment = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearCustomComment = function() {
  return this.setCustomComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasCustomComment = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional google.protobuf.StringValue custom_placed_type = 22;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getCustomPlacedType = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 22));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setCustomPlacedType = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearCustomPlacedType = function() {
  return this.setCustomPlacedType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasCustomPlacedType = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.BoolValue reverse_trade = 23;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getReverseTrade = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 23));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setReverseTrade = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearReverseTrade = function() {
  return this.setReverseTrade(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasReverseTrade = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional google.protobuf.BoolValue strict_close = 24;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getStrictClose = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 24));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setStrictClose = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearStrictClose = function() {
  return this.setStrictClose(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasStrictClose = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional google.protobuf.BoolValue copy_magic_number = 25;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getCopyMagicNumber = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 25));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setCopyMagicNumber = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearCopyMagicNumber = function() {
  return this.setCopyMagicNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasCopyMagicNumber = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional google.protobuf.Int64Value magic_number = 26;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getMagicNumber = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 26));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setMagicNumber = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearMagicNumber = function() {
  return this.setMagicNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasMagicNumber = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional google.protobuf.BoolValue copy_expiry_time = 27;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getCopyExpiryTime = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 27));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setCopyExpiryTime = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearCopyExpiryTime = function() {
  return this.setCopyExpiryTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasCopyExpiryTime = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional google.protobuf.BoolValue force_minimum_lot_size = 28;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getForceMinimumLotSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 28));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setForceMinimumLotSize = function(value) {
  return jspb.Message.setWrapperField(this, 28, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearForceMinimumLotSize = function() {
  return this.setForceMinimumLotSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasForceMinimumLotSize = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional google.protobuf.BoolValue force_maximum_lot_size = 29;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getForceMaximumLotSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 29));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setForceMaximumLotSize = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearForceMaximumLotSize = function() {
  return this.setForceMaximumLotSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasForceMaximumLotSize = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional google.protobuf.BoolValue consider_contract_size = 30;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getConsiderContractSize = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 30));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setConsiderContractSize = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearConsiderContractSize = function() {
  return this.setConsiderContractSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasConsiderContractSize = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional google.protobuf.DoubleValue stop_loss_pip = 31;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getStopLossPip = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 31));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setStopLossPip = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearStopLossPip = function() {
  return this.setStopLossPip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasStopLossPip = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional google.protobuf.DoubleValue take_profit_pip = 32;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getTakeProfitPip = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 32));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setTakeProfitPip = function(value) {
  return jspb.Message.setWrapperField(this, 32, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearTakeProfitPip = function() {
  return this.setTakeProfitPip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasTakeProfitPip = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional google.protobuf.DoubleValue sl_refiner = 33;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getSlRefiner = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 33));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setSlRefiner = function(value) {
  return jspb.Message.setWrapperField(this, 33, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearSlRefiner = function() {
  return this.setSlRefiner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasSlRefiner = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional google.protobuf.DoubleValue tp_refiner = 34;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getTpRefiner = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 34));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setTpRefiner = function(value) {
  return jspb.Message.setWrapperField(this, 34, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearTpRefiner = function() {
  return this.setTpRefiner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasTpRefiner = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional FilterType magic_filter_type = 35;
 * @return {!proto.tradecopier.FilterType}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getMagicFilterType = function() {
  return /** @type {!proto.tradecopier.FilterType} */ (jspb.Message.getFieldWithDefault(this, 35, 0));
};


/**
 * @param {!proto.tradecopier.FilterType} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.setMagicFilterType = function(value) {
  return jspb.Message.setProto3EnumField(this, 35, value);
};


/**
 * optional FilterType comment_filter_type = 36;
 * @return {!proto.tradecopier.FilterType}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getCommentFilterType = function() {
  return /** @type {!proto.tradecopier.FilterType} */ (jspb.Message.getFieldWithDefault(this, 36, 0));
};


/**
 * @param {!proto.tradecopier.FilterType} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.setCommentFilterType = function(value) {
  return jspb.Message.setProto3EnumField(this, 36, value);
};


/**
 * optional google.protobuf.StringValue allowed_trade_side = 37;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getAllowedTradeSide = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 37));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
*/
proto.tradecopier.UpdateCopierTemplateReq.prototype.setAllowedTradeSide = function(value) {
  return jspb.Message.setWrapperField(this, 37, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.clearAllowedTradeSide = function() {
  return this.setAllowedTradeSide(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.hasAllowedTradeSide = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional string id = 38;
 * @return {string}
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.UpdateCopierTemplateReq} returns this
 */
proto.tradecopier.UpdateCopierTemplateReq.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.UpdateCopierTemplateReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.UpdateCopierTemplateReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.UpdateCopierTemplateReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdateCopierTemplateReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.UpdateCopierTemplateReply}
 */
proto.tradecopier.UpdateCopierTemplateReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.UpdateCopierTemplateReply;
  return proto.tradecopier.UpdateCopierTemplateReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.UpdateCopierTemplateReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.UpdateCopierTemplateReply}
 */
proto.tradecopier.UpdateCopierTemplateReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.UpdateCopierTemplateReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.UpdateCopierTemplateReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.UpdateCopierTemplateReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.UpdateCopierTemplateReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.DeleteCopierTemplateReq.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.DeleteCopierTemplateReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.DeleteCopierTemplateReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.DeleteCopierTemplateReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.DeleteCopierTemplateReq}
 */
proto.tradecopier.DeleteCopierTemplateReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.DeleteCopierTemplateReq;
  return proto.tradecopier.DeleteCopierTemplateReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.DeleteCopierTemplateReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.DeleteCopierTemplateReq}
 */
proto.tradecopier.DeleteCopierTemplateReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.DeleteCopierTemplateReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.DeleteCopierTemplateReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.DeleteCopierTemplateReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.DeleteCopierTemplateReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.tradecopier.DeleteCopierTemplateReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.DeleteCopierTemplateReq} returns this
 */
proto.tradecopier.DeleteCopierTemplateReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.tradecopier.DeleteCopierTemplateReq.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tradecopier.DeleteCopierTemplateReq} returns this
 */
proto.tradecopier.DeleteCopierTemplateReq.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tradecopier.DeleteCopierTemplateReply.prototype.toObject = function(opt_includeInstance) {
  return proto.tradecopier.DeleteCopierTemplateReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tradecopier.DeleteCopierTemplateReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.DeleteCopierTemplateReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tradecopier.DeleteCopierTemplateReply}
 */
proto.tradecopier.DeleteCopierTemplateReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tradecopier.DeleteCopierTemplateReply;
  return proto.tradecopier.DeleteCopierTemplateReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tradecopier.DeleteCopierTemplateReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tradecopier.DeleteCopierTemplateReply}
 */
proto.tradecopier.DeleteCopierTemplateReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tradecopier.DeleteCopierTemplateReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tradecopier.DeleteCopierTemplateReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tradecopier.DeleteCopierTemplateReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tradecopier.DeleteCopierTemplateReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.tradecopier.RISK_TYPE = {
  UNKNOWN: 0,
  FIXED_LOT: 1,
  LOT_MULTIPLIER: 2,
  BALANCE_MULTIPLIER: 3,
  FIXED_BALANCE_MULTIPLIER: 4,
  BALANCE_PERCENTAGE: 5
};

/**
 * @enum {number}
 */
proto.tradecopier.DayOfWeek = {
  MONDAY: 0,
  TUESDAY: 1,
  WEDNESDAY: 2,
  THURSDAY: 3,
  FRIDAY: 4,
  SATURDAY: 5,
  SUNDAY: 6
};

/**
 * @enum {number}
 */
proto.tradecopier.FilterType = {
  FILTER_TYPE_UNKNOWN: 0,
  COPY: 1,
  IGNORE: 2
};

goog.object.extend(exports, proto.tradecopier);
